(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var DealContentLoader, sendExperimentTrackyMessage;

window.Backbone = require('backbone');

window.Backbone.$ = window.$;

DealContentLoader = require('../../../../modules/deal/frontend/deal_content_loader');

DealContentLoader.init(false);

require('../../../../modules/tracking/frontend/initializer');

require('../../../../modules/buy_button/desktop_2016/frontend/buy_button');

require('../../../../modules/buy_button/desktop_2016/frontend/multi_option_modal');

require('../../../../modules/deal/frontend/channel_tabs');

require('../../../../modules/deal/frontend/controller');

require('../../../../modules/deal/frontend/external_links');

require('../../../../modules/gift_button/frontend/gift');

require('../../../../modules/g_map/frontend/main');

require('../../../../modules/external_deal/frontend/external_deal');

require('../../../../modules/sharing/frontend/facebook');

require('../../../../modules/deal/frontend/deal_lazy_loader');

require('../../../../modules/deal/frontend/deal_track_content_loaded');

require('../../../../modules/variations/frontend/variations-widget');

require('../../../../modules/doubleclick/frontend/dfp_ads');

require('../../../../modules/deal_widget/frontend/deal_widgets');

require('../../../../modules/deal_highlights/frontend/deal_highlights');

require('../../../../modules/ad_unit/frontend/ad_unit_lazy_loader');

require('../../../../modules/wishlist_button/frontend/wishlist');

require('../../../../modules/applepay/desktop2016/frontend/main');

require('../../../../modules/member_only/frontend/main');

require('../vendor_modules/fix-a11y');

require('groupon-iframe-login');

require('hogan.js');

require('../../../../modules/groupon-deal-carousel/frontend/swfobject-2.2');

require('../../../../modules/groupon-deal-carousel/frontend/detect-flash');

require('../../../../modules/groupon-deal-carousel/frontend/templates/main');

require('../../../../modules/groupon-deal-carousel/frontend/helpers');

require('../../../../modules/groupon-deal-carousel/frontend/models/media');

require('../../../../modules/groupon-deal-carousel/frontend/views/carousel');

require('../../../../modules/groupon-deal-carousel/frontend/carousel');

sendExperimentTrackyMessage = require('../../../../modules/experiments/frontend/sendExperimentTrackyMessage');

DealContentLoader.addOnLoadHandler(function() {
  var Groupon, ref, ref1, ref2;
  Groupon = window.Groupon;
  Groupon.Performance.pageReady();
  if ((ref = Groupon.DFPAds) != null) {
    if (typeof ref.load === "function") {
      ref.load();
    }
  }
  if ((ref1 = Groupon.DFPAds) != null) {
    if (typeof ref1.showAds === "function") {
      ref1.showAds();
    }
  }
  if ((ref2 = window.AdUnitLazyLoader) != null) {
    ref2.load();
  }
  return sendExperimentTrackyMessage();
});



},{"../../../../modules/ad_unit/frontend/ad_unit_lazy_loader":5,"../../../../modules/applepay/desktop2016/frontend/main":6,"../../../../modules/buy_button/desktop_2016/frontend/buy_button":9,"../../../../modules/buy_button/desktop_2016/frontend/multi_option_modal":10,"../../../../modules/deal/frontend/channel_tabs":16,"../../../../modules/deal/frontend/controller":17,"../../../../modules/deal/frontend/deal_content_loader":18,"../../../../modules/deal/frontend/deal_lazy_loader":19,"../../../../modules/deal/frontend/deal_track_content_loaded":20,"../../../../modules/deal/frontend/external_links":22,"../../../../modules/deal_highlights/frontend/deal_highlights":23,"../../../../modules/deal_widget/frontend/deal_widgets":24,"../../../../modules/doubleclick/frontend/dfp_ads":30,"../../../../modules/experiments/frontend/sendExperimentTrackyMessage":31,"../../../../modules/external_deal/frontend/external_deal":32,"../../../../modules/g_map/frontend/main":38,"../../../../modules/gift_button/frontend/gift":43,"../../../../modules/groupon-deal-carousel/frontend/carousel":48,"../../../../modules/groupon-deal-carousel/frontend/detect-flash":49,"../../../../modules/groupon-deal-carousel/frontend/helpers":50,"../../../../modules/groupon-deal-carousel/frontend/models/media":51,"../../../../modules/groupon-deal-carousel/frontend/swfobject-2.2":52,"../../../../modules/groupon-deal-carousel/frontend/templates/main":53,"../../../../modules/groupon-deal-carousel/frontend/views/carousel":54,"../../../../modules/member_only/frontend/main":68,"../../../../modules/sharing/frontend/facebook":91,"../../../../modules/tracking/frontend/initializer":95,"../../../../modules/variations/frontend/variations-widget":99,"../../../../modules/wishlist_button/frontend/wishlist":103,"../vendor_modules/fix-a11y":3,"backbone":104,"groupon-iframe-login":121,"hogan.js":133}],2:[function(require,module,exports){
require('./desktop_2016_base');

require('../../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster');

require('../../../../modules/delivery_estimates/frontend/delivery_estimates');

require('../../../../modules/shipping/frontend/free_shipping');

require('../../../../modules/product_reviews/frontend/product_reviews');

require('../../../../modules/inline_variations/frontend/inline_variations');

require('../../../../modules/static_pages/frontend');

require('../../../../modules/goods_warranty/frontend');

require('../../../../node_modules/grpn-card-ui/lib/frontend');

require('../../../../modules/live_chat/frontend/live_chat');

require('../../../../modules/buy_more/frontend/main');



},{"../../../../modules/buy_more/frontend/main":12,"../../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster":15,"../../../../modules/delivery_estimates/frontend/delivery_estimates":25,"../../../../modules/goods_warranty/frontend":46,"../../../../modules/inline_variations/frontend/inline_variations":61,"../../../../modules/live_chat/frontend/live_chat":67,"../../../../modules/product_reviews/frontend/product_reviews":74,"../../../../modules/shipping/frontend/free_shipping":92,"../../../../modules/static_pages/frontend":94,"../../../../node_modules/grpn-card-ui/lib/frontend":128,"./desktop_2016_base":1}],3:[function(require,module,exports){
var A11yToolInitializer, FixA11y;

A11yToolInitializer = require('grpn-fix-a11y/lib/initializer');

FixA11y = window.FixA11y != null ? window.FixA11y : window.FixA11y = {};

FixA11y.init = function(payload, done) {
  var fixA11y;
  fixA11y = payload.fixA11y;
  if (fixA11y == null) {
    return done();
  }
  A11yToolInitializer(fixA11y);
  return done();
};

module.exports = FixA11y;



},{"grpn-fix-a11y/lib/initializer":131}],4:[function(require,module,exports){
(function (global){
'use strict';
var FLOAT_PRECISION_RECIPROCAL, map, normalizePercentages, reduce, ref, sortBy;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), map = ref.map, reduce = ref.reduce, sortBy = ref.sortBy;

FLOAT_PRECISION_RECIPROCAL = 1e7;

Math.sign = Math.sign || function(x) {
  x = +x;
  if (x === 0 || isNaN(x)) {
    return x;
  }
  if (x > 0) {
    return 1;
  } else {
    return -1;
  }
};

normalizePercentages = function(arr, sum) {
  var differenceFrom100, flooredPercentValue, i, increment, index, len, num, percentValue, rawPercentages, sumFloored;
  if (sum === 0) {
    throw new RangeError("sum must not be zero!");
  }
  if (!(arr != null ? arr.length : void 0)) {
    return arr;
  }
  rawPercentages = [];
  sumFloored = 0;
  if (sum == null) {
    sum = reduce(arr, (function(acc, el) {
      return acc + el;
    }), 0);
  }
  for (index = i = 0, len = arr.length; i < len; index = ++i) {
    num = arr[index];
    percentValue = num / sum * 100;
    flooredPercentValue = Math.floor(percentValue);
    sumFloored += flooredPercentValue;
    rawPercentages.push([index, percentValue]);
  }
  differenceFrom100 = 100 - sumFloored;
  increment = Math.sign(differenceFrom100);
  if (differenceFrom100 !== 0) {
    rawPercentages = sortBy(rawPercentages, function(pair) {
      return -increment * Math.round((pair[1] % 1) * FLOAT_PRECISION_RECIPROCAL) / FLOAT_PRECISION_RECIPROCAL;
    });
    index = 0;
    while (Math.abs(differenceFrom100) > 0) {
      rawPercentages[index++ % rawPercentages.length][1] += increment;
      differenceFrom100 -= increment;
    }
  }
  return map(sortBy(rawPercentages, function(pair) {
    return pair[0];
  }), function(pair) {
    return Math.floor(pair[1]);
  });
};

module.exports = {
  normalizePercentages: normalizePercentages
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],5:[function(require,module,exports){
var AdUnitLazyLoader;

AdUnitLazyLoader = window.AdUnitLazyLoader = {
  load: function() {
    return $('.ad-widget iframe').attr('src', function() {
      return $(this).attr('data-src');
    });
  }
};

module.exports = AdUnitLazyLoader;



},{}],6:[function(require,module,exports){
var ApplePay, ApplePayUI, getApplePayButton, getConfirmationUrl, getLegalDisclaimerText, getTotalAmount, renderApplePayFeature, updatePromoCode, updatePromoCodeHandler;

ApplePayUI = require('../../frontend/');

getLegalDisclaimerText = require('../../frontend/helpers').getLegalDisclaimerText;

ApplePay = window.ApplePay = {};

getTotalAmount = function() {
  return $('.option input[name=option]:checked').next('label').find('.breakout-option-price').text();
};

renderApplePayFeature = function() {
  getApplePayButton().after('<div class="applepay-promo-code"><a href="#applepay">' + I18n.t('js.modules.applepay.enter_promo_code_or_gift_code') + '</a></div>').before("<span class='applepay-legal-disclaimer'>" + (getLegalDisclaimerText('desktop')) + "</span>").addClass('applepay-button').html('<span class="applepay-logo" data-bhw="ApplePayButton"></span>');
  return updatePromoCode();
};

getApplePayButton = function() {
  return $('.buy-button:not(:disabled)');
};

getConfirmationUrl = function() {
  return $('.option input[name=option]:checked').val();
};

updatePromoCodeHandler = function() {
  return $('.option input[name=option]').change(updatePromoCode);
};

updatePromoCode = function() {
  return $('.applepay-promo-code a').attr('href', getConfirmationUrl());
};

ApplePay.init = function(payload, done) {
  if (ApplePayUI.hasValidConfirmationLink($('a.buy-button:first')[0].href)) {
    ApplePayUI.start(payload, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, 'SpyglassDesktopDealsPage');
  }
  return done();
};

module.exports = ApplePay;



},{"../../frontend/":8,"../../frontend/helpers":7}],7:[function(require,module,exports){
var loadJs;

loadJs = function(urls, cb, onLoad) {
  var load;
  if (urls == null) {
    urls = [];
  }
  if (cb == null) {
    cb = _.noop;
  }
  if (onLoad == null) {
    onLoad = false;
  }
  if (!_.isArray(urls)) {
    urls = [urls];
  }
  load = function() {
    return $.when.apply(window, _.map(urls, function(url) {
      return $.ajax({
        url: url,
        dataType: 'script',
        cache: true
      });
    })).done(cb);
  };
  if (onLoad) {
    return $(window).load(load);
  }
  return load();
};

module.exports = {
  getLegalDisclaimerText: function(env) {
    var privacyStatement, termsOfUse;
    termsOfUse = I18n.t('js.modules.applepay.terms_of_use');
    privacyStatement = I18n.t('js.modules.applepay.privacy_statement');
    return I18n.t("js.modules.applepay." + env + ".legal_disclaimer", {
      termsOfUse: '<a href="/terms">' + termsOfUse + '</a>',
      privacyStatement: '<a href="/privacy">' + privacyStatement + '</a>'
    });
  },
  lazyLoadJs: function(urls, fn, onLoad) {
    return loadJs(urls, fn, onLoad);
  }
};



},{}],8:[function(require,module,exports){
var FIXED_PURCHASE_QTY, confirmationRedirect, getIovationBlackBox, getTotal, hasErrors, lazyLoadJs, receiptRedirect, shouldBucketTheUserIntoExp, showPaymentSheet;

lazyLoadJs = require('./helpers').lazyLoadJs;

FIXED_PURCHASE_QTY = 1;

getTotal = function(amount, type) {
  var total;
  amount = amount.replace(/\$|\s/g, '');
  total = {
    label: I18n.t('js.modules.applepay.total'),
    amount: amount
  };
  if (type) {
    total.type = type;
  }
  return total;
};

confirmationRedirect = function(url) {
  return window.location = url + "&msg=complete_failed";
};

receiptRedirect = function(url) {
  return window.location = url;
};

hasErrors = function(res) {
  var ref, ref1;
  return ((ref = res.flashErrors) != null ? ref.length : void 0) > 0 || ((ref1 = res.apiErrors) != null ? ref1.length : void 0) > 0 || res.error;
};

showPaymentSheet = function(opts) {
  var confirmationUrl, countryCode, csrf, currencyCode, dealId, ioBlackBox, matches, optionId, paymentRequest, session, totalAmount;
  totalAmount = opts.totalAmount, currencyCode = opts.currencyCode, csrf = opts.csrf, confirmationUrl = opts.confirmationUrl, ioBlackBox = opts.ioBlackBox;
  countryCode = I18n.country;
  matches = /\/deals\/(.+)\/confirmation\?pledge_id=([0-9]+)/.exec(confirmationUrl);
  dealId = matches[1];
  optionId = matches[2];
  if (!dealId || !optionId) {
    window.location = confirmationUrl;
    return;
  }
  paymentRequest = {
    currencyCode: currencyCode,
    countryCode: countryCode,
    total: getTotal(totalAmount),
    supportedNetworks: ['amex', 'discover', 'masterCard', 'visa'],
    merchantCapabilities: ['supports3DS'],
    requiredBillingContactFields: ['postalAddress', 'email']
  };
  session = new ApplePaySession(1, paymentRequest);
  session.onpaymentauthorized = function(event) {
    var billingContact, payload, ref, token;
    ref = event.payment, billingContact = ref.billingContact, token = ref.token;
    payload = {
      ioBlackBox: ioBlackBox,
      items: [
        {
          deal_id: dealId,
          option_id: optionId,
          quantity: FIXED_PURCHASE_QTY
        }
      ],
      encrypted_payment_data: JSON.stringify(token.paymentData),
      type: 'applepay',
      billing_record: {
        payment_id: 'applepay',
        type: 'applepay',
        street_address_1: billingContact.addressLines.join(', '),
        country: billingContact.country,
        city: billingContact.locality,
        state: billingContact.administrativeArea,
        postal_code: billingContact.postalCode
      }
    };
    return $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      dataType: 'json',
      url: '/deals/new/orders',
      headers: {
        "x-csrf-token": csrf
      },
      data: payload,
      success: function(data) {
        if (hasErrors(data)) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          return confirmationRedirect(confirmationUrl);
        } else {
          session.completePayment(ApplePaySession.STATUS_SUCCESS);
          return receiptRedirect(data.url);
        }
      },
      error: function() {
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        return confirmationRedirect(confirmationUrl);
      }
    });
  };
  session.onpaymentmethodselected = function(e) {
    return session.completePaymentMethodSelection(getTotal(totalAmount, 'final'), []);
  };
  session.onvalidatemerchant = function(arg) {
    var validationURL;
    validationURL = arg.validationURL;
    return $.ajax({
      type: 'POST',
      dataType: 'json',
      data: {
        url: validationURL
      },
      headers: {
        "x-csrf-token": csrf
      },
      url: '/checkout/payment/validation',
      success: function(merchantSession) {
        return session.completeMerchantValidation(merchantSession);
      }
    });
  };
  return session.begin();
};

shouldBucketTheUserIntoExp = function(expName, cb) {
  return Finch.experiment(expName, {
    Control: function() {
      return cb(false);
    },
    Treatment: function() {
      return cb(true);
    }
  });
};

getIovationBlackBox = function(iovationUrl, cb) {
  window.io_bbout_element_id = 'ioBlackBox';
  window.io_install_flash = false;
  window.io_enable_rip = true;
  window.io_install_stm = false;
  window.io_exclude_stm = 12;
  $('body').append("<input type='hidden' name='" + io_bbout_element_id + "' id='" + io_bbout_element_id + "'>");
  return lazyLoadJs(iovationUrl, function() {
    return cb($("#" + io_bbout_element_id).val());
  });
};

module.exports = {
  hasValidConfirmationLink: function(href) {
    return href.match(/\/deals\/.+\/confirmation\?pledge_id=[0-9]+/i);
  },
  start: function(opts, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, expName) {
    if (!(window.ApplePaySession && opts.isApplePayEnabled)) {
      return;
    }
    return ApplePaySession.canMakePaymentsWithActiveCard(opts.appleMerchantId).then(function(canMakePayments) {
      if (!canMakePayments) {
        return;
      }
      return $.get('/deals/proxy/user/valid', function(arg) {
        var isApplePayEligible;
        isApplePayEligible = arg.isApplePayEligible;
        if (!isApplePayEligible) {
          return;
        }
        return shouldBucketTheUserIntoExp(expName, function(res) {
          if (!res) {
            return;
          }
          return getIovationBlackBox(opts.iovationUrl, function(ioBlackBox) {
            updatePromoCodeHandler();
            renderApplePayFeature();
            return getApplePayButton().click(function(e) {
              var totalAmount;
              totalAmount = getTotalAmount();
              showPaymentSheet(_.extend({}, opts, {
                totalAmount: totalAmount,
                ioBlackBox: ioBlackBox,
                confirmationUrl: getConfirmationUrl()
              }));
              return false;
            });
          });
        });
      });
    });
  }
};



},{"./helpers":7}],9:[function(require,module,exports){
var BuyButton, MagicEventBus, resetMultiOptionLink;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

MagicEventBus = require('magic-event-bus/lib/frizzle.js');

BuyButton.View = require('../frontend/views/buy_button');

resetMultiOptionLink = function() {
  return $(window).on('pageshow', function() {
    var $wrapper, buyLink, linkWithNoQuantity;
    if ($('.multi-option-breakout').length) {
      $wrapper = '.multi-option-breakout';
      buyLink = $('#buy-link').attr('href');
    } else {
      $wrapper = '#options';
      buyLink = $('#options a.buy-button').attr('href');
    }
    if (!buyLink) {
      return;
    }
    linkWithNoQuantity = BuyButton.removeQuantityParam(buyLink);
    return $($wrapper + ' input[value="' + linkWithNoQuantity + '"]').prop('checked', true);
  });
};

BuyButton.removeQuantityParam = function(url) {
  return url.split(/&quantity=[0-9]+[^&]?/).join('');
};

BuyButton.init = function(arg, done) {
  var buyButton, goodsWarranty, handleBuyButton, iframeLogin, inlineVariations, variations;
  buyButton = arg.buyButton, iframeLogin = arg.iframeLogin, variations = arg.variations, inlineVariations = arg.inlineVariations, goodsWarranty = arg.goodsWarranty;
  this.eventBus = new MagicEventBus();
  if ((iframeLogin != null) && !iframeLogin.authenticated && !iframeLogin.disabledOnBuyButton) {
    handleBuyButton = function() {
      IframeLogin.openModal(BuyButton.view.$buyButton.attr('href'));
      return {
        stopTheBus: true
      };
    };
    this.eventBus.board('buy_button_clicked', handleBuyButton)(999);
  }
  return $((function(_this) {
    return function() {
      if (buyButton.multiOptionEnabled) {
        resetMultiOptionLink();
      }
      _this.view = new BuyButton.View({
        multiOptionEnabled: buyButton.multiOptionEnabled,
        multiOptionInline: buyButton.multiOptionInline,
        buyButtonEnabled: buyButton.buyButtonEnabled,
        hasVariations: (variations != null) || (inlineVariations != null),
        goodsWarranty: goodsWarranty
      });
      return done();
    };
  })(this));
};

module.exports = BuyButton;



},{"../frontend/views/buy_button":11,"magic-event-bus/lib/frizzle.js":135}],10:[function(require,module,exports){
var Gift;

Gift = require('../../../gift_button/frontend/gift');

if (window.MultiOptionModal == null) {
  window.MultiOptionModal = {};
}

MultiOptionModal.init = function(payload, done) {
  var openMultiOptionModal;
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : void 0)) {
    return done();
  }
  openMultiOptionModal = function(e) {
    var $modal, $otherTooltip, $tooltipTrigger, firstAvailableOption, modalSelector;
    modalSelector = BuyButton.view.offersClicked ? '#offer-options' : '#options';
    $modal = $(modalSelector);
    if (!$modal.length) {
      return;
    }
    if ($modal.hasClass('tooltip')) {
      $otherTooltip = modalSelector === '#options' ? $('#offer-options') : $('#options');
      if ($otherTooltip.is(':visible')) {
        $otherTooltip.find('.tooltip-close').click();
      }
      $tooltipTrigger = (e != null ? e.delegateTarget : void 0) ? $(e.delegateTarget) : BuyButton.view.offersClicked ? $('.offer-buy-button') : Gift.cookieCreated ? $('.gift-button') : $('.buy-button');
      $tooltipTrigger.attr({
        'data-position': 'bottom',
        'data-tooltip-id': modalSelector.slice(1),
        'data-trigger-event': 'js-trigger'
      });
      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom');
      GIG.Tooltip.helpers.tooltip.apply($tooltipTrigger[0], [
        {
          preventDefault: function() {}
        }
      ]);
    } else {
      if ($modal.hasClass('show-modal')) {
        return;
      }
      if ($(".header-row-sticky").is(":visible") && !payload.buyButton.multiOptionInline) {
        return;
      }
      if (!BuyButton.view.$multiOptions.filter('.selected').length) {
        firstAvailableOption = BuyButton.view.$multiOptions.not(":disabled")[0];
        BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: firstAvailableOption
        });
      }
      GIG.Modal.open({
        el: $modal
      });
    }
    return {
      stopTheBus: true
    };
  };
  if (payload.buyButton.multiOptionInline) {
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998);
  }
  return $(function() {
    var $tooltipCloser, $triggers;
    $triggers = $(".show-multi-option-modal");
    $triggers.click(openMultiOptionModal);
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    GIG.Modal.onClose(Gift.removeCookie, 'options');
    GIG.Modal.onClose(Gift.removeCookie, 'offer-options');
    $('#options, #offer-options').on('click', '.tooltip-close', Gift.removeCookie);
    return done();
  });
};

module.exports = MultiOptionModal;



},{"../../../gift_button/frontend/gift":43}],11:[function(require,module,exports){
var BuyButton, DealEventPipe, GoodsWarranty, SCROLL_THRESHOLD, getBuyUrlWithShippingOptionData;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

GoodsWarranty = window.GoodsWarranty != null ? window.GoodsWarranty : window.GoodsWarranty = {};

DealEventPipe = require('../../../../deal/frontend/event_pipe');

if (GoodsWarranty.Helpers == null) {
  GoodsWarranty.Helpers = require('../../../../goods_warranty/common/helpers');
}

getBuyUrlWithShippingOptionData = require('../../../../goods_local_supply_v2/common/helpers').getBuyUrlWithShippingOptionData;

SCROLL_THRESHOLD = 460;

BuyButton.View = Backbone.View.extend({
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster",
  events: {
    "click a.buy-button:not(.external-buy)": "buyButtonClicked",
    "click .view-options a": "viewAllOptions",
    "click a.offer-buy-button": "offersBuyButtonClicked",
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton",
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton",
    "click a div.text": "goToTips"
  },
  initialize: function(arg) {
    var processLink;
    this.multiOptionEnabled = arg.multiOptionEnabled, this.multiOptionInline = arg.multiOptionInline, this.buyButtonEnabled = arg.buyButtonEnabled, this.hasVariations = arg.hasVariations, this.goodsWarranty = arg.goodsWarranty;
    this.$buyContainer = this.$(".buy");
    this.$buyButton = this.$("a.buy-button");
    this.$giftButton = this.$("a.buy-for-friend");
    this.$offersBuyButton = this.$("a.offer-buy-button");
    this.$dealHeroPrice = this.$(".deal-hero-price, .multi-option-overlay-cluster-price");
    this.$mainBtnPrice = this.$("#main-button-formatted-price");
    this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price");
    this.$priceLabel = this.$(".price-label, .multi-option-overlay-cluster-price-label");
    this.$value = this.$("#discount-value, .discount-value, .breakout-option-value");
    this.$smallPrice = this.$(".discount-value");
    this.$multiOptionBreakout = this.$('.multi-option-breakout, .modal-body');
    this.$multiOptionOverlay = this.$el.filter('.multi-option-overlay');
    this.$multiOptions = this.$('.multi-option-breakout input, .multi-option-overlay-item input');
    this.$buyButtonLoader = this.$buyButton.find('.order-processing-loader');
    this.$finePrintDesc = $(".fine-print-description");
    this.$goodsWarrantyOption = $(".goods-warranty-option");
    this.$headerTitles = $(".header-title-item");
    this.$headerOptions = $(".header-options");
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.$discount = this.$(".breakout-messages .discount-message");
    this.$valueBox = this.$(".multi-option-overlay-cluster-value");
    this.$overlayCluster = this.$(".multi-option-overlay-cluster");
    this.$soldBox = this.$overlayCluster.find("div.sold-message");
    this.$discountBox = this.$overlayCluster.find("div.discount-message");
    this.$expirationBox = this.$overlayCluster.find("div.expiration");
    this.$overlayList = this.$('.multi-option-overlay-list');
    this.$overlayFade = this.$('.scroll-fade-overlay');
    if (this.hasVariations) {
      this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price, .breakout-option-price");
      this.$urgencyPricingMessage = this.$multiOptionBreakout.find('.urgency-pricing-label');
      this.$soldMessage = this.$multiOptionBreakout.find('.sold-message');
    }
    if (this.$multiOptionOverlay.length) {
      this.$discountPercent = this.$('#discount-percent, .discount-percent');
      this.$discountYouSave = this.$('#discount-you-save, .discount-you-save');
      this.$qtyBought = this.$('.qty-bought');
      this.$dealStatus = this.$('.deal-status');
      this.fixPossiblePriceOverflow();
    }
    this.hasBeenClicked = false;
    this.variationsSelected = false;
    if (this.multiOptionInline) {
      this.restoreOptionSelection();
    }
    processLink = (function(_this) {
      return function() {
        return _this.processLink();
      };
    })(this);
    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000);
    DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        _this.variationsSelected = priceData.variationsSelected;
        _this.$buyButton.removeClass("login-disabled");
        _this.updatePrice(priceData);
        _this.updateValue(priceData);
        _this.updateDiscount(priceData);
        _this.updateSoldMessage(priceData);
        return _this.updateBuyButton(priceData);
      };
    })(this));
    return this.$overlayList.on('scroll', (function(_this) {
      return function() {
        return _this.handleFadeout();
      };
    })(this));
  },
  handleFadeout: function() {
    if (this.$overlayList[0].scrollHeight <= SCROLL_THRESHOLD) {
      return;
    }
    if (this.$overlayList.scrollTop() + this.$overlayList.innerHeight() >= this.$overlayList[0].scrollHeight) {
      if (this.$overlayFade.is(':visible')) {
        return this.$overlayFade.hide();
      }
    } else if (!this.$overlayFade.is(':visible')) {
      return this.$overlayFade.show();
    }
  },
  buyButtonClicked: function(e) {
    e.preventDefault();
    this.offersClicked = false;
    this.giftButtonClicked = false;
    return BuyButton.eventBus.go('buy_button_clicked', e);
  },
  offersBuyButtonClicked: function(e) {
    e.preventDefault();
    this.offersClicked = true;
    this.giftButtonClicked = false;
    return BuyButton.eventBus.go('buy_button_clicked', e);
  },
  shouldShowPriceInTwoRows: function() {
    var includeMargin;
    includeMargin = true;
    return this.$priceBox.outerWidth(includeMargin) + this.$smallPrice.outerWidth(includeMargin) > this.$dealHeroPrice.outerWidth(includeMargin);
  },
  setPriceWithSale: function(newPrice) {
    this.$priceBox.text(newPrice);
    return this.fixPossiblePriceOverflow();
  },
  setOfferLabel: function(offerLabel) {
    if (!(offerLabel != null ? offerLabel.length : void 0)) {
      return;
    }
    if (this.hasVariations) {
      this.$urgencyPricingMessage.text(offerLabel);
      this.$soldMessage.hide();
      return this.$priceBox.addClass('urgency-pricing');
    } else {
      offerLabel = "<span class='urgency-pricing-label'>" + offerLabel + "</span>";
      this.$dealHeroPrice.append(offerLabel);
      return this.$dealHeroPrice.addClass('urgency-pricing');
    }
  },
  cleanPriceBox: function() {
    if (this.hasVariations) {
      this.$urgencyPricingMessage.text('');
      this.$soldMessage.text('').show();
      return this.$priceBox.removeClass('urgency-pricing');
    } else {
      this.$priceBox.removeClass('two-rows');
      this.$priceBox.find('.urgency-pricing-label').remove();
      return this.$dealHeroPrice.removeClass('urgency-pricing');
    }
  },
  setPriceBox: function(price, sale, variationsSelected) {
    var ref;
    this.cleanPriceBox();
    if ((sale != null ? sale.urgencyPricing : void 0) != null) {
      this.setPriceWithSale(sale.urgencyPricing.newPrice);
      return this.setOfferLabel((ref = sale.urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0, variationsSelected);
    } else if ((sale != null ? sale.offer : void 0) != null) {
      this.$mainBtnPrice.text(sale.offer.formattedNewPrice);
      return this.setPriceWithSale(sale.offer.formattedOldPrice);
    } else {
      return this.$priceBox.text(price);
    }
  },
  updatePrice: function(arg) {
    var lengthClass, price, sale, variationsSelected;
    lengthClass = arg.lengthClass, price = arg.price, sale = arg.sale, variationsSelected = arg.variationsSelected;
    if (this.currentPriceClass) {
      this.$buyContainer.removeClass(this.currentPriceClass);
    }
    if (lengthClass) {
      this.$buyContainer.addClass(lengthClass);
    }
    this.setPriceBox(price, sale, variationsSelected);
    this.currentPriceClass = lengthClass;
    if (variationsSelected) {
      this.$priceLabel.hide();
      return this.$value.show();
    } else {
      this.$priceLabel.show();
      return this.$value.hide();
    }
  },
  updateValue: function(arg) {
    var hideOriginalPriceAndDiscount, value;
    value = arg.value, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    return this.$value.html(hideOriginalPriceAndDiscount ? "" : value);
  },
  updateDiscount: function(arg) {
    var discountHtml, hideOriginalPriceAndDiscount, percent;
    percent = arg.percent, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    if (!hideOriginalPriceAndDiscount) {
      discountHtml = this.i18n.t('js.modules.buy_button.multi_option.discount_percentage', {
        rawDiscountPercentage: percent
      });
    }
    return this.$discount.html(discountHtml != null ? discountHtml : discountHtml = "");
  },
  updateSoldMessage: function(arg) {
    var soldMessage, variationsSelected;
    variationsSelected = arg.variationsSelected, soldMessage = arg.soldMessage;
    if (variationsSelected) {
      return this.$soldMessage.text(soldMessage);
    }
  },
  updateBuyButton: function(option) {
    var bundleCheckoutUrl, buyUrl, localSupplyUrl, sale, variationsSelected;
    variationsSelected = option.variationsSelected, buyUrl = option.buyUrl, sale = option.sale;
    if (variationsSelected) {
      if (bundleCheckoutUrl = this.buyButtonBundleCheckoutUrl(option)) {
        buyUrl = bundleCheckoutUrl;
      }
      if (localSupplyUrl = this.getLocalSupplyUrl(option)) {
        buyUrl = localSupplyUrl;
      }
      this.$buyButton.attr("href", buyUrl);
      this.$giftButton.attr("href", buyUrl);
      if ((sale != null ? sale.offer : void 0) != null) {
        return this.$offersBuyButton.attr("href", sale.offer.buyUrl);
      }
    }
  },
  getLocalSupplyUrl: function(arg) {
    var buyUrl, ref, shippingOptionData;
    buyUrl = arg.buyUrl;
    if (!(shippingOptionData = typeof GoodsLocalSupply !== "undefined" && GoodsLocalSupply !== null ? (ref = GoodsLocalSupply.View) != null ? ref.getSelectedShippingOptionData() : void 0 : void 0)) {
      return;
    }
    return getBuyUrlWithShippingOptionData(buyUrl, shippingOptionData);
  },
  buyButtonBundleCheckoutUrl: function(arg) {
    var dealUuid, id, ref, uuid, warrantyOption;
    dealUuid = arg.dealUuid, id = arg.id, uuid = arg.uuid;
    if (!this.$goodsWarrantyOption.prop('checked')) {
      return;
    }
    if (!(warrantyOption = GoodsWarranty.Helpers.getFirstWarrantyOption(uuid, (ref = this.goodsWarranty) != null ? ref.dealOptionWarranties : void 0))) {
      return;
    }
    return GoodsWarranty.Helpers.generateBundleCheckoutUrl(dealUuid, id, warrantyOption);
  },
  disableBuyButton: function() {
    this.hasBeenClicked = true;
    this.$buyButton.removeClass("state-buy");
    this.$offersBuyButton.removeClass("state-buy");
    this.$buyButton.addClass("state-disabled");
    this.$offersBuyButton.addClass("state-disabled");
    this.$headerOptions.fadeOut();
    return this.$buyButtonLoader.show();
  },
  enableBuyButton: function() {
    this.hasBeenClicked = false;
    this.$buyButton.removeClass("state-disabled");
    this.$offersBuyButton.removeClass("state-disabled");
    this.$buyButton.addClass("state-buy");
    this.$offersBuyButton.addClass("state-buy");
    this.$headerOptions.fadeIn();
    return this.$buyButtonLoader.hide();
  },
  processLink: function() {
    var button, newUrl;
    if (!this.buyButtonEnabled) {
      return;
    }
    if (!this.hasBeenClicked) {
      button = this.offersClicked ? this.$offersBuyButton : this.$buyButton;
      newUrl = button.attr("href");
      if (this.giftButtonClicked && (payload.buyMore != null)) {
        newUrl = BuyButton.removeQuantityParam(newUrl);
      }
      window.location = newUrl;
    }
    return this.disableBuyButton();
  },
  updateMultiOptionBreakoutButton: function(e) {
    var $option, bundleCheckoutUrl, deal, localSupplyUrl, option, optionInfo, ref, uuid, value;
    $option = this.$multiOptions.filter(e.currentTarget);
    if (!$option.length || $option.hasClass('selected') || !this.buyButtonEnabled) {
      return;
    }
    this.$multiOptions.removeClass('selected');
    $option.addClass('selected');
    value = $option.val();
    ref = $option.data(), deal = ref.deal, option = ref.option, uuid = ref.uuid;
    optionInfo = {
      buyUrl: value,
      dealUuid: deal,
      id: option,
      uuid: uuid
    };
    if (bundleCheckoutUrl = this.buyButtonBundleCheckoutUrl(optionInfo)) {
      value = bundleCheckoutUrl;
    }
    if (localSupplyUrl = this.getLocalSupplyUrl(optionInfo)) {
      value = localSupplyUrl;
    }
    this.$buyButton.attr('href', value);
    this.$giftButton.attr('href', value);
    if (this.$multiOptionOverlay.length) {
      this.updateClusterOptionPrice($option);
      this.syncDealOptions($option);
      this.cleanPriceBox();
      this.setOfferLabel($option.attr('data-offer-label'));
      this.fixPossiblePriceOverflow();
    } else {
      this.updateHeaderPrice($option);
    }
    this.updateHeaderTitle($option);
    if ($option.parent('a').length) {
      BuyButton.eventBus.go('buy_button_clicked', e);
    }
    if (payload.goodsWarranty) {
      DealEventPipe.trigger('goodsWarrantyUpdate', optionInfo);
    }
    if (payload.buyMore) {
      return DealEventPipe.trigger('buyMoreUpdate', optionInfo, false);
    }
  },
  updateHeaderPrice: function($option) {
    var formattedPrice, formattedValue;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    this.$priceBox.text(formattedPrice);
    return this.$smallPrice.text(formattedValue);
  },
  updateHeaderTitle: function($option) {
    var breakoutOptionID, selectedTitle, targetTitleId;
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    this.$headerTitles.removeClass('checked');
    targetTitleId = "#header-title-" + breakoutOptionID;
    selectedTitle = this.$headerTitles.filter(targetTitleId);
    return selectedTitle.addClass('checked');
  },
  updateClusterOptionPrice: function($option) {
    var breakoutOptionID, finePrintDesc, formattedPrice, formattedValue, offerLabel, soldMessage;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    offerLabel = $option.attr('data-offer-label') || '';
    soldMessage = $option.attr('data-sold-message') || '';
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    finePrintDesc = $option.attr('data-description') || '';
    this.$priceBox.text(formattedPrice);
    this.$smallPrice.text(formattedValue);
    this.$valueBox.text(formattedValue);
    this.$soldBox.text(soldMessage);
    this.fixPossiblePriceOverflow();
    this.updateClusterOptionDiscount($option);
    this.updateExpiration($option);
    this.$priceBox.find('.urgency-pricing-label').text(offerLabel);
    this.updateUrgencyPricingMetaData(offerLabel, breakoutOptionID);
    if (soldMessage.length) {
      this.$qtyBought.text(soldMessage);
      this.$dealStatus.show();
    } else {
      this.$dealStatus.hide();
    }
    return this.updateFinePrint(finePrintDesc);
  },
  updateExpiration: function($option) {
    var expiration;
    expiration = $option.attr('data-expiration') || '';
    return this.$expirationBox.text(expiration);
  },
  updateClusterOptionDiscount: function($option) {
    var discountPercentage, savings;
    discountPercentage = $option.attr('data-discount-percentage') || '';
    savings = $option.attr('data-savings') || '';
    if (discountPercentage) {
      this.$discountPercent.text(discountPercentage);
      this.$discountYouSave.text(savings);
      $('.deal-discount').show();
    } else {
      $('.deal-discount').hide();
    }
    return this.$discountBox.text(discountPercentage);
  },
  updateUrgencyPricingMetaData: function(offerLabel, breakoutOptionID) {
    if (offerLabel) {
      return this.$dealHeroPrice.addClass('urgency-pricing tooltip-trigger').attr('data-bhw', 'UrgencyPrice').attr('data-tooltip-id', "urgency-pricing-tooltip-" + breakoutOptionID).attr('data-position', "left");
    } else {
      this.$dealHeroPrice.addClass('c-txt-price');
      return this.$dealHeroPrice.removeClass('urgency-pricing tooltip-trigger').removeAttr('data-bhw').removeAttr('data-tooltip-id').removeAttr('data-position');
    }
  },
  fixPossiblePriceOverflow: function() {
    this.$priceBox.removeClass('two-rows');
    this.$smallPrice.removeClass('two-rows');
    if (this.shouldShowPriceInTwoRows()) {
      this.$priceBox.addClass('two-rows');
      return this.$smallPrice.addClass('two-rows');
    }
  },
  viewAllOptions: function(e) {
    var ref;
    e.preventDefault();
    BuyButton.eventBus.go('view_options_clicked', e);
    if (((ref = this.$overlayList[0]) != null ? ref.scrollHeight : void 0) <= SCROLL_THRESHOLD) {
      return this.$overlayFade.hide();
    }
  },
  restoreOptionSelection: function() {
    return this.$el.find('.multi-option-breakout li input:first').trigger('click');
  },
  syncDealOptions: function($option) {
    var breakoutOptionId, optionId;
    optionId = $option.attr('id');
    if (optionId.indexOf('overlay') !== -1) {
      breakoutOptionId = "#" + (this.getPurchaseClusterOptionId(optionId));
      this.reorderDealOptions(breakoutOptionId);
    } else {
      breakoutOptionId = "#overlay-" + optionId;
    }
    return $(breakoutOptionId).prop('checked', true);
  },
  getPurchaseClusterOptionId: function(optionId) {
    if (optionId == null) {
      return '';
    }
    return optionId.replace('overlay-', '');
  },
  reorderDealOptions: function(breakoutOptionId) {
    var $optionElem;
    $optionElem = $(breakoutOptionId).parents('li');
    if ($optionElem.is(':visible')) {
      return;
    }
    $optionElem.insertBefore($optionElem.siblings('li').first());
    $optionElem.parent().find('li:visible:last').hide();
    return $optionElem.show();
  },
  updateFinePrint: function(finePrintDesc) {
    var $body, finePrintLines, tempLines;
    if (!(finePrintDesc != null ? finePrintDesc.length : void 0)) {
      return;
    }
    $body = $(document.body);
    if ($body.hasClass('getaways') || $body.hasClass('getaways-booking')) {
      finePrintLines = (typeof I18n !== "undefined" && I18n !== null ? I18n.country : void 0) === "US" ? (tempLines = _.filter(finePrintDesc.split(". "), function(line) {
        return line.replace(/<[^>]*>/g, '').trim().length > 0;
      }), tempLines = _.map(tempLines, function(line) {
        return "<li class='fine-print-description'>" + line + "</li>";
      }), tempLines.join('')) : "<span class='fine-print-description'>" + (finePrintDesc.replace(/\n/g, '<br/>')) + "</span>";
      $(finePrintLines).insertBefore(this.$finePrintDesc.first());
      this.$finePrintDesc.remove();
      return this.$finePrintDesc = $('.fine-print-description');
    } else {
      return this.$finePrintDesc.html(finePrintDesc);
    }
  },
  goToTips: function(e) {
    e.preventDefault();
    GIG.Modal.close();
    return window.location.href = "#tips";
  }
});

module.exports = BuyButton.View;



},{"../../../../deal/frontend/event_pipe":21,"../../../../goods_local_supply_v2/common/helpers":44,"../../../../goods_warranty/common/helpers":45}],12:[function(require,module,exports){
var DealEventPipe;

if (window.BuyMore == null) {
  window.BuyMore = {};
}

DealEventPipe = require('../../deal/frontend/event_pipe');

BuyMore.disableQuantityPicker = function($quantityPicker, removeHtml) {
  if (removeHtml == null) {
    removeHtml = false;
  }
  $quantityPicker.attr('disabled', true);
  if (removeHtml) {
    $quantityPicker.empty();
    return $quantityPicker.attr('data-current-option', '');
  }
};

BuyMore.enableQuantityPicker = function($quantityPicker) {
  $quantityPicker.attr('disabled', false);
  return BuyMore.updateBuyButtonUrl({
    currentTarget: $quantityPicker
  });
};

BuyMore.updateQuantityPickerHtml = function(arg) {
  var currentOption, currentTarget, data, optionId;
  currentTarget = arg.currentTarget, data = arg.data;
  currentOption = data.$quantityPicker.attr('data-current-option');
  optionId = data.optionId || $(currentTarget).attr('data-option');
  if (currentOption === optionId) {
    return;
  }
  data.$quantityPicker.empty().append(data.buyMore[optionId].selectHtml);
  data.$quantityPicker.attr('data-current-option', optionId);
  if (data.buyMore[optionId].enableSelection) {
    return BuyMore.enableQuantityPicker(data.$quantityPicker);
  } else {
    return BuyMore.disableQuantityPicker(data.$quantityPicker);
  }
};

BuyMore.updateBuyButtonUrl = function(arg) {
  var $buyButton, currentTarget, newHref, newValue, oldHref;
  currentTarget = arg.currentTarget;
  $buyButton = $('.buy-button');
  newValue = $(currentTarget).val();
  oldHref = $buyButton.attr('href');
  newHref = oldHref.match(/quantity=[0-9]+[^&]?/) ? $buyButton.attr('href').replace(/quantity=[0-9]+[^&]?/, "quantity=" + newValue) : oldHref + ("&quantity=" + newValue);
  return $buyButton.attr('href', newHref);
};

BuyMore.updateAllQuantityPickers = function(arg) {
  var currentTarget, data, newValue;
  currentTarget = arg.currentTarget, data = arg.data;
  newValue = $(currentTarget).val();
  return data.$quantityPicker.val(newValue);
};

BuyMore.init = function(payload, done) {
  var $quantityPicker, $selectedOption, eventData;
  if (payload.buyMore == null) {
    return done();
  }
  $quantityPicker = $('.quantity-picker select');
  eventData = {
    buyMore: payload.buyMore,
    $quantityPicker: $quantityPicker
  };
  if ($selectedOption = $('.multi-option-breakout input:checked')[0]) {
    BuyMore.updateQuantityPickerHtml({
      currentTarget: $selectedOption,
      data: eventData
    });
  }
  $quantityPicker.on("change", eventData, BuyMore.updateBuyButtonUrl);
  if ($quantityPicker.length > 1) {
    $quantityPicker.on("change", eventData, BuyMore.updateAllQuantityPickers);
  }
  DealEventPipe.on("buyMoreUpdate", function(data, disablePicker) {
    if (data == null) {
      data = {};
    }
    if (disablePicker == null) {
      disablePicker = false;
    }
    if (disablePicker) {
      return BuyMore.disableQuantityPicker($quantityPicker, true);
    } else {
      return BuyMore.updateQuantityPickerHtml({
        data: _.extend({}, eventData, {
          optionId: data.id
        })
      });
    }
  });
  return done();
};

module.exports = BuyMore;



},{"../../deal/frontend/event_pipe":21}],13:[function(require,module,exports){
var generateCartUrl;

generateCartUrl = function(optionuuid, dealuuid) {
  return "/cart/add/" + optionuuid + "?deal_id=" + dealuuid;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.Cart == null) {
    window.Cart = {};
  }
  if (Cart.Helpers == null) {
    Cart.Helpers = {};
  }
  Cart.Helpers.generateCartUrl = generateCartUrl;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    generateCartUrl: generateCartUrl
  };
}



},{}],14:[function(require,module,exports){
var StickyHandler,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

StickyHandler = (function() {
  function StickyHandler(element, container, elementOffset) {
    this.element = element;
    this.container = container;
    this.elementOffset = elementOffset;
    this.attachEvents = bind(this.attachEvents, this);
    this.windowHasHorizontalScroll = bind(this.windowHasHorizontalScroll, this);
    this.isWindowSmallerThanElement = bind(this.isWindowSmallerThanElement, this);
    this.shouldBeFixed = bind(this.shouldBeFixed, this);
    this.shouldBeAbsolute = bind(this.shouldBeAbsolute, this);
    this.shouldBeRelative = bind(this.shouldBeRelative, this);
    this.isFixedPositionOverrideRequired = bind(this.isFixedPositionOverrideRequired, this);
    this.getFixedCss = bind(this.getFixedCss, this);
    this.getAbsoluteCss = bind(this.getAbsoluteCss, this);
    this.getRelativeCss = bind(this.getRelativeCss, this);
    this.getCss = bind(this.getCss, this);
    this.updateCss = bind(this.updateCss, this);
    this.updatePosition = bind(this.updatePosition, this);
    this.scroll = bind(this.scroll, this);
    this.resize = bind(this.resize, this);
    this.updateDimensions = bind(this.updateDimensions, this);
    if (this.element.length) {
      this.container = this.container || $('body');
      if (this.window == null) {
        this.window = $(window);
      }
      this.document = $(document);
      this.parent = this.element.parent();
      this.sibling = this.parent.next();
      this.firstTick = true;
      if (this.elementOffset == null) {
        this.elementOffset = 0;
      }
      this.lastCss = {};
      this.scrollTop = this.window.scrollTop();
      this.isRtl = $('body').hasClass('rtl');
      this.attachEvents();
      this.updatePosition();
    }
  }

  StickyHandler.prototype.updateDimensions = function() {
    this.windowHeight = this.window.height();
    this.elementHeight = this.element.height();
    this.elementWidth = this.element.outerWidth();
    this.parentPadding = this.parent.outerWidth() - this.elementWidth;
    this.offsetLeft = this.isRtl ? this.element.offset().left : this.sibling.offset().left + this.sibling.outerWidth() + this.parentPadding - this.window.scrollLeft();
    this.containerBottomPosition = this.container.offset().top + this.container.height();
    this.scrollTop = this.window.scrollTop();
    this.elementTop = this.parent.offset().top - this.elementOffset;
    return this.elementBottomPosition = this.scrollTop + this.elementHeight;
  };

  StickyHandler.prototype.resize = function() {
    this.firstTick = true;
    return this.updatePosition();
  };

  StickyHandler.prototype.scroll = function() {
    this.firstTick = false;
    return this.updatePosition();
  };

  StickyHandler.prototype.updatePosition = function() {
    this.updateDimensions();
    this.css = this.getCss();
    if (!_.isEqual(this.css, this.lastCss)) {
      this.updateCss();
      return this.lastCss = _.clone(this.css);
    }
  };

  StickyHandler.prototype.updateCss = function() {
    return this.element.css(this.css);
  };

  StickyHandler.prototype.getCss = function() {
    if (this.isWindowSmallerThanElement() || this.shouldBeRelative() || this.isFixedPositionOverrideRequired()) {
      return this.getRelativeCss();
    } else if (this.shouldBeAbsolute()) {
      return this.getAbsoluteCss();
    } else {
      return this.getFixedCss();
    }
  };

  StickyHandler.prototype.getRelativeCss = function() {
    return {
      'position': 'relative',
      'top': (this.isFixedPositionOverrideRequired() && !this.isWindowSmallerThanElement()) ? this.scrollTop - this.elementTop : 0,
      'width': '',
      'left': '',
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getAbsoluteCss = function() {
    return {
      'position': 'absolute',
      'top': this.containerBottomPosition - this.elementHeight - this.elementTop,
      'width': this.elementWidth,
      'left': this.parentPadding,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getFixedCss = function() {
    return {
      'position': 'fixed',
      'top': this.elementOffset,
      'width': this.elementWidth,
      'left': this.offsetLeft,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.isFixedPositionOverrideRequired = function() {
    return this.shouldBeFixed() && (this.firstTick || this.windowHasHorizontalScroll());
  };

  StickyHandler.prototype.shouldBeRelative = function() {
    return this.scrollTop <= this.elementTop;
  };

  StickyHandler.prototype.shouldBeAbsolute = function() {
    return this.elementBottomPosition > this.containerBottomPosition;
  };

  StickyHandler.prototype.shouldBeFixed = function() {
    return !(this.shouldBeRelative() || this.shouldBeAbsolute());
  };

  StickyHandler.prototype.isWindowSmallerThanElement = function() {
    return this.windowHeight < this.elementHeight;
  };

  StickyHandler.prototype.windowHasHorizontalScroll = function() {
    return this.window.scrollLeft() !== 0;
  };

  StickyHandler.prototype.attachEvents = function() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.scroll, false);
      window.addEventListener('resize', this.resize, false);
    } else if (window.attachEvent) {
      window.attachEvent('onscroll', this.scroll);
      window.attachEvent('onresize', this.resize);
    }
    return $(document.body).on('modal-open', this.scroll);
  };

  return StickyHandler;

})();

module.exports = StickyHandler;



},{}],15:[function(require,module,exports){
var PURCHASE_CLUSTER_PADDING, StickyHandler, StickyPurchaseCluster;

StickyHandler = require('./sticky_handler');

PURCHASE_CLUSTER_PADDING = 12;

StickyPurchaseCluster = window.StickyPurchaseCluster != null ? window.StickyPurchaseCluster : window.StickyPurchaseCluster = {};

StickyPurchaseCluster.init = function(payload, done) {
  return $(function() {
    var container, element;
    element = $("#purchase-cluster > div");
    container = $('.deal-container');
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING);
    return done();
  });
};

module.exports = StickyPurchaseCluster;



},{"./sticky_handler":14}],16:[function(require,module,exports){
var ChannelTabs;

ChannelTabs = window.ChannelTabs != null ? window.ChannelTabs : window.ChannelTabs = {};

ChannelTabs.init = function(arg, done) {
  var categoriesBaseUrl;
  categoriesBaseUrl = arg.categoriesBaseUrl;
  return $(function() {
    $(".primary-nav").find("a[href='" + categoriesBaseUrl + "']").parent().addClass('active');
    return done();
  });
};

module.exports = ChannelTabs;



},{}],17:[function(require,module,exports){
var DealController, Discount;

DealController = window.DealController != null ? window.DealController : window.DealController = {};

Discount = require('../../discount/frontend/views/discount');

DealController.init = function(payload, done) {
  return $(function() {
    new Discount.View;
    return done();
  });
};

module.exports = DealController;



},{"../../discount/frontend/views/discount":29}],18:[function(require,module,exports){
var DealContentLoader, ERR_ABORTED, ERR_CORRUPTED_DATA, ERR_GLIVE_DEAL, ERR_INTERNAL_SERVER_ERROR, ERR_NETWORK_ERROR, ERR_NON_JSON_RESPONSE, ERR_NOT_FOUND, ERR_NOT_LOCAL_DEAL, ERR_NO_MESSAGE, ERR_OTHER_HTTP_CODE, ERR_REQUEST_TIMEOUT, ERR_XHR_UNHANDLED_ERROR, FALLBACK_QUERY_STRING, LOAD_CONTENT_QUERY_STRING, createQueryAndHashURL, fallback, handlers, hector_config, loadContent, onWindowLoad, populateData, request, runHandlers;

handlers = hector_config = request = void 0;

FALLBACK_QUERY_STRING = 'eagerLoad';

LOAD_CONTENT_QUERY_STRING = 'loadContent';

ERR_XHR_UNHANDLED_ERROR = 'XHR throws an unhandled error';

ERR_REQUEST_TIMEOUT = 'Request timeout';

ERR_ABORTED = 'Request aborted';

ERR_NOT_FOUND = 'Not found';

ERR_INTERNAL_SERVER_ERROR = 'Internal server error';

ERR_NETWORK_ERROR = 'Network error';

ERR_OTHER_HTTP_CODE = 'Other http code';

ERR_NON_JSON_RESPONSE = 'Not a json response';

ERR_NO_MESSAGE = 'No message provided';

ERR_CORRUPTED_DATA = 'Response data is corrupted';

ERR_NOT_LOCAL_DEAL = 'Not a local deal';

ERR_GLIVE_DEAL = 'It is a Glive deal';

createQueryAndHashURL = function(paramAndValue, isFallback) {
  var queryAndHash;
  queryAndHash = paramAndValue;
  if (isFallback) {
    queryAndHash += window.location.hash;
  }
  if (window.location.search) {
    return window.location.search + "&" + queryAndHash;
  } else {
    return "?" + queryAndHash;
  }
};

fallback = function(errMsg) {
  var raw, redirect;
  redirect = function() {
    return window.DealContentLoader._redirectTo(createQueryAndHashURL(FALLBACK_QUERY_STRING, true));
  };
  if (errMsg == null) {
    errMsg = ERR_NO_MESSAGE;
  }
  raw = {
    _csrf: $("meta[name='csrf-token']").attr('content'),
    errMsg: errMsg,
    xhr_status: request != null ? request.status : void 0,
    xhr_readyState: request != null ? request.readyState : void 0
  };
  try {
    return $.ajax({
      data: raw,
      complete: redirect,
      method: 'POST',
      timeout: (hector_config != null ? hector_config.reporterTimeout : void 0) || 1000
    });
  } catch (error) {
    return redirect();
  }
};

runHandlers = function() {
  if (handlers != null) {
    return handlers.forEach(function(handler) {
      return handler();
    });
  }
};

populateData = function(data) {
  if (!data || typeof data !== 'object' || !data.content_html) {
    return fallback(ERR_CORRUPTED_DATA);
  }
  document.title = data.deal_title;
  $('section.main.deal-content-placeholder').replaceWith(data.content_html);
  DealTrackContentLoaded(BOOMR.track_deal_loadtime);
  GIG.Tooltip.reloadBindings();
  GIG.Modal.reloadBindings();
  $('body').addClass('qa-content-loaded');
  return runHandlers();
};

loadContent = function() {
  return request = $.ajax({
    url: createQueryAndHashURL(LOAD_CONTENT_QUERY_STRING, false),
    dataType: 'json',
    timeout: (hector_config != null ? hector_config.loadContentTimeout : void 0) || 5000,
    error: function(jqXHR, textStatus) {
      switch (textStatus) {
        case 'timeout':
          return fallback(ERR_REQUEST_TIMEOUT);
        case 'abort':
          return fallback(ERR_ABORTED);
        case 'parsererror':
          return fallback(ERR_NON_JSON_RESPONSE);
        case 'error':
          switch (jqXHR.status) {
            case 0:
              return fallback(ERR_NETWORK_ERROR);
            case 404:
              return fallback(ERR_NOT_FOUND);
            case 500:
              return fallback(ERR_INTERNAL_SERVER_ERROR);
            default:
              return fallback(ERR_OTHER_HTTP_CODE);
          }
      }
    },
    success: populateData
  });
};

onWindowLoad = function() {
  var ref;
  BOOMR.track_deal_loadtime = +new Date();
  if (DealContentLoader.loadEnabled) {
    hector_config = typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Utils) != null ? typeof ref.getConfigFromDom === "function" ? ref.getConfigFromDom() : void 0 : void 0 : void 0;
    if (!(hector_config != null ? hector_config.shouldLazyLoadDeal : void 0)) {
      return runHandlers();
    } else {
      try {
        return loadContent();
      } catch (error) {
        return fallback(ERR_XHR_UNHANDLED_ERROR);
      }
    }
  } else {
    return runHandlers();
  }
};

DealContentLoader = window.DealContentLoader = {
  addOnLoadHandler: function(handler) {
    if (typeof handler === "function") {
      return handlers.push(handler);
    }
  },
  init: function(loadEnabled) {
    this.loadEnabled = loadEnabled;
    handlers = [];
    return $(window).load(onWindowLoad);
  },
  _redirectTo: function(url) {
    return window.location.replace(url);
  }
};

module.exports = DealContentLoader;



},{}],19:[function(require,module,exports){
var DealLazyLoader;

DealLazyLoader = window.DealLazyLoader = {
  sleepyLoadImages: function() {
    return $('.sleepy-load').lazyload({
      skip_invisible: false
    });
  },
  init: function(payload, done) {
    return $(function() {
      $(document.body).on('modal-open', function(e, data) {
        return $('#' + data.id).find('.lazy-load').lazyload();
      });
      DealContentLoader.addOnLoadHandler(function() {
        Groupon.Utils.lazyLoadImages({
          skip_invisible: false
        });
        return DealLazyLoader.sleepyLoadImages();
      });
      return done();
    });
  }
};

module.exports = DealLazyLoader;



},{}],20:[function(require,module,exports){
var DealTrackContentLoaded, track;

DealTrackContentLoaded = window.DealTrackContentLoaded = function(startTimestamp) {
  var dealContentLoaded;
  dealContentLoaded = +new Date();
  return track(startTimestamp, dealContentLoaded);
};

track = function(startTimestamp, endTimestamp) {
  if ((typeof BOOMR !== 'undefined') && (typeof BOOMR.addVar === 'function')) {
    return BOOMR.addVar('t_deal_content_loaded', endTimestamp - startTimestamp);
  }
};

module.exports = DealTrackContentLoaded;



},{}],21:[function(require,module,exports){
var DealEventPipe;

DealEventPipe = window.DealEventPipe != null ? window.DealEventPipe : window.DealEventPipe = _(Backbone.Events).clone();

module.exports = DealEventPipe;



},{}],22:[function(require,module,exports){
var ExternalLinks, isBlackListedLink, isLinkToEmptyUrl, isLinkToExternalUrl, isLinkToJs, isLinkToPdf, isMailToLink, isWhiteListedLink;

ExternalLinks = window.ExternalLinks != null ? window.ExternalLinks : window.ExternalLinks = {};

isMailToLink = function(obj) {
  return obj.href.match(/^mailto\:/);
};

isLinkToPdf = function(obj) {
  return /.pdf$/.test(obj.href);
};

isLinkToJs = function(obj) {
  return obj.href.match(/^javascript\:/);
};

isLinkToEmptyUrl = function(obj) {
  return obj.href.match(/^$/);
};

isLinkToExternalUrl = function(obj) {
  return obj.hostname.indexOf(location.hostname.replace('www.', '')) === -1;
};

isWhiteListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

isBlackListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

$.expr[":"].external = function(obj, index, meta, stack) {
  return (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) && !(isMailToLink(obj) || isLinkToJs(obj) || isLinkToEmptyUrl(obj) || isBlackListedLink(obj));
};

ExternalLinks.init = function(payload, done) {
  return $(function() {
    $("a:external").click(function(e) {
      e.preventDefault();
      return window.open($(this).attr('href'), "_blank");
    });
    return done();
  });
};

module.exports = ExternalLinks;



},{}],23:[function(require,module,exports){
var ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, DealHighlights, PRIMARY_MESSAGE_TIMEOUT_TOUCH;

require('../../groupon-deal-timer/responsive/common/helpers');

require('../../groupon-deal-timer/responsive/frontend/models/countdown_timer');

require('../../groupon-deal-timer/responsive/frontend/views/countdown_timer');

require('../../groupon-deal-timer/responsive/frontend/countdown_timer');

DealHighlights = window.DealHighlights != null ? window.DealHighlights : window.DealHighlights = {};

ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;

PRIMARY_MESSAGE_TIMEOUT_TOUCH = 3000;

DealHighlights.rotateMessages = function(messagesContainer, loopMessages) {
  var currentMessage, maxHeight, messagesWrapper, nextMessage, primaryMessage, primaryMessageHeight, secondaryMessage, secondaryMessageHeight, switchMessage;
  if (loopMessages == null) {
    loopMessages = false;
  }
  messagesWrapper = messagesContainer.find('.ums-wrapper.pre-animate');
  currentMessage = primaryMessage = messagesContainer.find('.primary');
  nextMessage = secondaryMessage = messagesContainer.find('.secondary');
  primaryMessageHeight = primaryMessage.height();
  messagesWrapper.css('height', primaryMessageHeight + "px");
  maxHeight = primaryMessageHeight;
  if (secondaryMessage.length) {
    secondaryMessageHeight = secondaryMessage.height();
    maxHeight = Math.max(primaryMessageHeight, secondaryMessageHeight);
  }
  switchMessage = function() {
    var ref;
    messagesWrapper.css('height', maxHeight + "px").removeClass('pre-animate');
    currentMessage.addClass('fade-out').removeClass('fade-in');
    nextMessage.addClass('fade-in').removeClass('fade-out');
    if (loopMessages) {
      return ref = [nextMessage, currentMessage], currentMessage = ref[0], nextMessage = ref[1], ref;
    }
  };
  if (loopMessages) {
    return window.setInterval(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH + ACTIVATE_PRIMARY_MESSAGE_TIMEOUT);
  } else {
    return window.setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH);
  }
};

DealHighlights.init = function(arg, done) {
  var activateRotatingMessaging, bindHighlightLinksNavigation, dealHighlights, prepareWindowHandlers, scrollHandler, tiles;
  dealHighlights = arg.dealHighlights;
  if (!dealHighlights) {
    return;
  }
  tiles = dealHighlights.tiles;
  if (dealHighlights.leftTile || dealHighlights.middleTile || dealHighlights.rightTile) {
    tiles = [dealHighlights.leftTile, dealHighlights.middleTile, dealHighlights.rightTile].filter(function(a) {
      return a;
    });
  }
  activateRotatingMessaging = function($element, loopMessages) {
    if ($element.attr("data-activated") === "true") {
      return;
    }
    $element.attr("data-activated", "true");
    return DealHighlights.rotateMessages($element, loopMessages);
  };
  scrollHandler = function(e, $element, loopMessages) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      return activateRotatingMessaging($element, loopMessages);
    }
  };
  bindHighlightLinksNavigation = function(id) {
    var $anchorElement, ref;
    $anchorElement = $(".deal-highlights a[href=\"#" + id + "\"]");
    return (ref = window.TouchDeal) != null ? ref.bindTargetNavigation($anchorElement) : void 0;
  };
  prepareWindowHandlers = function($element, timeout, loopMessages) {
    timeout = timeout || ACTIVATE_PRIMARY_MESSAGE_TIMEOUT;
    window.setTimeout(function() {
      return activateRotatingMessaging($element, loopMessages);
    }, timeout);
    return $(window).on('scroll', function(e) {
      return scrollHandler(e, $element, loopMessages);
    });
  };
  return $(function() {
    var i, len, loopMessages, messageTimer, ref, tile, timerData;
    ref = tiles || [];
    for (i = 0, len = ref.length; i < len; i++) {
      tile = ref[i];
      if (tile.secondaryMessage) {
        messageTimer = tile.messageTimerInSec * 1000;
        loopMessages = tile.loop === true;
        prepareWindowHandlers($('.t-main-inner .deal-highlights, #purchase-cluster .deal-highlights, .multi-option-overlay-cluster .deal-highlights'), messageTimer, loopMessages);
        if ($("#options-pane .deal-highlights").length) {
          window.UrlHashChange.eventBus.board('showHideOptions', function() {
            return prepareWindowHandlers($('#options-pane .deal-highlights'), ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, loopMessages);
          });
        }
      } else if (tile.jsTimerData) {
        timerData = _.extend(tile.jsTimerData, {
          el: '.deal-highlights .countdown-timer',
          translationScope: 'js.modules.groupon-deal-timer.tile'
        });
        CountdownTimer.init({
          timerData: timerData
        });
      }
    }
    bindHighlightLinksNavigation('touch-tips');
    return done();
  });
};

module.exports = DealHighlights;



},{"../../groupon-deal-timer/responsive/common/helpers":55,"../../groupon-deal-timer/responsive/frontend/countdown_timer":56,"../../groupon-deal-timer/responsive/frontend/models/countdown_timer":57,"../../groupon-deal-timer/responsive/frontend/views/countdown_timer":58}],24:[function(require,module,exports){
var DealWidgets;

DealWidgets = window.DealWidgets != null ? window.DealWidgets : window.DealWidgets = {};

DealWidgets.lazyLoadImages = function($widgets) {
  return $widgets.find('.lazy-load').each(function(position, imageElement) {
    var $image;
    $image = $(imageElement);
    return $image.attr('src', $image.attr('data-original'));
  });
};

DealWidgets.ajax_success = function(data, productReviews, done) {
  var $aboveReviewsSlot, $bottomSlot, $featuredTopSlot, $widgets, hasWidgets, ref, ref1, ref2, ref3, ref4;
  if (data == null) {
    $('#featuredtopslot-widget-placeholder').remove();
    $('#bottomslot-widget-placeholder').remove();
    $('#abovereviewsslot-widget-placeholder').remove();
    return done();
  }
  hasWidgets = false;
  $featuredTopSlot = $('#featuredtopslot-widget-placeholder');
  $bottomSlot = $('#bottomslot-widget-placeholder');
  $aboveReviewsSlot = $('#abovereviewsslot-widget-placeholder');
  if ((ref = data.FeaturedTopSlot) != null ? ref.length : void 0) {
    hasWidgets = true;
    if ((ref1 = window.payload) != null ? ref1.solidLine : void 0) {
      $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr id='top-slot-border'/>");
    } else {
      $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr class='dotted-border' id='top-slot-border'/>");
    }
  } else {
    $featuredTopSlot.remove();
  }
  if ((ref2 = data.BottomSlot) != null ? ref2.length : void 0) {
    hasWidgets = true;
    $bottomSlot.replaceWith(data.BottomSlot);
  } else {
    $bottomSlot.remove();
  }
  if ((ref3 = data.AboveReviewsSlot) != null ? ref3.length : void 0) {
    hasWidgets = true;
    $aboveReviewsSlot.replaceWith(data.AboveReviewsSlot);
  } else {
    $aboveReviewsSlot.remove();
  }
  if (hasWidgets) {
    if ((ref4 = Groupon.Utils) != null) {
      if (typeof ref4.lazyLoadImages === "function") {
        ref4.lazyLoadImages();
      }
    }
    if ($widgets = $('.mm-widget, .fake-wls-widget .widget-deals')) {
      DealWidgets.lazyLoadImages($widgets);
      GIG.Utils.truncateElements($widgets);
    }
  }
  return done();
};

DealWidgets.ajax_success_cards = function(data, productReviews, clientDealWidgets, done) {
  var $aboveReviewCard, $bottomCard, cardHtml, hasCards, hasLocal, isUserMaxExceeded, maxPurchaseLimit, ref;
  isUserMaxExceeded = clientDealWidgets.isUserMaxExceeded, maxPurchaseLimit = clientDealWidgets.maxPurchaseLimit;
  if (data == null) {
    $('#cards-above-reviews-placeholder').remove();
    $('#cards-bottom-placeholder').remove();
    return done();
  }
  $aboveReviewCard = $('#cards-above-reviews-placeholder');
  $bottomCard = $('#cards-bottom-placeholder');
  if ((data[0] != null) && $aboveReviewCard.length === 0 && $bottomCard.hasClass('local-cards') && !isUserMaxExceeded) {
    hasLocal = true;
    hasCards = true;
    cardHtml = data[0];
    if (data[1] != null) {
      cardHtml += "<br /> " + data[1];
    }
    $aboveReviewCard.remove();
    $bottomCard.html(cardHtml);
  } else if (data[0] != null) {
    hasCards = true;
    if (isUserMaxExceeded) {
      $aboveReviewCard.html(data[0].replace("{maxPurchaseLimit}", maxPurchaseLimit));
    } else {
      $aboveReviewCard.html(data[0]);
    }
  } else {
    $aboveReviewCard.remove();
  }
  if ((data[1] != null) && !hasLocal) {
    hasCards = true;
    $bottomCard.html(data[1]);
  } else if (!hasLocal) {
    $bottomCard.remove();
  }
  if (hasCards) {
    if ((ref = Groupon.Utils) != null) {
      if (typeof ref.lazyLoadImages === "function") {
        ref.lazyLoadImages();
      }
    }
    CardUI.init();
  }
  return done();
};

DealWidgets.init = function(arg, done) {
  var clientDealWidgets, productReviews;
  clientDealWidgets = arg.clientDealWidgets, productReviews = arg.productReviews;
  if (clientDealWidgets == null) {
    return done();
  }
  return $(function() {
    return DealContentLoader.addOnLoadHandler(function() {
      return $.ajax({
        url: clientDealWidgets.formattedUrl,
        dataType: 'json',
        success: function(data) {
          if (clientDealWidgets.isCardatronCard) {
            return DealWidgets.ajax_success_cards(data, productReviews, clientDealWidgets, done);
          } else {
            return DealWidgets.ajax_success(data, productReviews, done);
          }
        },
        error: function(err) {
          $('#featuredtopslot-widget-placeholder').remove();
          $('#bottomslot-widget-placeholder').remove();
          $('#abovereviewsslot-widget-placeholder').remove();
          $('#cards-above-reviews-placeholder').remove();
          $('#cards-bottom-placeholder').remove();
          return done();
        }
      });
    });
  });
};

module.exports = DealWidgets;



},{}],25:[function(require,module,exports){
var DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

DeliveryEstimates.View = require('./views/delivery_estimates');

DeliveryEstimates.Model = require('./models/delivery_estimates');

DeliveryEstimates.init = function(arg, done) {
  var deliveryEstimates;
  deliveryEstimates = arg.deliveryEstimates;
  if (deliveryEstimates == null) {
    return done();
  }
  return $(function() {
    if (deliveryEstimates != null ? deliveryEstimates.fetchSmartDeliveryEstimates : void 0) {
      DealContentLoader.addOnLoadHandler(function() {
        var model;
        model = new DeliveryEstimates.Model({
          dealId: deliveryEstimates.isGISDeal ? deliveryEstimates.dealId : deliveryEstimates.dealUuid,
          isGISDeal: deliveryEstimates.isGISDeal
        });
        return new DeliveryEstimates.View({
          model: model,
          deliveryEstimates: deliveryEstimates
        });
      });
    } else {
      new DeliveryEstimates.View({
        deliveryEstimates: deliveryEstimates
      });
    }
    return done();
  });
};

module.exports = DeliveryEstimates;



},{"./models/delivery_estimates":27,"./views/delivery_estimates":28}],26:[function(require,module,exports){
(function (global){
var DEFAULT_SHIPPING_TYPE, DEFAULT_ZIPCODE_LENGTH, SHORT_DATE_FORMAT, find, findWhere, formatDeliveryDateRange, formatShippingDayRange, generateDeliveryEstimateHash, generateShippingOptions, generateZipcodeText, getFormattedDeliveryEstimates, getFormattedFastestDeliveryEstimate, map, min, moment, ref;

moment = require('moment');

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), findWhere = ref.findWhere, find = ref.find, map = ref.map, min = ref.min;

SHORT_DATE_FORMAT = 'MMM D';

DEFAULT_SHIPPING_TYPE = 'standard';

DEFAULT_ZIPCODE_LENGTH = 5;

formatDeliveryDateRange = function(date, i18n, isExpedited, name) {
  var dateParams;
  dateParams = {
    spanOpen: "<span class='date'>",
    spanClose: "</span>",
    formattedDate: moment(date).format(SHORT_DATE_FORMAT),
    name: name
  };
  if (isExpedited) {
    return i18n.t('js.modules.delivery_estimates.estimated_delivery_expedited', dateParams);
  } else {
    return i18n.t('js.modules.delivery_estimates.estimated_delivery', dateParams);
  }
};

formatShippingDayRange = function(dayCount, i18n, showBusinessDaysText) {
  if (showBusinessDaysText) {
    return i18n.p(dayCount, 'js.modules.delivery_estimates.ships_in_business');
  } else {
    return i18n.p(dayCount, 'js.modules.delivery_estimates.ships_in');
  }
};

getFormattedFastestDeliveryEstimate = function(options, i18n, isExpedited, showBusinessDaysText) {
  var fastestOption;
  fastestOption = min(options, function(option) {
    var maxDate, ref1;
    if (maxDate = (ref1 = option.deliveryEstimate) != null ? ref1.maxDate : void 0) {
      return moment(maxDate);
    }
  });
  if (fastestOption === 2e308) {
    fastestOption = min(options, function(option) {
      var maxBusinessDays, ref1;
      if ((maxBusinessDays = (ref1 = option.shippingEstimate) != null ? ref1.maxBusinessDays : void 0) != null) {
        return maxBusinessDays;
      }
    });
  }
  return getFormattedDeliveryEstimates(fastestOption, i18n, isExpedited, showBusinessDaysText);
};

getFormattedDeliveryEstimates = function(option, i18n, isExpedited, showBusinessDaysText) {
  var maxDeliveryDate, maxShippingDay, ref1, ref2;
  maxDeliveryDate = option != null ? (ref1 = option.deliveryEstimate) != null ? ref1.maxDate : void 0 : void 0;
  maxShippingDay = option != null ? (ref2 = option.shippingEstimate) != null ? ref2.maxBusinessDays : void 0 : void 0;
  if (!(maxDeliveryDate || (maxShippingDay != null))) {
    return;
  }
  if (maxDeliveryDate) {
    return {
      estimates: formatDeliveryDateRange(maxDeliveryDate, i18n, isExpedited, option != null ? option.name : void 0)
    };
  } else if (!isExpedited) {
    return {
      estimates: formatShippingDayRange(maxShippingDay, i18n, showBusinessDaysText)
    };
  }
};

generateShippingOptions = function(options, isExpedited) {
  if (!(options != null ? options.length : void 0)) {
    return [];
  }
  return map(options, function(option) {
    var shippingOption;
    if (isExpedited) {
      shippingOption = find(option.shippingOptions, function(shippingOption) {
        return shippingOption.id !== DEFAULT_SHIPPING_TYPE;
      });
    } else {
      shippingOption = findWhere(option.shippingOptions, {
        id: DEFAULT_SHIPPING_TYPE
      });
    }
    if (shippingOption == null) {
      shippingOption = {};
    }
    shippingOption.uuid = option.uuid;
    return shippingOption;
  });
};

generateDeliveryEstimateHash = function(options, i18n, isExpedited, showBusinessDaysText) {
  var data, deliveryOption, i, len, ref1, standardDeliveryOptions;
  standardDeliveryOptions = generateShippingOptions(options, isExpedited);
  if (!standardDeliveryOptions.length) {
    return;
  }
  data = {
    "default": getFormattedFastestDeliveryEstimate(standardDeliveryOptions, i18n, isExpedited, showBusinessDaysText)
  };
  ref1 = standardDeliveryOptions || [];
  for (i = 0, len = ref1.length; i < len; i++) {
    deliveryOption = ref1[i];
    data[deliveryOption.uuid] = getFormattedDeliveryEstimates(deliveryOption, i18n, isExpedited, showBusinessDaysText);
  }
  return data;
};

generateZipcodeText = function(zipcode, i18n) {
  if (!(zipcode != null ? zipcode.length : void 0)) {
    return;
  }
  zipcode = zipcode.substring(0, DEFAULT_ZIPCODE_LENGTH);
  return i18n.t('js.modules.delivery_estimates.shipping_zipcode', {
    zipcode: zipcode
  });
};

module.exports = {
  generateDeliveryEstimateHash: generateDeliveryEstimateHash,
  generateZipcodeText: generateZipcodeText,
  getFormattedFastestDeliveryEstimate: getFormattedFastestDeliveryEstimate,
  getFormattedDeliveryEstimates: getFormattedDeliveryEstimates,
  generateShippingOptions: generateShippingOptions
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"moment":136}],27:[function(require,module,exports){
var DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

if (DeliveryEstimates.Views == null) {
  DeliveryEstimates.Views = {};
}

DeliveryEstimates.Model = Backbone.Model.extend({
  initialize: function(attrs) {
    return _.extend(this, attrs);
  },
  setZipcode: function(inputZipcode) {
    if (!/^\d{5}$/.test(inputZipcode)) {
      return;
    }
    this.set('zipcodeValue', inputZipcode);
    return this.fetch();
  },
  url: function() {
    var resource, zipcodeValue;
    zipcodeValue = this.get('zipcodeValue');
    resource = "/deals/delivery_estimates_proxy/" + this.dealId + ".json";
    if (zipcodeValue != null ? zipcodeValue.length : void 0) {
      return resource + "?zipcode=" + zipcodeValue + "&isGISDeal=true";
    } else if (this.isGISDeal) {
      return resource + "?isGISDeal=true";
    } else {
      return resource;
    }
  }
});

module.exports = DeliveryEstimates.Model;



},{}],28:[function(require,module,exports){
var DEFAULT_SELECT_OPTION, DealEventPipe, DeliveryEstimates, EMPTY_HASH, generateDeliveryEstimateHash, generateZipcodeText, ref;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

ref = require('../helpers/delivery_estimates'), generateDeliveryEstimateHash = ref.generateDeliveryEstimateHash, generateZipcodeText = ref.generateZipcodeText;

EMPTY_HASH = '{}';

DEFAULT_SELECT_OPTION = 'default';

DeliveryEstimates.View = Backbone.View.extend({
  el: '#delivery-estimates .delivery-estimates-container',
  events: {
    'click #change-zipcode': 'changeZipcode',
    'click #delivery-estimates-save-zipcode': 'saveZipcode',
    'submit form': function(e) {
      return e.preventDefault();
    }
  },
  initialize: function(arg) {
    var deliveryEstimates, model, ref1, ref2, ref3, ref4;
    model = arg.model, deliveryEstimates = arg.deliveryEstimates;
    this.deliveryEstimates = deliveryEstimates;
    this.$deliveryEstimatesPod = $('#delivery-estimates');
    this.$estimates = this.$el.find('.estimates');
    this.$expedited = this.$el.find('.expedited');
    this.dealId = (ref1 = this.deliveryEstimates) != null ? ref1.dealId : void 0;
    this.selectedOption = DEFAULT_SELECT_OPTION;
    this.manualError = false;
    if ((ref2 = this.deliveryEstimates) != null ? ref2.fetchSmartDeliveryEstimates : void 0) {
      this.cacheZipcodeElements();
      this.model.fetch();
      this.listenTo(this.model, 'sync', (function(_this) {
        return function() {
          var ref3, ref4;
          _.extend(_this.deliveryEstimates, _this.model.attributes);
          if (_this.deliveryEstimates.isGISDeal) {
            _this.$deliveryEstimatesPod.removeClass('icon-g-loader');
            if (_this.deliveryEstimates.smartDeliveryEstimates) {
              _this.deliveryEstimatesHash = generateDeliveryEstimateHash((ref3 = _this.deliveryEstimates.dealHash) != null ? ref3.options : void 0, I18n, false, _this.deliveryEstimates.showBusinessDaysText);
            } else {
              _this.deliveryEstimatesHash = _this.deliveryEstimates;
            }
            if (_this.deliveryEstimates.showExpeditedShipping) {
              _this.expeditedShippingHash = generateDeliveryEstimateHash((ref4 = _this.deliveryEstimates.dealHash) != null ? ref4.options : void 0, I18n, true);
            }
            _this.updateDeliveryEstimatesMessage();
            return _this.updateZipcodeContainer();
          } else {
            _this.deliveryEstimates.smartDeliveryEstimates = false;
            _this.deliveryEstimatesHash = _this.deliveryEstimates.deliveryEstimatesHash;
            return _this.updateDeliveryEstimatesMessage();
          }
        };
      })(this));
      this.listenTo(this.model, 'error', (function(_this) {
        return function() {
          _this.$deliveryEstimatesPod.removeClass('icon-g-loader');
          _this.$deliveryEstimatesPod.addClass('close');
          return _this.deliveryEstimatesHash = {};
        };
      })(this));
    } else {
      this.deliveryEstimatesHash = this.deliveryEstimates;
      this.updateDeliveryEstimatesMessage();
    }
    DealEventPipe.on('priceUpdate', (function(_this) {
      return function(data) {
        _this.selectedOption = data != null ? data.uuid : void 0;
        return _this.updateDeliveryEstimatesMessage();
      };
    })(this));
    DealEventPipe.on('touchDeliveryEstimatesUpdate', (function(_this) {
      return function(data) {
        _this.selectedOption = data != null ? data.uuid : void 0;
        return _this.updateDeliveryEstimatesMessage();
      };
    })(this));
    if (typeof BuyButton !== "undefined" && BuyButton !== null) {
      if ((ref3 = BuyButton.eventBus) != null) {
        ref3.board('buy_button_clicked', (function(_this) {
          return function() {
            return _this.logDeliveryEstimates(true);
          };
        })(this));
      }
    }
    return typeof ResponsiveBuyButton !== "undefined" && ResponsiveBuyButton !== null ? (ref4 = ResponsiveBuyButton.eventBus) != null ? ref4.board('buy_button_clicked', (function(_this) {
      return function() {
        return _this.logDeliveryEstimates(true);
      };
    })(this)) : void 0 : void 0;
  },
  cacheZipcodeElements: function() {
    this.$shippingZipcodeContainer = this.$el.find('.shipping-zipcode-container');
    this.$shippingZipcodeContainerText = this.$shippingZipcodeContainer.find('.zipcode-text');
    this.$shippingZipcodeContainerError = this.$shippingZipcodeContainer.find('.zipcode-text-error');
    this.$changeZipcodeLink = this.$el.find('#change-zipcode');
    this.$changeZipcodeContainer = this.$el.find('.change-zipcode-container');
    return this.$changeZipcodeInput = this.$el.find('#input-zipcode');
  },
  logDeliveryEstimates: function(buyButtonClicked) {
    var estimates, expedited;
    if (buyButtonClicked == null) {
      buyButtonClicked = false;
    }
    if (!this.deliveryEstimates.logEstimates) {
      return;
    }
    estimates = this.$estimates.text();
    expedited = this.$expedited.text();
    return OptimizeSuite.TrackingHub.add('delivery-estimates', {
      dealId: this.dealId,
      selectedOption: this.selectedOption,
      estimates: estimates,
      expedited: expedited,
      buyButtonClicked: buyButtonClicked
    });
  },
  updateDeliveryEstimatesMessage: function() {
    var estimates, expedited, ref1, ref2, ref3, ref4;
    if (estimates = (ref1 = this.deliveryEstimatesHash) != null ? (ref2 = ref1[this.selectedOption]) != null ? ref2.estimates : void 0 : void 0) {
      this.$estimates.html(estimates);
      this.$deliveryEstimatesPod.removeClass('close');
      this.manualError = false;
    } else {
      if (JSON.stringify(this.deliveryEstimatesHash) === EMPTY_HASH) {
        this.manualError = true;
        this.showValidationError();
        this.$changeZipcodeLink.hide();
        this.$changeZipcodeContainer.show();
      } else {
        this.manualError = false;
        this.$deliveryEstimatesPod.addClass('close');
      }
    }
    if (expedited = (ref3 = this.expeditedShippingHash) != null ? (ref4 = ref3[this.selectedOption]) != null ? ref4.estimates : void 0 : void 0) {
      this.$deliveryEstimatesPod.addClass('has-expedited');
      this.$expedited.html(expedited);
      this.$expedited.removeClass('close');
    } else if (!this.manualError) {
      this.$deliveryEstimatesPod.removeClass('has-expedited');
      this.$expedited.addClass('close');
    }
    return this.logDeliveryEstimates();
  },
  updateZipcodeContainer: function() {
    var ref1, ref2, ref3;
    this.zipcodeValue = (ref1 = this.deliveryEstimates.dealHash) != null ? ref1.deliveryEstimatesZipcode : void 0;
    this.zipcodeSource = (ref2 = this.deliveryEstimates.dealHash) != null ? ref2.deliveryEstimatesZipcodeSource : void 0;
    if (!((ref3 = this.zipcodeValue) != null ? ref3.length : void 0)) {
      return;
    }
    this.$shippingZipcodeContainer.show();
    if (this.manualError) {
      return;
    }
    this.$shippingZipcodeContainer.attr('data-bhc', "zipcode-source:" + this.zipcodeSource);
    this.$shippingZipcodeContainerText.text(generateZipcodeText(this.zipcodeValue, I18n));
    this.hideValidationError();
    this.$changeZipcodeLink.show();
    return this.$changeZipcodeContainer.hide();
  },
  changeZipcode: function(e) {
    this.$changeZipcodeLink.hide();
    this.$changeZipcodeContainer.show();
    this.$changeZipcodeInput.val(this.zipcodeValue);
    this.$shippingZipcodeContainerText.text(I18n.t('js.modules.delivery_estimates.shipping_zipcode', {
      zipcode: ''
    }));
    return this.$changeZipcodeInput.focus();
  },
  saveZipcode: function(e) {
    if (this.model.setZipcode(this.$changeZipcodeInput.val())) {
      this.$deliveryEstimatesPod.addClass('icon-g-loader');
      this.zipcodeValue = this.model.get('zipcodeValue');
      return this.hideValidationError();
    } else {
      return this.showValidationError();
    }
  },
  hideValidationError: function() {
    this.$el.removeClass('error');
    return this.$changeZipcodeInput.removeClass('error');
  },
  showValidationError: function() {
    this.$el.addClass('error');
    this.$changeZipcodeInput.addClass('error');
    if (this.manualError) {
      return this.$shippingZipcodeContainerError.text(I18n.t('js.modules.delivery_estimates.no_estimates'));
    } else {
      return this.$shippingZipcodeContainerError.text(I18n.t('js.modules.delivery_estimates.invalid_zipcode'));
    }
  }
});

module.exports = DeliveryEstimates.View;



},{"../../../deal/frontend/event_pipe":21,"../helpers/delivery_estimates":26}],29:[function(require,module,exports){
var DealEventPipe;

if (window.Discount == null) {
  window.Discount = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Discount.View = Backbone.View.extend({
  el: "#discount-data, .discount-data",
  initialize: function() {
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateTiles(priceData);
      };
    })(this));
  },
  updateTiles: function(arg) {
    var hideOriginalPriceAndDiscount, percent, savings, value;
    value = arg.value, percent = arg.percent, savings = arg.savings, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    this.$("#discount-value, .discount-value").html(value);
    this.$("#discount-percent, .discount-percent").html(percent);
    this.$("#discount-you-save, .discount-you-save").html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents(".deal-discount").hide();
    } else {
      return this.$el.parents(".deal-discount").show();
    }
  }
});

module.exports = Discount;



},{"../../../deal/frontend/event_pipe":21}],30:[function(require,module,exports){
var DfpAds;

DfpAds = window.DfpAds != null ? window.DfpAds : window.DfpAds = {};

DfpAds.init = function(arg, done) {
  var dfpHeader;
  dfpHeader = arg.dfpHeader;
  if (!dfpHeader) {
    return done();
  }
  return DealContentLoader.addOnLoadHandler(function() {
    Groupon.DFPAds || (Groupon.DFPAds = {});
    Groupon.DFPAds.showAds = function() {
      return $('.dfp-footer, .dfp-side-rail').map(function() {
        return this.id;
      }).each(function(i, id) {
        return googletag.cmd.push(function() {
          return googletag.display(id);
        });
      });
    };
    return done();
  });
};

module.exports = DfpAds;



},{}],31:[function(require,module,exports){
module.exports = function() {
  var config, deal_data, ref, t_done, t_page, t_resp, variants;
  config = typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Utils) != null ? ref.getConfigFromDom() : void 0 : void 0;
  if (!(config != null ? config.bucketedExperimentData : void 0)) {
    return;
  }
  if (!(typeof BOOMR !== "undefined" && BOOMR !== null ? BOOMR.getVar : void 0)) {
    return;
  }
  t_resp = BOOMR.getVar('t_resp');
  t_page = BOOMR.getVar('t_page');
  t_done = BOOMR.getVar('t_done');
  variants = config.bucketedExperimentData.experiments;
  deal_data = config.bucketedExperimentData.dealData;
  return OptimizeSuite.TrackingHub.add('deal_page_experiment_performance', {
    deal_data: deal_data,
    t_page: t_page,
    t_done: t_done,
    t_resp: t_resp,
    variants: variants
  });
};



},{}],32:[function(require,module,exports){
if (window.ExternalDeal == null) {
  window.ExternalDeal = {};
}

ExternalDeal.init = function(arg, done) {
  var externalDeal;
  externalDeal = arg.externalDeal;
  if (!externalDeal) {
    return done();
  }
  return $(function() {
    var $externalBuyButton;
    $externalBuyButton = $('.external-buy');
    $externalBuyButton.click(function(e) {
      e.preventDefault();
      window.open($(this).attr('href'));
      return setTimeout(GIG.Modal.close, 3000);
    });
    return done();
  });
};

module.exports = ExternalDeal;



},{}],33:[function(require,module,exports){
(function (global){
var DEAL_PAGE_LOCATIONS_MODAL_COUNT, GMap, GMapDesktop2016V2Markers, INLINE_MAP_HEIGHT_LIMIT, INLINE_MAP_WIDTH_LIMIT, MAP_CENTER_OFFSET, MODAL_MAP_HEIGHT_LIMIT, MODAL_MAP_WIDTH_LIMIT, ResponsiveMarkers, SVG_INLINE, _, _setEventListeners,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

GMap.vent = require('../../frontend/helpers/events').vent;

ResponsiveMarkers = require('../../responsive/frontend/markers');

SVG_INLINE = require('../../frontend/svgs');

DEAL_PAGE_LOCATIONS_MODAL_COUNT = 3;

MAP_CENTER_OFFSET = -162;

MODAL_MAP_WIDTH_LIMIT = 320;

MODAL_MAP_HEIGHT_LIMIT = 270;

INLINE_MAP_WIDTH_LIMIT = 150;

INLINE_MAP_HEIGHT_LIMIT = 150;

module.exports = GMapDesktop2016V2Markers = (function(superClass) {
  extend(GMapDesktop2016V2Markers, superClass);

  function GMapDesktop2016V2Markers() {
    GMapDesktop2016V2Markers.__super__.constructor.apply(this, arguments);
    this.isIe11 = (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '11.0';
    this.isFirefox = (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'Firefox';
  }

  GMapDesktop2016V2Markers.prototype.makeMarkers = function(markerData) {
    var i, len, marker, ref, results;
    GMapDesktop2016V2Markers.__super__.makeMarkers.apply(this, arguments);
    ref = this.activeMarkers;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      marker = ref[i];
      results.push(_.defaults(marker.icon, {
        scaledSize: new this.googleMaps.Size(24, 32)
      }));
    }
    return results;
  };

  GMapDesktop2016V2Markers.prototype.makeSVGString = function(type, text) {
    var svg;
    if (this.isIe11) {
      return "https://img.grouponcdn.com/editorial/2U9cjJau6vATPp6UezFVhTHwCnmn/2U-52x70";
    } else if (this.isFirefox) {
      svg = SVG_INLINE[type];
      svg = svg.split('y="13"').join('y="17"');
      svg = svg.split('MARKER_LABEL_PLACEHOLDER').join(text);
      return "data:image/svg+xml;utf-8," + encodeURIComponent(svg);
    } else {
      return GMapDesktop2016V2Markers.__super__.makeSVGString.apply(this, arguments);
    }
  };

  GMapDesktop2016V2Markers.prototype.addMarkersToMap = function(map) {
    var i, index, len, marker, ref;
    ref = this.activeMarkers;
    for (index = i = 0, len = ref.length; i < len; index = ++i) {
      marker = ref[index];
      _setEventListeners(marker, index);
      marker.setMap(map);
    }
    if (this.activeMarkers.length > 2) {
      this.bounds = this.createBounds(this.activeMarkers, this.nearbyLocationsCount);
      return map.fitBounds(this.bounds);
    }
  };

  GMapDesktop2016V2Markers.prototype.createBounds = function(markers, nearbyLocationsCount) {
    var bounds, displayCount, i, len, marker, ref;
    bounds = new this.googleMaps.LatLngBounds();
    if (nearbyLocationsCount === 0) {
      displayCount = DEAL_PAGE_LOCATIONS_MODAL_COUNT * 2;
    } else {
      displayCount = Math.min(DEAL_PAGE_LOCATIONS_MODAL_COUNT * 2, nearbyLocationsCount * 2);
    }
    if ((markers != null ? markers.length : void 0) > DEAL_PAGE_LOCATIONS_MODAL_COUNT) {
      markers = markers.slice(0, displayCount);
    }
    ref = markers || [];
    for (i = 0, len = ref.length; i < len; i++) {
      marker = ref[i];
      bounds.extend(marker.getPosition());
    }
    return bounds;
  };

  GMapDesktop2016V2Markers.prototype.adjustMarkersPosition = function(map, userMarkerData) {
    var userGeoDetails, zoomChangeListener;
    userGeoDetails = _.pick(userMarkerData, 'lat', 'lng');
    return zoomChangeListener = map.addListener('bounds_changed', (function(_this) {
      return function() {
        var boundLeftPoint, boundLeftX, boundLeftY, boundRightPoint, boundRightX, boundRightY, centerPoint, centerX, centerY, heightLimit, ref, ref1, ref2, widthLimit, zoom;
        if (((ref = _this.activeMarkers) != null ? ref.length : void 0) === 2) {
          map.panBy(MAP_CENTER_OFFSET, 0);
          return zoomChangeListener.remove();
        } else {
          if (_this.nearbyLocationsCount !== 0) {
            map.panTo({
              lat: userGeoDetails.lat,
              lng: userGeoDetails.lng
            });
          }
          zoom = map.getZoom();
          boundRightPoint = _this.fromLatLngToPoint(map, _this.bounds.getNorthEast(), zoom);
          boundRightX = boundRightPoint != null ? boundRightPoint.x : void 0;
          boundRightY = boundRightPoint != null ? boundRightPoint.y : void 0;
          boundLeftPoint = _this.fromLatLngToPoint(map, _this.bounds.getSouthWest(), zoom);
          boundLeftX = boundLeftPoint != null ? boundLeftPoint.x : void 0;
          boundLeftY = boundLeftPoint != null ? boundLeftPoint.y : void 0;
          centerPoint = _this.fromLatLngToPoint(map, map.getCenter(), zoom);
          centerX = centerPoint != null ? centerPoint.x : void 0;
          centerY = centerPoint != null ? centerPoint.y : void 0;
          if (boundRightX && boundLeftX && centerX) {
            widthLimit = ((ref1 = _this.activeMarkers) != null ? ref1.length : void 0) === 4 ? INLINE_MAP_WIDTH_LIMIT : MODAL_MAP_WIDTH_LIMIT;
            heightLimit = ((ref2 = _this.activeMarkers) != null ? ref2.length : void 0) === 4 ? INLINE_MAP_HEIGHT_LIMIT : MODAL_MAP_HEIGHT_LIMIT;
            if ((boundRightX - centerX > widthLimit || centerX - boundLeftX > widthLimit || centerY - boundRightY > heightLimit || boundLeftY - centerY > heightLimit) && zoom > 0) {
              return map.setZoom(zoom - 1);
            } else {
              zoomChangeListener.remove();
              return map.panBy(MAP_CENTER_OFFSET, 0);
            }
          }
        }
      };
    })(this));
  };

  GMapDesktop2016V2Markers.prototype.fromLatLngToPoint = function(map, latLng, zoom) {
    var mapBounds, northWest, northWestPoint, point, scale, targetPoint;
    scale = Math.pow(2, zoom);
    mapBounds = map.getBounds();
    northWest = new this.googleMaps.LatLng(mapBounds.getNorthEast().lat(), mapBounds.getSouthWest().lng());
    northWestPoint = map.getProjection().fromLatLngToPoint(northWest);
    targetPoint = map.getProjection().fromLatLngToPoint(latLng);
    return point = new this.googleMaps.Point(Math.floor((targetPoint.x - northWestPoint.x) * scale), Math.floor((targetPoint.y - northWestPoint.y) * scale));
  };

  GMapDesktop2016V2Markers.prototype.addUserMarker = function(map, userMarkerData) {
    var markerOptions, ref, userGeoDetails, userMarker;
    userGeoDetails = _.pick(userMarkerData, 'lat', 'lng');
    if (this.nearbyLocationsCount === 0 || ((ref = this.activeMarkers) != null ? ref.length : void 0) === 2) {
      return;
    }
    markerOptions = {
      position: new this.googleMaps.LatLng(userGeoDetails.lat, userGeoDetails.lng),
      icon: {
        url: userMarkerData.icons[0].url,
        scaledSize: userMarkerData.size ? new this.googleMaps.Size(userMarkerData.size.width, userMarkerData.size.height) : void 0
      }
    };
    userMarker = new this.googleMaps.Marker(markerOptions);
    return userMarker.setMap(map);
  };

  return GMapDesktop2016V2Markers;

})(ResponsiveMarkers);

_setEventListeners = function(markers, index) {
  if (markers != null) {
    markers.addListener('mouseover', function() {
      return GMap.vent.trigger('mouseOverMerchantPin', {
        index: index
      });
    });
  }
  return markers != null ? markers.addListener('click', function() {
    return GMap.vent.trigger('clickedMerchantPin', {
      index: index
    });
  }) : void 0;
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../frontend/helpers/events":37,"../../frontend/svgs":40,"../../responsive/frontend/markers":42}],34:[function(require,module,exports){
(function (global){
var Rolodex, _, _getLockedCards, _getOpenCards, _updateCards;

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

module.exports = Rolodex = (function() {
  function Rolodex(data) {
    if (data != null) {
      this.element = data.$el, this.minLength = data.minLength;
      this.cards = this.element.find('li.merchant-location-card:not(".all-locations")');
      this.initialize();
    }
  }

  Rolodex.prototype.initialize = function() {
    this.initialScrollTop = 22;
    this.addressBottomHeight = -35;
    this.scrollBox = this.element.find('.scroll-box');
    this.scrollBox.scrollTop(this.initialScrollTop);
    this.lockBoxList = this.element.find('.lock-box ol');
    this.element.on('updateCards', (function(_this) {
      return function(event, cb) {
        return _updateCards.call(_this, cb);
      };
    })(this));
    if (this.minLength && typeof this.minLength === 'number' && this.cards.length > this.minLength) {
      if (this.cards.length > this.minLength) {
        this._collapseCard(this.cards.slice(this.minLength));
        return this._watchScrollEvent();
      }
    } else {
      return this.scrollBox.addClass('no-scroll');
    }
  };

  Rolodex.prototype.rollForwards = function($card) {
    if (!($card != null ? $card.length : void 0)) {
      return;
    }
    this._ignoreScrollEvent();
    this._lockAndPlaceCard($card);
    this._repositionList();
    return this._watchScrollEvent();
  };

  Rolodex.prototype.rollBackwards = function($card, event) {
    if (!($card != null ? $card.length : void 0)) {
      return;
    }
    this._ignoreScrollEvent();
    this._unlockAndResetCard($card, event);
    this._repositionList();
    return this._watchScrollEvent();
  };

  Rolodex.prototype.toggleVisibility = function(event) {
    if (!this.element.is(':hidden')) {
      return this.element.slideUp();
    } else {
      return this.element.slideDown();
    }
  };

  Rolodex.prototype._watchScrollEvent = function() {
    this.element.on('wheel', '.lock-box ol', _.throttle((function(_this) {
      return function(event) {
        var newValue, value;
        value = _this.scrollBox.scrollTop();
        newValue = value + event.originalEvent.deltaY;
        return _this.scrollBox.scrollTop(newValue);
      };
    })(this), 50, {
      trailing: false
    }));
    return this.scrollBox.on('scroll', (function(_this) {
      return function(event) {
        var $card, ref;
        if (_this.scrollBox.scrollTop() > 115) {
          return _this.rollForwards.call(_this, _this.cards.open.first());
        } else if (_this.scrollBox.scrollTop() === 0) {
          $card = (ref = _this.cards.locked) != null ? ref.last() : void 0;
          return _this.rollBackwards.call(_this, $card, event);
        }
      };
    })(this));
  };

  Rolodex.prototype._ignoreScrollEvent = function() {
    return this.scrollBox.off('scroll');
  };

  Rolodex.prototype._addClickOnCollapseCard = function($card) {
    if (!$card) {
      return;
    }
    return $card.on('click.rolodex', (function(_this) {
      return function(event) {
        var card, i, len, ref, results;
        if (!$card.hasClass('collapse-card')) {
          return;
        }
        $card.off('click.rolodex');
        ref = _this.cards.open.onlyExpanded;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          card = ref[i];
          $card = $(card);
          results.push(_this.rollForwards.call(_this, $card));
        }
        return results;
      };
    })(this));
  };

  Rolodex.prototype._addClickOnLockedCard = function($card) {
    if (!$card) {
      return;
    }
    return $card.on('click.rolodex', (function(_this) {
      return function(event) {
        $card.off('click.rolodex');
        return _this.rollBackwards.call(_this, $card, event);
      };
    })(this));
  };

  Rolodex.prototype._repositionList = function() {
    return this.scrollBox.scrollTop(this.initialScrollTop);
  };

  Rolodex.prototype._collapseCard = function($cards) {
    var $card, card, i, len, results;
    if (!($cards != null ? $cards.length : void 0)) {
      return;
    }
    results = [];
    for (i = 0, len = $cards.length; i < len; i++) {
      card = $cards[i];
      $card = $(card);
      $card.addClass('collapse-card');
      results.push(this.element.trigger('updateCards', this._addClickOnCollapseCard($card)));
    }
    return results;
  };

  Rolodex.prototype._expandCard = function($cards, event) {
    var $card, card, i, len, results;
    if (!$cards) {
      return;
    }
    results = [];
    for (i = 0, len = $cards.length; i < len; i++) {
      card = $cards[i];
      $card = $(card);
      if ((event != null ? event.type : void 0) === "click") {
        $card.off('click.rolodex');
      }
      results.push($card.removeClass('collapse-card locked'));
    }
    return results;
  };

  Rolodex.prototype._unlockAndResetCard = function($card, event) {
    var collectionOfVisibleLockedCards, start;
    start = $card.index();
    collectionOfVisibleLockedCards = this.cards.locked.slice(start);
    collectionOfVisibleLockedCards.get().reverse();
    this._expandCard(collectionOfVisibleLockedCards, event);
    this._placeOpenCard(collectionOfVisibleLockedCards);
    if (this.element.find('.lock-box ol').css('transform') !== 'none' && this.cards.locked.length >= 3) {
      this._popLockedCards(collectionOfVisibleLockedCards.length);
    } else {
      this._popLockedCards(0);
    }
    if (this.cards.open.length > this.minLength) {
      return this._collapseCard(this.cards.open.slice(this.minLength));
    }
  };

  Rolodex.prototype._lockAndPlaceCard = function($card) {
    $card.addClass('collapse-card locked');
    this._placeLockedCard($card);
    if (this.cards.locked.length > 3) {
      this._pushLockedCard();
    }
    this._addClickOnLockedCard($card);
    return this._expandCard(this.cards.open.onlyCollapsed.first());
  };

  Rolodex.prototype._placeOpenCard = function($cards) {
    var scrollBoxList;
    scrollBoxList = this.scrollBox.find('ol');
    $cards.prependTo(scrollBoxList);
    return this.element.trigger('updateCards');
  };

  Rolodex.prototype._placeLockedCard = function($card) {
    this.lockBoxList.append($card);
    return this.element.trigger('updateCards');
  };

  Rolodex.prototype._popLockedCards = function(collectionOfVisibleLockedCardsLength) {
    var animateToPoint;
    if (this.cards.locked.length > 2) {
      animateToPoint = (this.cards.locked.length - 3) * this.addressBottomHeight;
    } else {
      animateToPoint = 0;
    }
    return this.lockBoxList.css({
      'transform': 'translateY(' + animateToPoint + "px" + ')'
    });
  };

  Rolodex.prototype._pushLockedCard = function() {
    var animateToPoint;
    animateToPoint = (this.lockBoxList.find('.locked').length - 3) * this.addressBottomHeight;
    return this.lockBoxList.css({
      'transform': 'translateY(' + animateToPoint + "px" + ')'
    });
  };

  return Rolodex;

})();

_updateCards = function(cb) {
  this.cards = _.extend({}, this.cards, {
    open: _getOpenCards(this.cards),
    locked: _getLockedCards(this.cards)
  });
  if (typeof cb === 'function') {
    return cb();
  }
};

_getOpenCards = function($cards) {
  var openCards;
  openCards = $cards.filter('.scroll-box li:not(".locked, .all-locations")');
  return _.extend({}, openCards, {
    onlyCollapsed: openCards.filter('.collapse-card'),
    onlyExpanded: openCards.not('.collapse-card')
  });
};

_getLockedCards = function($cards) {
  var lockedCards;
  lockedCards = $cards.filter('.lock-box ol li.locked');
  return _.extend({}, lockedCards, {
    height: lockedCards.height()
  });
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],35:[function(require,module,exports){
var GMap, GMapDesktop2016V2Markers, GMapDesktop2016V2View, OldGMapView, _highlightMerchantLocationCard, _highlightMerchantPin,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../../frontend/helpers/events');
}

GMapDesktop2016V2Markers = require('../markers');

OldGMapView = require('../../../frontend/views/g_map');

module.exports = GMapDesktop2016V2View = (function(superClass) {
  extend(GMapDesktop2016V2View, superClass);

  function GMapDesktop2016V2View() {
    return GMapDesktop2016V2View.__super__.constructor.apply(this, arguments);
  }

  GMapDesktop2016V2View.prototype.events = {
    'mouseover .is-maps-v2': 'changeToDynamic'
  };

  GMapDesktop2016V2View.prototype.initialize = function() {
    GMapDesktop2016V2View.__super__.initialize.apply(this, arguments);
    this.Markers = GMapDesktop2016V2Markers;
    this.assignCardOrder();
    GMap.vent.on('clickedMerchantPin', (function(_this) {
      return function() {
        var index;
        index = arguments[0].index;
        return _this._handleMarkerClick(index);
      };
    })(this));
    return GMap.vent.on('mouseOverMerchantPin', (function(_this) {
      return function(arg) {
        var index;
        index = arg.index;
        index = Math.floor(index / 2);
        return _this.highlightSelectedMerchant({
          index: index,
          skipCentering: true
        });
      };
    })(this));
  };

  GMapDesktop2016V2View.prototype.start = function() {
    GMapDesktop2016V2View.__super__.start.apply(this, arguments);
    this.markerHandler.adjustMarkersPosition(this.activeMap, this.userMarkerData);
    this.markerHandler.addUserMarker(this.activeMap, this.userMarkerData);
    return this.googleMaps.event.addListenerOnce(this.activeMap, 'bounds_changed', (function(_this) {
      return function() {
        return _this.$el.find('.dynamic-map .merchant-location-card:not(".all-locations")').on('mouseover', function(event) {
          var card;
          if (_this.$el.attr('id') === 'merchant-info-map') {
            card = $(event.currentTarget);
            return _this.highlightSelectedMerchant({
              index: card.index()
            });
          }
        });
      };
    })(this));
  };

  GMapDesktop2016V2View.prototype.assignCardOrder = function() {
    var listLength;
    listLength = this.$locationsModal.find('.address-card').length;
    return this.$locationsModal.find('.merchant-location-card').css('z-index', function(i) {
      return listLength - i;
    });
  };

  GMapDesktop2016V2View.prototype.changeToDynamic = function(event) {
    if ((event != null ? event.type : void 0) === 'mouseover') {
      this.$el.off('mouseover', '.is-maps-v2');
    }
    return GMapDesktop2016V2View.__super__.changeToDynamic.apply(this, arguments);
  };

  GMapDesktop2016V2View.prototype.highlightSelectedMerchant = function(options) {
    var index, skipCentering;
    if (options == null) {
      options = {};
    }
    index = options.index, skipCentering = options.skipCentering;
    if (index !== this.previousIndex) {
      _highlightMerchantPin.call(this, index);
      _highlightMerchantLocationCard.call(this, index);
      if (skipCentering == null) {
        this.reCenterMap(index);
      }
    }
    return this.previousIndex = index;
  };

  GMapDesktop2016V2View.prototype.showMerchantLocationsModal = function() {
    if (this.$el.find('.all-locations').length) {
      return GIG.Modal.open({
        id: 'locations'
      });
    }
  };

  GMapDesktop2016V2View.prototype.reCenterMap = function(index) {
    var activeMarkers, realIndex, ref, ref1;
    if (!((this.activeMap != null) && this.centeredMarkerIndex !== index)) {
      return;
    }
    activeMarkers = this.markerHandler.activeMarkers;
    realIndex = this.markerHandler.getRealIndex(index);
    this.activeMap.panTo({
      lat: (ref = activeMarkers[realIndex]) != null ? ref.position.lat() : void 0,
      lng: (ref1 = activeMarkers[realIndex]) != null ? ref1.position.lng() : void 0
    });
    this.activeMap.panBy(-162, 0);
    return this.centeredMarkerIndex = index;
  };

  GMapDesktop2016V2View.prototype._handleMarkerClick = function(index) {
    if (!this.shouldShowLocationsModal()) {
      index = Math.floor(index / 2);
      return this.reCenterMap(index);
    }
  };

  return GMapDesktop2016V2View;

})(OldGMapView);

_highlightMerchantLocationCard = function(index) {
  this.$el.find('.selected-location').removeClass('selected-location');
  return this.$el.find('.merchant-location-card:eq(' + index + ')').find('.address-top').addClass('selected-location');
};

_highlightMerchantPin = function(index) {
  if (this.markerHandler != null) {
    this.markerHandler.updateIcon(index, "SELECTED");
    return this.markerHandler.updateIcon(this.previousIndex, "DEFAULT");
  }
};



},{"../../../frontend/helpers/events":37,"../../../frontend/views/g_map":41,"../markers":33}],36:[function(require,module,exports){
var GMap, GMapDesktop2016V2Markers, GMapModalView, InlineMap, Rolodex,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../../frontend/helpers/events');
}

InlineMap = require('./g_map');

GMapDesktop2016V2Markers = require('../markers');

Rolodex = require('../rolodex');

module.exports = GMapModalView = (function(superClass) {
  extend(GMapModalView, superClass);

  function GMapModalView() {
    return GMapModalView.__super__.constructor.apply(this, arguments);
  }

  GMapModalView.prototype.events = {
    'click .location-modal-head': function(event) {
      return this.toggleRolodex(event);
    },
    'click .merchant-location-card': function(event) {
      var card, cards;
      card = $(event.currentTarget);
      cards = this.$el.find('.merchant-location-card');
      return this.highlightSelectedMerchant({
        index: cards.index(card)
      });
    }
  };

  GMapModalView.prototype._handleMarkerClick = function(index) {
    index = Math.floor(index / 2);
    this.reCenterMap(index);
    if (this.openCard !== index) {
      this.$el.find('.merchant-location-card').eq(index).click();
    }
    return this.openCard = index;
  };

  GMapModalView.prototype._handleStreetViewOpen = function() {
    var overlayItems, streetViewObject;
    streetViewObject = this.activeMap.getStreetView();
    overlayItems = this.$el.find('.merchant-location-cards, .location-modal-head');
    return this.googleMaps.event.addListener(streetViewObject, 'visible_changed', function() {
      if (streetViewObject.getVisible()) {
        return overlayItems.hide();
      } else {
        return overlayItems.show();
      }
    });
  };

  GMapModalView.prototype.initialize = function() {
    GMapModalView.__super__.initialize.apply(this, arguments);
    this.getLocationModalHead();
    return $('body').on("modal-open:locations", (function(_this) {
      return function() {
        return _this.rolodex = new Rolodex({
          $el: _this.$el.find('.merchant-cards-container'),
          minLength: 3,
          header: {
            offsetTop: _this.locationModalHead.offset().top,
            height: _this.locationModalHead.height()
          }
        });
      };
    })(this));
  };

  GMapModalView.prototype.start = function() {
    GMapModalView.__super__.start.apply(this, arguments);
    return this._handleStreetViewOpen();
  };

  GMapModalView.prototype.getLocationModalHead = function() {
    return this.locationModalHead = this.$el.find('.location-modal-head');
  };

  GMapModalView.prototype.toggleRolodex = function(event) {
    var arrow;
    event.preventDefault();
    arrow = $(event.currentTarget).find('a');
    if (arrow.hasClass('arrow-down')) {
      arrow.removeClass('arrow-down icon-arrow-down-large').addClass('arrow-up icon-arrow-up-large');
    } else {
      arrow.removeClass('arrow-up icon-arrow-up-large').addClass('arrow-down icon-arrow-down-large');
    }
    if (this.rolodex != null) {
      return this.rolodex.toggleVisibility(event);
    }
  };

  return GMapModalView;

})(InlineMap);



},{"../../../frontend/helpers/events":37,"../markers":33,"../rolodex":34,"./g_map":35}],37:[function(require,module,exports){
var vent;

if (window.GMap == null) {
  window.GMap = {};
}

GMap.vent = vent = _(Backbone.Events).clone();

module.exports = {
  vent: vent
};



},{}],38:[function(require,module,exports){
var GMapDesktop2016ModalView, GMapDesktop2016V2View, GMapView;

if (window.GMap == null) {
  window.GMap = {};
}

GMapView = require('./views/g_map');

GMapDesktop2016V2View = require('../desktop_2016/frontend/views/g_map');

GMapDesktop2016ModalView = require('../desktop_2016/frontend/views/g_map_modal.coffee');

GMap.init = function(arg, done) {
  var dynamicMaps, isDesktop2016V2, multipleLocations, staticMaps;
  dynamicMaps = arg.dynamicMaps, multipleLocations = arg.multipleLocations, staticMaps = arg.staticMaps, isDesktop2016V2 = arg.isDesktop2016V2;
  if (dynamicMaps == null) {
    return done();
  }
  if (isDesktop2016V2) {
    GMap.View = GMapDesktop2016V2View;
    GMap.ModalView = GMapDesktop2016ModalView;
  } else {
    GMap.View = GMapView;
  }
  return $(function() {
    var i, len, map;
    if (staticMaps != null ? staticMaps.shouldLazyLoadControls : void 0) {
      return DealContentLoader.addOnLoadHandler(function() {
        var i, len, map;
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          new GMap.View(_.extend(map, {
            staticMaps: staticMaps,
            isDesktop2016V2: isDesktop2016V2
          }));
        }
        return done();
      });
    } else {
      if (dynamicMaps[0].isDesktop2016V2) {
        new GMap.View(dynamicMaps[0]);
        if (dynamicMaps[1]) {
          new GMap.ModalView(dynamicMaps[1]);
        }
      } else {
        for (i = 0, len = dynamicMaps.length; i < len; i++) {
          map = dynamicMaps[i];
          new GMap.View(_.extend(map, {
            isDesktop2016V2: isDesktop2016V2
          }));
        }
      }
      return done();
    }
  });
};

module.exports = GMap;



},{"../desktop_2016/frontend/views/g_map":35,"../desktop_2016/frontend/views/g_map_modal.coffee":36,"./views/g_map":41}],39:[function(require,module,exports){
var GMapMarkers;

module.exports = GMapMarkers = function(googleMaps) {
  return {
    googleMaps: googleMaps,
    makeMarkers: function(markerData) {
      var i, icon, j, len, len1, locationMarker, marker, markerOptions, ref, results;
      this.markers = [];
      results = [];
      for (i = 0, len = markerData.length; i < len; i++) {
        marker = markerData[i];
        locationMarker = {
          currentIndex: 0,
          coloredMarkers: []
        };
        ref = marker.icons;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          icon = ref[j];
          markerOptions = {
            position: new this.googleMaps.LatLng(marker.lat, marker.lng),
            icon: {
              url: icon.url,
              scaledSize: marker.size ? new this.googleMaps.Size(marker.size.width, marker.size.height) : void 0
            }
          };
          locationMarker.coloredMarkers.push({
            color: icon.color,
            dynamicMarker: new this.googleMaps.Marker(markerOptions)
          });
        }
        results.push(this.markers.push(locationMarker));
      }
      return results;
    },
    createBounds: function(markers) {
      var bounds, i, len, marker, ref;
      bounds = new this.googleMaps.LatLngBounds();
      ref = markers || [];
      for (i = 0, len = ref.length; i < len; i++) {
        marker = ref[i];
        bounds.extend(marker.getPosition());
      }
      return bounds;
    },
    connectMapToMarkers: function(map, markers) {
      var i, len, marker, results;
      results = [];
      for (i = 0, len = markers.length; i < len; i++) {
        marker = markers[i];
        results.push(marker.setMap(map));
      }
      return results;
    },
    addMarkersToMap: function(map) {
      var i, len, marker, ref;
      this.activeMarkers = [];
      ref = this.markers;
      for (i = 0, len = ref.length; i < len; i++) {
        marker = ref[i];
        this.activeMarkers.push(marker.coloredMarkers[0].dynamicMarker);
      }
      this.connectMapToMarkers(map, this.activeMarkers);
      if (this.activeMarkers.length > 1) {
        this.bounds = this.createBounds(this.activeMarkers);
        return map.fitBounds(this.bounds);
      }
    }
  };
};



},{}],40:[function(require,module,exports){
module.exports = {
  DEFAULT: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"26px\" height=\"35px\" viewBox=\"0 0 26 35\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\"><feGaussianBlur stdDeviation=\"0\" in=\"SourceGraphic\"></feGaussianBlur></filter><path d=\"M12.496177,33.8176277 C12.6667598,34.1515519 13.3891213,33.9634064 13.4862172,33.7568413 C18.1770613,23.7773856 25.9999998,20.4762271 26,13.1482909 C26.0000002,5.88669035 20.1797017,0 13,0 C5.82029825,0 3.3179618e-16,5.88669035 0,13.1482909 C3.21086765e-16,20.7297783 7.38181369,23.8060127 12.496177,33.8176277 Z\" id=\"markerPath\"></path><mask id=\"markerMask\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"26\" height=\"34\" fill=\"white\"><use xlink:href=\"#markerPath\"></use></mask></defs><g id=\"marker\" transform=\"translate(-1.000000, -1.000000)\"><g id=\"markerSelected\" transform=\"translate(1.000000, 1.000000)\"><g><ellipse id=\"shadow\" fill=\"#75787B\" opacity=\"0.35\" filter=\"url(#filter-1)\" cx=\"13.0909091\" cy=\"33.9090909\" rx=\"5.45454545\" ry=\"1.09090909\"></ellipse><use id=\"marker\" stroke=\"#428610\" mask=\"url(#markerMask)\" stroke-width=\"3\" fill=\"#53A318\" xlink:href=\"#markerPath\"></use><text id=\"5\" font-size=\"13\" font-family=\"Roboto,Arial,sans-serif\" fill=\"#FFFFFF\"><tspan x=\"13\" y=\"13\" text-anchor=\"middle\" alignment-baseline=\"central\">MARKER_LABEL_PLACEHOLDER</tspan></text></g></g></g></svg>",
  SELECTED: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"26px\" height=\"35px\" viewBox=\"0 0 26 35\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\"><feGaussianBlur stdDeviation=\"0\" in=\"SourceGraphic\"></feGaussianBlur></filter><path d=\"M12.496177,33.8176277 C12.6667598,34.1515519 13.3891213,33.9634064 13.4862172,33.7568413 C18.1770613,23.7773856 25.9999998,20.4762271 26,13.1482909 C26.0000002,5.88669035 20.1797017,0 13,0 C5.82029825,0 3.3179618e-16,5.88669035 0,13.1482909 C3.21086765e-16,20.7297783 7.38181369,23.8060127 12.496177,33.8176277 Z\" id=\"markerPath\"></path><mask id=\"markerMask\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"26\" height=\"34\" fill=\"white\"><use xlink:href=\"#markerPath\"></use></mask></defs><g id=\"marker\" transform=\"translate(-1.000000, -1.000000)\"><g id=\"markerSelected\" transform=\"translate(1.000000, 1.000000)\"><g><ellipse id=\"shadow\" fill=\"#75787B\" opacity=\"0.35\" filter=\"url(#filter-1)\" cx=\"13.0909091\" cy=\"33.9090909\" rx=\"5.45454545\" ry=\"1.09090909\"></ellipse><use id=\"marker\" stroke=\"#428610\" mask=\"url(#markerMask)\" stroke-width=\"3\" fill=\"#FFFFFF\" xlink:href=\"#markerPath\"></use><text id=\"5\" font-size=\"13\" font-family=\"Roboto,Arial,sans-serif\" fill=\"#428610\"><tspan x=\"13\" y=\"13\" text-anchor=\"middle\" alignment-baseline=\"central\">MARKER_LABEL_PLACEHOLDER</tspan></text></g></g></g></svg>",
  USER: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg class=\"user_map_marker\" width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><circle id=\"path-1\" cx=\"368\" cy=\"1236\" r=\"8\"></circle><mask id=\"mask-2\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"-12\" y=\"-12\" width=\"40\" height=\"40\"><rect x=\"348\" y=\"1216\" width=\"40\" height=\"40\" fill=\"white\"></rect><use xlink:href=\"#path-1\" fill=\"black\"></use></mask><mask id=\"mask-3\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"-2\" y=\"-2\" width=\"20\" height=\"20\"><rect x=\"358\" y=\"1226\" width=\"20\" height=\"20\" fill=\"white\"></rect><use xlink:href=\"#path-1\" fill=\"black\"></use></mask></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-348.000000, -1216.000000)\"><g><use fill=\"#0093EA\" fill-rule=\"evenodd\" xlink:href=\"#path-1\"></use><use stroke-opacity=\"0.25\" stroke=\"#0093EA\" mask=\"url(#mask-2)\" stroke-width=\"24\" xlink:href=\"#path-1\"></use><use stroke=\"#FFFFFF\" mask=\"url(#mask-3)\" stroke-width=\"4\" xlink:href=\"#path-1\"></use></g></g></g></svg>",
  DEFAULT_LS: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"26px\" height=\"35px\" viewBox=\"0 0 26 35\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\"><feGaussianBlur stdDeviation=\"0\" in=\"SourceGraphic\"></feGaussianBlur></filter><path d=\"M12.496177,33.8176277 C12.6667598,34.1515519 13.3891213,33.9634064 13.4862172,33.7568413 C18.1770613,23.7773856 25.9999998,20.4762271 26,13.1482909 C26.0000002,5.88669035 20.1797017,0 13,0 C5.82029825,0 3.3179618e-16,5.88669035 0,13.1482909 C3.21086765e-16,20.7297783 7.38181369,23.8060127 12.496177,33.8176277 Z\" id=\"markerPath\"></path><mask id=\"markerMask\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"26\" height=\"34\" fill=\"white\"><use xlink:href=\"#markerPath\"></use></mask></defs><g id=\"marker\" transform=\"translate(-1.000000, -1.000000)\"><g id=\"markerSelected\" transform=\"translate(1.000000, 1.000000)\"><g><ellipse id=\"shadow\" fill=\"#75787B\" opacity=\"0.35\" filter=\"url(#filter-1)\" cx=\"13.0909091\" cy=\"33.9090909\" rx=\"5.45454545\" ry=\"1.09090909\"></ellipse><use id=\"marker\" stroke=\"#322C61\" mask=\"url(#markerMask)\" stroke-width=\"3\" fill=\"#544AA1\" xlink:href=\"#markerPath\"></use><text id=\"5\" font-size=\"13\" font-family=\"Roboto,Arial,sans-serif\" fill=\"#FFFFFF\"><tspan x=\"13\" y=\"13\" text-anchor=\"middle\" alignment-baseline=\"central\">MARKER_LABEL_PLACEHOLDER</tspan></text></g></g></g></svg>",
  SELECTED_LS: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><svg width=\"26px\" height=\"35px\" viewBox=\"0 0 26 35\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\"><feGaussianBlur stdDeviation=\"0\" in=\"SourceGraphic\"></feGaussianBlur></filter><path d=\"M12.496177,33.8176277 C12.6667598,34.1515519 13.3891213,33.9634064 13.4862172,33.7568413 C18.1770613,23.7773856 25.9999998,20.4762271 26,13.1482909 C26.0000002,5.88669035 20.1797017,0 13,0 C5.82029825,0 3.3179618e-16,5.88669035 0,13.1482909 C3.21086765e-16,20.7297783 7.38181369,23.8060127 12.496177,33.8176277 Z\" id=\"markerPath\"></path><mask id=\"markerMask\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"26\" height=\"34\" fill=\"white\"><use xlink:href=\"#markerPath\"></use></mask></defs><g id=\"marker\" transform=\"translate(-1.000000, -1.000000)\"><g id=\"markerSelected\" transform=\"translate(1.000000, 1.000000)\"><g><ellipse id=\"shadow\" fill=\"#75787B\" opacity=\"0.35\" filter=\"url(#filter-1)\" cx=\"13.0909091\" cy=\"33.9090909\" rx=\"5.45454545\" ry=\"1.09090909\"></ellipse><use id=\"marker\" stroke=\"#322C61\" mask=\"url(#markerMask)\" stroke-width=\"3\" fill=\"#FFFFFF\" xlink:href=\"#markerPath\"></use><text id=\"5\" font-size=\"13\" font-family=\"Roboto,Arial,sans-serif\" fill=\"#322C61\"><tspan x=\"13\" y=\"13\" text-anchor=\"middle\" alignment-baseline=\"central\">MARKER_LABEL_PLACEHOLDER</tspan></text></g></g></g></svg>"
};



},{}],41:[function(require,module,exports){
var GMap, GMapMarkers, GMapView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../frontend/helpers/events');
}

GMapMarkers = require('../markers');

GMapView = (function(superClass) {
  extend(GMapView, superClass);

  function GMapView() {
    return GMapView.__super__.constructor.apply(this, arguments);
  }

  GMapView.prototype.events = {
    'click .merchant-location-card, a': function() {
      return stopClickPropagation(event);
    },
    'click .static-map': 'changeToDynamic'
  };

  GMapView.prototype.Markers = GMapMarkers;

  GMapView.prototype.initialize = function() {
    var $body, ref;
    ref = this.options, this.mapOptions = ref.mapOptions, this.markerData = ref.markerData, this.staticMaps = ref.staticMaps, this.userMarkerData = ref.userMarkerData, this.isDesktop2016V2 = ref.isDesktop2016V2;
    $body = $(document.body);
    this.$locationsModal = $('#locations');
    this.$staticMap = this.$el.find('.static-map').add(this.$locationsModal.find('static-map'));
    this.$dynamicMap = this.$el.find('.dynamic-map').add(this.$locationsModal.find('dynamic-map'));
    GMap.vent.on('start', (function(_this) {
      return function() {
        return _this.start();
      };
    })(this));
    this.isLocationsPopupWasActivated = false;
    this.isDynamicMapsWasActivated = false;
    return $body.on("modal-open:locations", (function(_this) {
      return function() {
        return _this.onLocationsPopupOpen();
      };
    })(this));
  };

  GMapView.prototype.stopClickPropagation = function(event) {
    return event.stopPropagation();
  };

  GMapView.prototype.changeToDynamic = function() {
    Groupon.Utils.GoogleMaps.load(function(err) {
      if (err != null) {
        return;
      }
      return GMap.vent.trigger('start');
    });
    return false;
  };

  GMapView.prototype.shouldShowLocationsModal = function() {
    return this.$locationsModal.hasClass('show-modal');
  };

  GMapView.prototype.start = function() {
    var showLocationsModal;
    if (this.googleMaps == null) {
      this.googleMaps = window.google.maps;
    }
    showLocationsModal = this.shouldShowLocationsModal();
    if (!showLocationsModal) {
      this.$locationsModal.css({
        display: 'block',
        visibility: 'hidden'
      });
    }
    this.createDynamicMap(this.mapOptions);
    if (this.activeMap) {
      this.markerHandler = new this.Markers(this.googleMaps);
      this.markerHandler.makeMarkers(this.markerData);
      this.markerHandler.addMarkersToMap(this.activeMap);
      this.revealDynamicMap(showLocationsModal);
      if (!showLocationsModal) {
        this.$locationsModal.css({
          display: '',
          visibility: ''
        });
      }
      return this.isDynamicMapsWasActivated = true;
    }
  };

  GMapView.prototype.createDynamicMap = function(options) {
    var mapOptions;
    mapOptions = this.buildMapOptions(options);
    return this.activeMap = new this.googleMaps.Map(this.$dynamicMap[0], mapOptions);
  };

  GMapView.prototype.revealDynamicMap = function() {
    if (this.$dynamicMap == null) {
      return;
    }
    this.$dynamicMap.each(function() {
      var $dynamicMap, $mapLocationCards, $staticMap, cardsContainer;
      $dynamicMap = $(this);
      $staticMap = $dynamicMap.siblings('.static-map');
      cardsContainer = $staticMap.find('.merchant-cards-container');
      if (cardsContainer) {
        $mapLocationCards = cardsContainer;
      } else {
        $mapLocationCards = $staticMap.find('.merchant-location-cards');
      }
      if ($staticMap.length) {
        $dynamicMap.css({
          height: $staticMap.height(),
          width: $staticMap.width()
        });
      }
      if ($mapLocationCards.length) {
        return $mapLocationCards.appendTo($dynamicMap);
      }
    });
    this.$staticMap.off('click');
    this.$staticMap.hide();
    return this.$dynamicMap.show();
  };

  GMapView.prototype.buildMapOptions = function(mapOptions) {
    mapOptions.center = new this.googleMaps.LatLng(mapOptions.center.lat, mapOptions.center.lng);
    mapOptions.mapTypeId = this.googleMaps.MapTypeId.ROADMAP;
    return mapOptions;
  };

  GMapView.prototype.onLocationsPopupOpen = function() {
    if (!this.isLocationsPopupWasActivated && this.isDynamicMapsWasActivated) {
      this.isLocationsPopupWasActivated = true;
      GMap.vent.once('start', (function(_this) {
        return function() {
          return _this.start();
        };
      })(this));
      return this.changeToDynamic();
    }
  };

  return GMapView;

})(Backbone.View);

module.exports = GMapView;



},{"../../frontend/helpers/events":37,"../markers":39}],42:[function(require,module,exports){
var GMapResponsiveMarkers, SVG_INLINE;

SVG_INLINE = require('../../frontend/svgs');

module.exports = GMapResponsiveMarkers = (function() {
  function GMapResponsiveMarkers(googleMaps) {
    this.googleMaps = googleMaps;
  }

  GMapResponsiveMarkers.prototype.makeSVGString = function(type, text) {
    return "data:image/svg+xml;utf-8," + encodeURIComponent(SVG_INLINE[type].split('MARKER_LABEL_PLACEHOLDER').join(text));
  };

  GMapResponsiveMarkers.prototype.makeMarkers = function(markerData) {
    var baseMarkerOptions, defaultMarker, defaultMarkerOptions, i, isGroupon, len, marker, results, selectedMarker, selectedMarkerOptions, userMarker, userMarkerOptions;
    this.activeMarkers = [];
    this.nearbyLocationsCount = 0;
    results = [];
    for (i = 0, len = markerData.length; i < len; i++) {
      marker = markerData[i];
      if (marker.isNearbyLocation != null) {
        this.nearbyLocationsCount = this.nearbyLocationsCount + marker.isNearbyLocation;
      }
      baseMarkerOptions = {
        optimized: false,
        position: new this.googleMaps.LatLng(marker.lat, marker.lng)
      };
      if (marker.label.type === "USER") {
        userMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: this.makeSVGString("USER", marker.label.text)
          }
        });
        userMarker = new this.googleMaps.Marker(userMarkerOptions);
        results.push(this.activeMarkers.push(userMarker));
      } else {
        isGroupon = !$('body').hasClass('brand-gemini') && !$('body').hasClass('brand-livingsocial');
        defaultMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: isGroupon ? this.makeSVGString("DEFAULT", marker.label.text) : this.makeSVGString("DEFAULT_LS", marker.label.text)
          },
          zIndex: 1
        });
        defaultMarker = new this.googleMaps.Marker(defaultMarkerOptions);
        this.activeMarkers.push(defaultMarker);
        selectedMarkerOptions = _.extend(baseMarkerOptions, {
          icon: {
            url: isGroupon ? this.makeSVGString("SELECTED", marker.label.text) : this.makeSVGString("SELECTED_LS", marker.label.text)
          },
          zIndex: marker.label.type === "SELECTED" || marker.label.type === "SELECTED_LS" ? 2 : 0
        });
        selectedMarker = new this.googleMaps.Marker(selectedMarkerOptions);
        results.push(this.activeMarkers.push(selectedMarker));
      }
    }
    return results;
  };

  GMapResponsiveMarkers.prototype.addMarkersToMap = function(map) {
    var firstMarkerPosition, i, len, marker, ref;
    ref = this.activeMarkers;
    for (i = 0, len = ref.length; i < len; i++) {
      marker = ref[i];
      marker.setMap(map);
    }
    firstMarkerPosition = this.activeMarkers[0].getPosition();
    return map.setCenter(firstMarkerPosition);
  };

  GMapResponsiveMarkers.prototype.updateIcon = function(index, svgType) {
    var realIndex, ref;
    realIndex = this.getRealIndex(index);
    return (ref = this.activeMarkers[realIndex]) != null ? ref.setZIndex(svgType === "SELECTED" ? 2 : 0) : void 0;
  };

  GMapResponsiveMarkers.prototype.getRealIndex = function(index) {
    var realIndex;
    return realIndex = index * 2 + 1;
  };

  return GMapResponsiveMarkers;

})();



},{"../../frontend/svgs":40}],43:[function(require,module,exports){
if (window.Gift == null) {
  window.Gift = {};
}

Gift.init = function(payload, done) {
  return $(function() {
    Gift.bindGiftButton();
    return done();
  });
};

Gift.bindGiftButton = function() {
  var $gift_button;
  $gift_button = $('.gift-button');
  if ($gift_button.length > 0) {
    return $gift_button.on('click', function(e) {
      e.preventDefault();
      Gift.createCookie();
      BuyButton.view.giftButtonClicked = true;
      return BuyButton.eventBus.go('buy_button_clicked');
    });
  }
};

Gift.createCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.set('modalForGiftOnLoad', 'true', 60, cookieDomain);
  return Gift.cookieCreated = true;
};

Gift.removeCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.unset('modalForGiftOnLoad', cookieDomain);
  return Gift.cookieCreated = false;
};

module.exports = Gift;



},{}],44:[function(require,module,exports){
(function (global){
var each, extend, find, getBuyUrlWithShippingOptionData, getRedemptionLocationsFromResponse, map, mergeRedemptionLocationInfo, omit, ref;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), each = ref.each, extend = ref.extend, find = ref.find, map = ref.map, omit = ref.omit;

mergeRedemptionLocationInfo = function(optionIdMap, redemptionLocationMap) {
  var id, optionWithRedemptionLocation, shippingOption;
  if (!optionIdMap) {
    return {};
  }
  for (id in optionIdMap) {
    shippingOption = optionIdMap[id];
    optionWithRedemptionLocation = find(shippingOption, function(option) {
      var ref1;
      return (ref1 = option.redemptionLocations) != null ? ref1.length : void 0;
    });
    each(optionWithRedemptionLocation != null ? optionWithRedemptionLocation.redemptionLocations : void 0, function(location) {
      return extend(location, omit(redemptionLocationMap[location.id], 'id', 'uuid'));
    });
  }
  return optionIdMap;
};

getBuyUrlWithShippingOptionData = function(buyUrl, shippingOptionData) {
  var key, params, value;
  params = [];
  for (key in shippingOptionData) {
    value = shippingOptionData[key];
    if (value) {
      params.push(key + "=" + value);
    }
  }
  return "" + buyUrl + (buyUrl.indexOf('?') > -1 ? '&' : '?') + (params.join('&'));
};

getRedemptionLocationsFromResponse = function(response, variantId) {
  var optionIdMap, optionWithRedemptionLocation, redemptionLocationMap, ref1, shippingOptions;
  if (response == null) {
    response = {};
  }
  optionIdMap = response.optionIdMap, redemptionLocationMap = response.redemptionLocationMap;
  if (!(optionIdMap && redemptionLocationMap)) {
    return [];
  }
  shippingOptions = optionIdMap[variantId];
  optionWithRedemptionLocation = find(shippingOptions, function(option) {
    var ref1;
    return (ref1 = option.redemptionLocations) != null ? ref1.length : void 0;
  });
  if (!(optionWithRedemptionLocation != null ? (ref1 = optionWithRedemptionLocation.redemptionLocations) != null ? ref1.length : void 0 : void 0)) {
    return [];
  }
  return map(optionWithRedemptionLocation.redemptionLocations, function(location) {
    return extend({}, location, omit(redemptionLocationMap[location.id], 'id', 'uuid'));
  });
};

module.exports = {
  mergeRedemptionLocationInfo: mergeRedemptionLocationInfo,
  getBuyUrlWithShippingOptionData: getBuyUrlWithShippingOptionData,
  getRedemptionLocationsFromResponse: getRedemptionLocationsFromResponse
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],45:[function(require,module,exports){
var generateBundleCheckoutUrl, getFirstWarrantyOption;

getFirstWarrantyOption = function(optionUuid, dealOptionWarranties) {
  var ref;
  if (dealOptionWarranties == null) {
    dealOptionWarranties = {};
  }
  return (ref = dealOptionWarranties[optionUuid]) != null ? ref[0] : void 0;
};

generateBundleCheckoutUrl = function(dealUuid, optionId, warrantyOption) {
  var warrantyDealUuid, warrantyOptionId;
  warrantyDealUuid = warrantyOption.warrantyDealUuid, warrantyOptionId = warrantyOption.warrantyOptionId;
  return "/checkout/bundle?type=warranty&items=" + dealUuid + ":" + optionId + "," + warrantyDealUuid + ":" + warrantyOptionId;
};

module.exports = {
  getFirstWarrantyOption: getFirstWarrantyOption,
  generateBundleCheckoutUrl: generateBundleCheckoutUrl
};



},{}],46:[function(require,module,exports){
var GoodsWarranty;

GoodsWarranty = window.GoodsWarranty != null ? window.GoodsWarranty : window.GoodsWarranty = {};

if (GoodsWarranty.View == null) {
  GoodsWarranty.View = require('./views/goods_warranty');
}

GoodsWarranty.init = function(arg, done) {
  var buyButton, goodsWarranty;
  buyButton = arg.buyButton, goodsWarranty = arg.goodsWarranty;
  if (goodsWarranty == null) {
    return done();
  }
  return $(function() {
    new GoodsWarranty.View({
      buyButton: buyButton,
      goodsWarranty: goodsWarranty
    });
    return done();
  });
};

module.exports = GoodsWarranty;



},{"./views/goods_warranty":47}],47:[function(require,module,exports){
var DealEventPipe, GoodsWarranty;

GoodsWarranty = window.GoodsWarranty != null ? window.GoodsWarranty : window.GoodsWarranty = {};

if (GoodsWarranty.Helpers == null) {
  GoodsWarranty.Helpers = require('../../../goods_warranty/common/helpers');
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

GoodsWarranty.View = Backbone.View.extend({
  el: '.goods-warranty',
  initialize: function(arg) {
    var buyButton, goodsWarranty;
    buyButton = arg.buyButton, goodsWarranty = arg.goodsWarranty;
    this.bundleCheckoutUrl = goodsWarranty.bundleCheckoutUrl, this.dealOptionWarranties = goodsWarranty.dealOptionWarranties, this.showMultiOptionBreakout = goodsWarranty.showMultiOptionBreakout, this.warrantyMessage = goodsWarranty.warrantyMessage;
    this.buyButtonUrl = buyButton != null ? buyButton.buyButtonUrl : void 0;
    this.initializeWarrantyOption();
    this.initializeWarrantyModal();
    return DealEventPipe.on('goodsWarrantyUpdate', (function(_this) {
      return function(data) {
        if (data == null) {
          data = {};
        }
        _this.optionInfo = data;
        _this.buyButtonUrl = data.buyUrl;
        _this.bundleCheckoutUrl = _this.getBundleCheckoutUrl();
        _this.updateWarrantyOption();
        return _this.updateWarrantyModal();
      };
    })(this));
  },
  initializeWarrantyOption: function() {
    this.$buyButton = $('a.buy-button');
    this.$goodsWarrantyOption = $('.goods-warranty-option');
    this.$warrantyMessage = this.$el.find('.warranty-option-message');
    this.$goodsWarrantyOption.prop('checked', false);
    return this.$goodsWarrantyOption.click((function(_this) {
      return function(e) {
        return _this.updateWarrantyCheckboxState($(e.target).prop('checked'));
      };
    })(this));
  },
  initializeWarrantyModal: function() {
    this.$warrantyModal = $('#goods-warranty-modal');
    this.$warrantyModalTitle = this.$warrantyModal.find('.warranty-option-message');
    this.$detailsLink = this.$warrantyModal.find('.details-link');
    this.$finePrint = this.$warrantyModal.find('.fine-print-messages');
    this.$noThanks = this.$warrantyModal.find('.no-thanks');
    this.$addProtection = this.$warrantyModal.find('.add-protection');
    this.$detailsLink.click((function(_this) {
      return function() {
        _this.$finePrint.toggle();
        return _this.$detailsLink.toggle();
      };
    })(this));
    this.$noThanks.click((function(_this) {
      return function() {
        return _this.updateWarrantyCheckboxState(false);
      };
    })(this));
    return this.$addProtection.click((function(_this) {
      return function() {
        return _this.updateWarrantyCheckboxState(true);
      };
    })(this));
  },
  getBundleCheckoutUrl: function() {
    var dealUuid, id, ref, uuid, warrantyOption;
    ref = this.optionInfo, dealUuid = ref.dealUuid, id = ref.id, uuid = ref.uuid;
    if (!(warrantyOption = GoodsWarranty.Helpers.getFirstWarrantyOption(uuid, this.dealOptionWarranties))) {
      return;
    }
    return GoodsWarranty.Helpers.generateBundleCheckoutUrl(dealUuid, id, warrantyOption);
  },
  toggleWarrantyCheckbox: function() {
    var ref;
    if (this.showMultiOptionBreakout) {
      return this.updateBuyButtonUrl();
    }
    if ((ref = this.optionInfo) != null ? ref.variationsSelected : void 0) {
      return DealEventPipe.trigger('priceUpdate', this.optionInfo);
    }
  },
  updateBuyButtonUrl: function() {
    var buyButtonUrl;
    buyButtonUrl = this.$goodsWarrantyOption.prop('checked') ? this.bundleCheckoutUrl : this.buyButtonUrl;
    if (buyButtonUrl != null ? buyButtonUrl.length : void 0) {
      return this.$buyButton.attr('href', buyButtonUrl);
    }
  },
  updateWarrantyCheckboxState: function(state) {
    this.$goodsWarrantyOption.prop('checked', state);
    return this.toggleWarrantyCheckbox();
  },
  updateWarrantyModal: function() {
    var ref;
    this.$warrantyModal.removeClass('replacement-plan-selected repair-plan-selected').addClass((ref = this.warrantyOption) != null ? ref.selectedCssClass : void 0);
    return this.$warrantyModalTitle.html(this.warrantyMessage);
  },
  updateWarrantyOption: function() {
    var ref, ref1;
    this.warrantyOption = GoodsWarranty.Helpers.getFirstWarrantyOption((ref = this.optionInfo) != null ? ref.uuid : void 0, this.dealOptionWarranties);
    this.warrantyMessage = (ref1 = this.warrantyOption) != null ? ref1.warrantyMessage : void 0;
    this.$warrantyMessage.html(this.warrantyMessage);
    return this.$el.toggleClass('close', this.warrantyMessage == null);
  }
});

module.exports = GoodsWarranty.View;



},{"../../../deal/frontend/event_pipe":21,"../../../goods_warranty/common/helpers":45}],48:[function(require,module,exports){
var getMedia, loadVideoScripts, prepareCarouselOptions, ref, setVideoLoaderFlags;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.carouselViews = {};

DealCarousel.dealMedia = {};

DealCarousel.current = {};

ref = DealCarousel.Helpers, getMedia = ref.getMedia, prepareCarouselOptions = ref.prepareCarouselOptions, setVideoLoaderFlags = ref.setVideoLoaderFlags, loadVideoScripts = ref.loadVideoScripts;

DealCarousel.init = function(arg, done) {
  var carousel, carouselOptions, currentCarouselView, currentDealMedia, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return typeof done === "function" ? done() : void 0;
  }
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  if (this.i18n == null) {
    this.i18n = I18n.scoped('modules.groupon-deal-carousel');
  }
  this.dealMedia[dealId] = currentDealMedia = new Backbone.Collection(media, {
    model: DealCarousel.Media
  });
  this.current.currentDealMedia = currentDealMedia;
  carouselOptions = prepareCarouselOptions(carousel, currentDealMedia, featuredImage, this.i18n);
  this.carouselViews[dealId] = currentCarouselView = new DealCarousel.View(carouselOptions);
  this.current.currentCarouselView = currentCarouselView;
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  if (carouselOptions.lazyLoadFeaturedImage) {
    $(window).load((function(_this) {
      return function() {
        loadVideoScripts(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
        return currentCarouselView.render();
      };
    })(this));
    return typeof done === "function" ? done() : void 0;
  } else {
    return $((function(_this) {
      return function() {
        loadVideoScripts(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
        currentCarouselView.render();
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  }
};

DealCarousel.onImageLoaded = function() {
  var $featuredContainer, ref1, ref2;
  $featuredContainer = ((ref1 = this.current) != null ? (ref2 = ref1.currentCarouselView) != null ? ref2.$featuredContainer : void 0 : void 0) || $('.featured-image-container');
  $featuredContainer.removeClass('preload');
  return this.current.currentCarouselView.setFeaturedHeight();
};

DealCarousel.updateCurrent = function(arg) {
  var carousel, carouselOptions, dealId, enabled, featuredImage, loadKaltura, loadOoyala, loadYoutube, media, ref1, ref2, showVideos;
  carousel = arg.carousel, featuredImage = arg.featuredImage;
  if (!(this.current.currentDealMedia && this.current.currentCarouselView)) {
    return;
  }
  dealId = carousel.dealId, enabled = carousel.enabled;
  if (!enabled) {
    return;
  }
  delete this.dealMedia[this.current.currentDealMedia.uuid];
  delete this.carouselViews[this.current.currentDealMedia.uuid];
  ref1 = getMedia(carousel), media = ref1.media, showVideos = ref1.showVideos;
  this.current.currentDealMedia.reset(media, {
    model: DealCarousel.Media
  });
  carouselOptions = prepareCarouselOptions(carousel, this.current.currentDealMedia, featuredImage, this.i18n);
  this.current.currentCarouselView.options = carouselOptions;
  this.current.currentCarouselView.initialize();
  this.current.currentCarouselView.updateCollection(this.current.currentDealMedia);
  ref2 = setVideoLoaderFlags(showVideos, carousel), loadKaltura = ref2.loadKaltura, loadOoyala = ref2.loadOoyala, loadYoutube = ref2.loadYoutube;
  return $((function(_this) {
    return function() {
      return loadVideoScripts(carousel, _this.current.currentCarouselView, loadKaltura, loadOoyala, loadYoutube);
    };
  })(this));
};



},{}],49:[function(require,module,exports){
if (window.DetectFlash == null) {
  window.DetectFlash = {};
}

DetectFlash.hasFlash = swfobject.hasFlashPlayerVersion('1');



},{}],50:[function(require,module,exports){
var DEFAULT_EL;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DEFAULT_EL = '.featured-image';

DealCarousel.Helpers = {
  getMedia: function(carousel) {
    var dealImages, dealVideos, forceVideos, media, showVideos, videoPosition;
    dealImages = carousel.dealImages, forceVideos = carousel.forceVideos, dealVideos = carousel.dealVideos, videoPosition = carousel.videoPosition;
    media = dealImages.slice(0);
    showVideos = forceVideos || DetectFlash.hasFlash || !!(typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.video : void 0);
    if (showVideos && (dealVideos != null ? dealVideos.length : void 0) > 0) {
      media.splice(videoPosition, 0, dealVideos[0]);
    }
    return {
      media: media,
      showVideos: showVideos
    };
  },
  prepareCarouselOptions: function(carousel, currentDealMedia, featuredImage, i18n) {
    var badge, carouselOptions, dealId, el, imageQuality, imageZoom, lazyLoadFeaturedImage, lazyLoadThumbs, mediaHeight, prefetchImages, shouldShowImageBadge, showThumbs;
    dealId = carousel.dealId, el = carousel.el, imageQuality = carousel.imageQuality, imageZoom = carousel.imageZoom, mediaHeight = carousel.mediaHeight, prefetchImages = carousel.prefetchImages, showThumbs = carousel.showThumbs, lazyLoadThumbs = carousel.lazyLoadThumbs, shouldShowImageBadge = carousel.shouldShowImageBadge, badge = carousel.badge, lazyLoadFeaturedImage = carousel.lazyLoadFeaturedImage;
    carouselOptions = {
      collection: currentDealMedia,
      el: el || DEFAULT_EL,
      imageQuality: imageQuality,
      imageZoom: imageZoom,
      mediaHeight: mediaHeight,
      prefetchImages: prefetchImages,
      showThumbs: showThumbs,
      uuid: dealId,
      lazyLoadThumbs: lazyLoadThumbs,
      shouldShowImageBadge: shouldShowImageBadge,
      badge: badge,
      lazyLoadFeaturedImage: lazyLoadFeaturedImage
    };
    if (imageZoom) {
      carouselOptions.imageZoom.hoverZoomText = i18n.t('.hoverToZoom');
    }
    if (featuredImage != null) {
      carouselOptions.featured = currentDealMedia.findWhere({
        baseURL: featuredImage
      });
    }
    return carouselOptions;
  },
  setVideoLoaderFlags: function(showVideos, carousel) {
    var i, len, loadKaltura, loadOoyala, loadYoutube, ref, video;
    loadKaltura = false;
    loadOoyala = false;
    loadYoutube = false;
    if (showVideos && ((typeof kWidget === "undefined" || kWidget === null) || (typeof OO === "undefined" || OO === null) || (typeof YT === "undefined" || YT === null))) {
      ref = carousel.dealVideos || [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        if (!loadKaltura && video.provider === "KALTURA") {
          loadKaltura = true;
        }
        if (!loadOoyala && video.provider === "OOYALA") {
          loadOoyala = true;
        }
        if (!loadYoutube && video.provider === "YOUTUBE") {
          loadYoutube = true;
        }
      }
    }
    return {
      loadKaltura: loadKaltura,
      loadOoyala: loadOoyala,
      loadYoutube: loadYoutube
    };
  },
  loadVideoScripts: function(carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube) {
    if (loadKaltura && (typeof kWidget === "undefined" || kWidget === null)) {
      $.getScript(carousel.kalturaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "KALTURA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadOoyala && (typeof OO === "undefined" || OO === null)) {
      $.getScript(carousel.ooyalaScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "OOYALA"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
    if (loadYoutube && (typeof YT === "undefined" || YT === null)) {
      return $.getScript(carousel.youtubeScriptUrl).fail(function() {
        currentCarouselView.collection.remove(currentCarouselView.collection.where({
          provider: "YOUTUBE"
        }));
        if (!(currentCarouselView.collection.classes.indexOf('script-load-fail') > -1)) {
          currentCarouselView.collection.classes += ' script-load-fail';
        }
        return currentCarouselView.render();
      });
    }
  }
};



},{}],51:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.Media = Backbone.Model.extend({
  initialize: function(arg) {
    var ref;
    ref = arg != null ? arg : {}, this.id = ref.id, this.type = ref.type, this.media = ref.media, this.thumb = ref.thumb, this.zoom = ref.zoom, this.provider = ref.provider, this.baseURL = ref.baseURL, this.alt = ref.alt;
    return this.id != null ? this.id : this.id = this.cid;
  },
  isFeatured: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.view.currentFeatured : void 0) === this;
  },
  isLast: function() {
    var ref;
    return ((ref = this.collection) != null ? ref.last() : void 0) === this;
  },
  isVideo: function() {
    return this.type === "video";
  }
});



},{}],52:[function(require,module,exports){
window.swfobject = (function() {
  var EXPRESS_INSTALL_ID, FLASH_MIME_TYPE, OBJECT, ON_READY_STATE_CHANGE, SHOCKWAVE_FLASH, SHOCKWAVE_FLASH_AX, UNDEF, abstractAltContent, addDomLoadEvent, addListener, addLoadEvent, autoHideShow, callDomLoadFunctions, canExpressInstall, cleanup, createCSS, createElement, createObjParam, createSWF, displayAltContent, doc, domLoadFnArr, dynamicStylesheet, dynamicStylesheetMedia, getElementById, getObjectById, hasPlayerVersion, isDomLoaded, isExpressInstallActive, listenersArr, main, matchVersions, nav, objIdArr, onDomLoad, plugin, regObjArr, removeObjectInIE, removeSWF, setVisibility, showExpressInstall, storedAltContent, storedAltContentId, storedCallbackFn, storedCallbackObj, testPlayerVersion, ua, urlEncodeIfNecessary, win;
  UNDEF = "undefined";
  OBJECT = "object";
  SHOCKWAVE_FLASH = "Shockwave Flash";
  SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash";
  FLASH_MIME_TYPE = "application/x-shockwave-flash";
  EXPRESS_INSTALL_ID = "SWFObjectExprInst";
  ON_READY_STATE_CHANGE = "onreadystatechange";
  win = window;
  doc = document;
  nav = navigator;
  plugin = false;
  regObjArr = [];
  objIdArr = [];
  listenersArr = [];
  isDomLoaded = false;
  isExpressInstallActive = false;
  autoHideShow = true;
  storedAltContent = storedAltContentId = storedCallbackFn = storedCallbackObj = dynamicStylesheet = dynamicStylesheetMedia = null;
  callDomLoadFunctions = function() {
    var dl, dlFn, e, i, len, ref, results, t, w;
    if (isDomLoaded) {
      return;
    }
    try {
      t = doc.getElementsByTagName("body")[0].appendChild(createElement("span"));
      t.parentNode.removeChild(t);
    } catch (error) {
      e = error;
      return;
    }
    isDomLoaded = true;
    dl = domLoadFnArr;
    ref = domLoadFnArr || [];
    results = [];
    for (i = w = 0, len = ref.length; w < len; i = ++w) {
      dlFn = ref[i];
      results.push(dlFn());
    }
    return results;
  };
  addDomLoadEvent = function(fn) {
    if (isDomLoaded) {
      return fn();
    } else {
      return domLoadFnArr[domLoadFnArr.length] = fn;
    }
  };
  addLoadEvent = function(fn) {
    var fnOld;
    if (typeof win.addEventListener !== UNDEF) {
      return win.addEventListener("load", fn, false);
    } else if (typeof doc.addEventListener !== UNDEF) {
      return doc.addEventListener("load", fn, false);
    } else if (typeof win.attachEvent !== UNDEF) {
      return addListener(win, "onload", fn);
    } else if (typeof win.onload === "function") {
      fnOld = win.onload;
      return win.onload = function() {
        fnOld();
        return fn();
      };
    } else {
      return win.onload = fn;
    }
  };
  main = function() {
    if (plugin) {
      return testPlayerVersion();
    } else {
      return matchVersions();
    }
  };
  domLoadFnArr = [main];
  testPlayerVersion = function() {
    var b, counter, o, t;
    b = doc.getElementsByTagName("body")[0];
    o = createElement(OBJECT);
    o.setAttribute("type", FLASH_MIME_TYPE);
    t = b.appendChild(o);
    if (t) {
      counter = 0;
      return (function() {
        var d;
        if (typeof t.GetVariable !== UNDEF) {
          d = t.GetVariable("$version");
          if (d) {
            d = d.split(" ")[1].split(",");
            ua.pv = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        } else if (counter < 10) {
          counter++;
          setTimeout(arguments.callee, 10);
          return;
        }
        b.removeChild(o);
        t = null;
        return matchVersions();
      })();
    } else {
      return matchVersions();
    }
  };
  matchVersions = function() {
    var att, cb, cbObj, i, id, len, len1, o, obj, p, pair, par, pl, ref, regObj, results, rl, w, x;
    rl = regObjArr.length;
    if (regObjArr.length) {
      results = [];
      for (i = w = 0, len = regObjArr.length; w < len; i = ++w) {
        regObj = regObjArr[i];
        id = regObj.id;
        cb = regObj.callbackFn;
        cbObj = {
          success: false,
          id: id
        };
        if (ua.pv[0] > 0) {
          obj = getElementById(id);
          if (obj) {
            if (hasPlayerVersion(regObj.swfVersion) && !(ua.wk && ua.wk < 312)) {
              setVisibility(id, true);
              if (cb) {
                cbObj.success = true;
                cbObj.ref = getObjectById(id);
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            } else if (regObj.expressInstall && canExpressInstall()) {
              att = {};
              att.data = regObj.expressInstall;
              att.width = obj.getAttribute("width") || "0";
              att.height = obj.getAttribute("height") || "0";
              if (obj.getAttribute("class")) {
                att.styleclass = obj.getAttribute("class");
              }
              if (obj.getAttribute("align")) {
                att.align = obj.getAttribute("align");
              }
              par = {};
              p = obj.getElementsByTagName("param");
              pl = p.length;
              ref = p || [];
              for (x = 0, len1 = ref.length; x < len1; x++) {
                pair = ref[x];
                if (pair.getAttribute("name").toLowerCase() !== "movie") {
                  par[pair.getAttribute("name")] = pair.getAttribute("value");
                }
              }
              results.push(showExpressInstall(att, par, id, cb));
            } else {
              displayAltContent(obj);
              if (cb) {
                results.push(cb(cbObj));
              } else {
                results.push(void 0);
              }
            }
          } else {
            results.push(void 0);
          }
        } else {
          setVisibility(id, true);
          if (cb) {
            o = getObjectById(id);
            if (o && typeof o.SetVariable !== UNDEF) {
              cbObj.success = true;
              cbObj.ref = o;
            }
            results.push(cb(cbObj));
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    }
  };
  getObjectById = function(objectIdStr) {
    var n, o, r;
    r = null;
    o = getElementById(objectIdStr);
    if (o && o.nodeName === "OBJECT") {
      if (typeof o.SetVariable !== UNDEF) {
        r = o;
      } else {
        n = o.getElementsByTagName(OBJECT)[0];
        if (n) {
          r = n;
        }
      }
    }
    return r;
  };
  canExpressInstall = function() {
    return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312);
  };
  showExpressInstall = function(att, par, replaceElemIdStr, callbackFn) {
    var fv, newObj, obj, pt;
    isExpressInstallActive = true;
    storedCallbackFn = callbackFn || null;
    storedCallbackObj = {
      success: false,
      id: replaceElemIdStr
    };
    obj = getElementById(replaceElemIdStr);
    if (obj) {
      if (obj.nodeName === "OBJECT") {
        storedAltContent = abstractAltContent(obj);
        storedAltContentId = null;
      } else {
        storedAltContent = obj;
        storedAltContentId = replaceElemIdStr;
      }
      att.id = EXPRESS_INSTALL_ID;
      if (typeof att.width === UNDEF || (!/%$/.test(att.width) && parseInt(att.width, 10) < 310)) {
        att.width = "310";
      }
      if (typeof att.height === UNDEF || (!/%$/.test(att.height) && parseInt(att.height, 10) < 137)) {
        att.height = "137";
      }
      doc.title = doc.title.slice(0, 47) + " - Flash Player Installation";
      pt = ua.ie && ua.win ? "ActiveX" : "PlugIn";
      fv = "MMredirectURL=" + win.location.toString().replace(/&/g, "%26") + "&MMplayerType=" + pt + "&MMdoctitle=" + doc.title;
      if (typeof par.flashvars !== UNDEF) {
        par.flashvars += "&" + fv;
      } else {
        par.flashvars = fv;
      }
      if (ua.ie && ua.win && obj.readyState !== 4) {
        newObj = createElement("div");
        replaceElemIdStr += "SWFObjectNew";
        newObj.setAttribute("id", replaceElemIdStr);
        obj.parentNode.insertBefore(newObj, obj);
        obj.style.display = "none";
        (function() {
          if (obj.readyState === 4) {
            return obj.parentNode.removeChild(obj);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      }
      return createSWF(att, par, replaceElemIdStr);
    }
  };
  displayAltContent = function(obj) {
    var el;
    if (ua.ie && ua.win && obj.readyState !== 4) {
      el = createElement("div");
      obj.parentNode.insertBefore(el, obj);
      el.parentNode.replaceChild(abstractAltContent(obj), el);
      obj.style.display = "none";
      return (function() {
        if (obj.readyState === 4) {
          return obj.parentNode.removeChild(obj);
        } else {
          return setTimeout(arguments.callee, 10);
        }
      })();
    } else {
      return obj.parentNode.replaceChild(abstractAltContent(obj), obj);
    }
  };
  abstractAltContent = function(obj) {
    var ac, c, childNode, cl, len, nestedObj, w;
    ac = createElement("div");
    if (ua.win && ua.ie) {
      ac.innerHTML = obj.innerHTML;
    } else {
      nestedObj = obj.getElementsByTagName(OBJECT)[0];
      if (nestedObj) {
        c = nestedObj.childNodes;
        if (c) {
          cl = c.length;
          for (w = 0, len = c.length; w < len; w++) {
            childNode = c[w];
            if (!(childNode.nodeType === 1 && childNode.nodeName === "PARAM") && !(childNode.nodeType === 8)) {
              ac.appendChild(childNode.cloneNode(true));
            }
          }
        }
      }
    }
    return ac;
  };
  createSWF = function(attObj, parObj, id) {
    var att, el, i, j, m, n, o, par, r;
    r = void 0;
    el = getElementById(id);
    if (ua.wk && ua.wk < 312) {
      return r;
    }
    if (el) {
      if (typeof attObj.id === UNDEF) {
        attObj.id = id;
      }
      if (ua.ie && ua.win) {
        att = "";
        for (i in attObj) {
          if (attObj[i] !== Object.prototype[i]) {
            if (i.toLowerCase() === "data") {
              parObj.movie = attObj[i];
            } else if (i.toLowerCase() === "styleclass") {
              att += ' class="' + attObj[i] + '"';
            } else if (i.toLowerCase() !== "classid") {
              att += ' ' + i + '="' + attObj[i] + '"';
            }
          }
        }
        par = "";
        for (j in parObj) {
          if (parObj[j] !== Object.prototype[j]) {
            par += '<param name="' + j + '" value="' + parObj[j] + '" />';
          }
        }
        el.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + att + '>' + par + '</object>';
        objIdArr[objIdArr.length] = attObj.id;
        r = getElementById(attObj.id);
      } else {
        o = createElement(OBJECT);
        o.setAttribute("type", FLASH_MIME_TYPE);
        for (m in attObj) {
          if (attObj[m] !== Object.prototype[m]) {
            if (m.toLowerCase() === "styleclass") {
              o.setAttribute("class", attObj[m]);
            } else if (m.toLowerCase() !== "classid") {
              o.setAttribute(m, attObj[m]);
            }
          }
        }
        for (n in parObj) {
          if (parObj[n] !== Object.prototype[n] && n.toLowerCase() !== "movie") {
            createObjParam(o, n, parObj[n]);
          }
        }
        el.parentNode.replaceChild(o, el);
        r = o;
      }
    }
    return r;
  };
  createObjParam = function(el, pName, pValue) {
    var p;
    p = createElement("param");
    p.setAttribute("name", pName);
    p.setAttribute("value", pValue);
    return el.appendChild(p);
  };
  removeSWF = function(id) {
    var obj;
    obj = getElementById(id);
    if (obj && obj.nodeName === "OBJECT") {
      if (ua.ie && ua.win) {
        obj.style.display = "none";
        return (function() {
          if (obj.readyState === 4) {
            return removeObjectInIE(id);
          } else {
            return setTimeout(arguments.callee, 10);
          }
        })();
      } else {
        return obj.parentNode.removeChild(obj);
      }
    }
  };
  removeObjectInIE = function(id) {
    var len, obj, thing, w;
    obj = getElementById(id);
    if (obj) {
      for (w = 0, len = obj.length; w < len; w++) {
        thing = obj[w];
        if (typeof thing === "function") {
          thing = null;
        }
      }
      return obj.parentNode.removeChild(obj);
    }
  };
  getElementById = function(id) {
    var e, el;
    el = null;
    try {
      el = doc.getElementById(id);
    } catch (error) {
      e = error;
    }
    return el;
  };
  createElement = function(el) {
    return doc.createElement(el);
  };
  addListener = function(target, eventType, fn) {
    target.attachEvent(eventType, fn);
    return listenersArr[listenersArr.length] = [target, eventType, fn];
  };
  hasPlayerVersion = function(rv) {
    var pv, ref, v;
    pv = ua.pv;
    v = rv.split(".");
    v[0] = parseInt(v[0], 10);
    v[1] = parseInt(v[1], 10) || 0;
    v[2] = parseInt(v[2], 10) || 0;
    return (ref = pv[0] > v[0] || (pv[0] === v[0] && pv[1] > v[1]) || (pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2])) != null ? ref : {
      "true": false
    };
  };
  createCSS = function(sel, decl, media, newStyle) {
    var h, m, ref, s;
    if (ua.ie && ua.mac) {
      return;
    }
    h = doc.getElementsByTagName("head")[0];
    if (!h) {
      return;
    }
    m = (ref = media && typeof media === "string") != null ? ref : {
      media: "screen"
    };
    if (newStyle) {
      dynamicStylesheet = null;
      dynamicStylesheetMedia = null;
    }
    if (!dynamicStylesheet || dynamicStylesheetMedia !== m) {
      s = createElement("style");
      s.setAttribute("type", "text/css");
      s.setAttribute("media", m);
      dynamicStylesheet = h.appendChild(s);
      if (ua.ie && ua.win && typeof doc.styleSheets !== UNDEF && doc.styleSheets.length > 0) {
        dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1];
      }
      dynamicStylesheetMedia = m;
    }
    if (ua.ie && ua.win) {
      if (dynamicStylesheet && typeof dynamicStylesheet.addRule === OBJECT) {
        return dynamicStylesheet.addRule(sel, decl);
      }
    } else {
      if (dynamicStylesheet && typeof doc.createTextNode !== UNDEF) {
        return dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"));
      }
    }
  };
  setVisibility = function(id, isVisible) {
    var v;
    if (!autoHideShow) {
      return;
    }
    v = isVisible != null ? isVisible : {
      "visible": "hidden"
    };
    if (isDomLoaded && getElementById(id)) {
      return getElementById(id).style.visibility = v;
    } else {
      return createCSS("#" + id, "visibility:" + v);
    }
  };
  urlEncodeIfNecessary = function(s) {
    var hasBadChars, regex;
    regex = /[\\\"<>\.;]/;
    hasBadChars = regex.exec(s) !== null;
    return hasBadChars && typeof encodeURIComponent !== (UNDEF ? encodeURIComponent(s) : s);
  };
  ua = (function() {
    var a, d, e, ie, mac, p, playerVersion, u, w3cdom, webkit, windows;
    w3cdom = typeof doc.getElementById !== UNDEF && typeof doc.getElementsByTagName !== UNDEF && typeof doc.createElement !== UNDEF;
    u = nav.userAgent.toLowerCase();
    p = nav.platform.toLowerCase();
    windows = p ? /win/.test(p) : /win/.test(u);
    mac = p ? /mac/.test(p) : /mac/.test(u);
    webkit = /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false;
    ie = !+"\v1";
    playerVersion = [0, 0, 0];
    d = null;
    if (typeof nav.plugins !== UNDEF && typeof nav.plugins[SHOCKWAVE_FLASH] === OBJECT) {
      d = nav.plugins[SHOCKWAVE_FLASH].description;
      if (d && !(typeof nav.mimeTypes !== UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) {
        plugin = true;
        ie = false;
        d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
        playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10);
        playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
        playerVersion[2] = /[a-zA-Z]/.test(d) ? parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
      }
    } else if (typeof win.ActiveXObject !== UNDEF) {
      try {
        a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
        if (a) {
          d = a.GetVariable("$version");
          if (d) {
            ie = true;
            d = d.split(" ")[1].split(",");
            playerVersion = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
          }
        }
      } catch (error) {
        e = error;
      }
    }
    return {
      w3: w3cdom,
      pv: playerVersion,
      wk: webkit,
      ie: ie,
      win: windows,
      mac: mac
    };
  })();
  onDomLoad = (function() {
    if (!ua.w3) {
      return;
    }
    if ((typeof doc.readyState !== UNDEF && doc.readyState === "complete") || (typeof doc.readyState === UNDEF && (doc.getElementsByTagName("body")[0] || doc.body))) {
      callDomLoadFunctions();
    }
    if (!isDomLoaded) {
      if (typeof doc.addEventListener !== UNDEF) {
        doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false);
      }
      if (ua.ie && ua.win) {
        doc.attachEvent(ON_READY_STATE_CHANGE, function() {
          if (doc.readyState === "complete") {
            doc.detachEvent(ON_READY_STATE_CHANGE, arguments.callee);
            return callDomLoadFunctions();
          }
        });
        if (win === top) {
          (function() {
            var e;
            if (isDomLoaded) {
              return;
            }
            try {
              doc.documentElement.doScroll("left");
            } catch (error) {
              e = error;
              setTimeout(arguments.callee, 0);
              return;
            }
            return callDomLoadFunctions();
          })();
        }
      }
      if (ua.wk) {
        (function() {
          if (isDomLoaded) {
            return;
          }
          if (!/loaded|complete/.test(doc.readyState)) {
            setTimeout(arguments.callee, 0);
            return;
          }
          return callDomLoadFunctions();
        })();
      }
      return addLoadEvent(callDomLoadFunctions);
    }
  })();
  cleanup = (function() {
    if (ua.ie && ua.win) {
      return window.attachEvent("onunload", function() {
        var k, l, len, len1, listener, obj, swfobject, w, x;
        for (w = 0, len = listenersArr.length; w < len; w++) {
          listener = listenersArr[w];
          listener[0].detachEvent(listener[1], listener[2]);
        }
        for (x = 0, len1 = objIdArr.length; x < len1; x++) {
          obj = objIdArr[x];
          removeSWF(obj);
        }
        for (k in ua) {
          ua[k] = null;
        }
        ua = null;
        for (l in swfobject) {
          swfobject[l] = null;
        }
        return swfobject = null;
      });
    }
  })();
  return {
    registerObject: function(objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) {
      var regObj;
      if (ua.w3 && objectIdStr && swfVersionStr) {
        regObj = {};
        regObj.id = objectIdStr;
        regObj.swfVersion = swfVersionStr;
        regObj.expressInstall = xiSwfUrlStr;
        regObj.callbackFn = callbackFn;
        regObjArr[regObjArr.length] = regObj;
        return setVisibility(objectIdStr, false);
      } else {
        return typeof callbackFn === "function" ? callbackFn({
          success: false,
          id: objectIdStr
        }) : void 0;
      }
    },
    getObjectById: function(objectIdStr) {
      if (ua.w3) {
        return getObjectById(objectIdStr);
      }
    },
    embedSWF: function(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
      var callbackObj;
      callbackObj = {
        success: false,
        id: replaceElemIdStr
      };
      if (ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
        setVisibility(replaceElemIdStr, false);
        return addDomLoadEvent(function() {
          var att, i, j, k, obj, par;
          widthStr += "";
          heightStr += "";
          att = {};
          if (attObj && typeof attObj === OBJECT) {
            for (i in attObj) {
              att[i] = attObj[i];
            }
          }
          att.data = swfUrlStr;
          att.width = widthStr;
          att.height = heightStr;
          par = {};
          if (parObj && typeof parObj === OBJECT) {
            for (j in parObj) {
              par[j] = parObj[j];
            }
          }
          if (flashvarsObj && typeof flashvarsObj === OBJECT) {
            for (k in flashvarsObj) {
              if (typeof par.flashvars !== UNDEF) {
                par.flashvars += "&" + k + "=" + flashvarsObj[k];
              } else {
                par.flashvars = k + "=" + flashvarsObj[k];
              }
            }
          }
          if (hasPlayerVersion(swfVersionStr)) {
            obj = createSWF(att, par, replaceElemIdStr);
            if (att.id === replaceElemIdStr) {
              setVisibility(replaceElemIdStr, true);
            }
            callbackObj.success = true;
            callbackObj.ref = obj;
          } else if (xiSwfUrlStr && canExpressInstall()) {
            att.data = xiSwfUrlStr;
            showExpressInstall(att, par, replaceElemIdStr, callbackFn);
            return;
          } else {
            setVisibility(replaceElemIdStr, true);
          }
          return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
        });
      } else {
        return typeof callbackFn === "function" ? callbackFn(callbackObj) : void 0;
      }
    },
    switchOffAutoHideShow: function() {
      return autoHideShow = false;
    },
    ua: ua,
    getFlashPlayerVersion: function() {
      return {
        major: ua.pv[0],
        minor: ua.pv[1],
        release: ua.pv[2]
      };
    },
    hasFlashPlayerVersion: hasPlayerVersion,
    createSWF: function(attObj, parObj, replaceElemIdStr) {
      if (ua.w3) {
        return createSWF(attObj, parObj, replaceElemIdStr);
      } else {
        return void 0;
      }
    },
    showExpressInstall: function(att, par, replaceElemIdStr, callbackFn) {
      if (ua.w3 && canExpressInstall()) {
        return showExpressInstall(att, par, replaceElemIdStr, callbackFn);
      }
    },
    removeSWF: function(objElemIdStr) {
      if (ua.w3) {
        return removeSWF(objElemIdStr);
      }
    },
    createCSS: function(selStr, declStr, mediaStr, newStyleBoolean) {
      if (ua.w3) {
        return createCSS(selStr, declStr, mediaStr, newStyleBoolean);
      }
    },
    addDomLoadEvent: addDomLoadEvent,
    addLoadEvent: addLoadEvent,
    getQueryParamValue: function(param) {
      var len, pair, pairs, q, w;
      q = doc.location.search || doc.location.hash;
      if (q) {
        if (/\?/.test(q)) {
          q = q.split("?")[1];
        }
        if (param === null) {
          return urlEncodeIfNecessary(q);
        }
        pairs = q.split("&");
        for (w = 0, len = pairs.length; w < len; w++) {
          pair = pairs[w];
          if (pair.substring(0, pair.indexOf("=")) === param) {
            return urlEncodeIfNecessary(pair.substring(pair.indexOf("=") + 1));
          }
        }
      }
      return "";
    },
    expressInstallCallback: function() {
      var obj;
      if (isExpressInstallActive) {
        obj = getElementById(EXPRESS_INSTALL_ID);
        if (obj && storedAltContent) {
          obj.parentNode.replaceChild(storedAltContent, obj);
          if (storedAltContentId) {
            setVisibility(storedAltContentId, true);
            if (ua.ie && ua.win) {
              storedAltContent.style.display = "block";
            }
          }
          if (storedCallbackFn) {
            storedCallbackFn(storedCallbackObj);
          }
        }
        return isExpressInstallActive = false;
      }
    }
  };
})();



},{}],53:[function(require,module,exports){
if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.CarouselTemplate = Hogan.compile('{{# renderFullCarousel }}\n  <div class="gallery {{ classes }}" data-bhw="PromNightGallery" data-bhc="PromNightGallery:{{ uuid }}">\n    <div class="gallery-featured">\n      {{# badge }}<div class="featured-badge" style="color: {{ textColor }}; background-color: {{ backgroundColor }}">{{ text }}</div>{{/ badge }}\n      <div class="click-blocker"></div>\n      {{# featured }}\n        {{# isVideo }}\n          <img src="http://cdnapi.kaltura.com/p/1302621/thumbnail/entry_id/{{ media }}/height/{{ collection.view.options.mediaHeight}}" id="gallery-video-{{ id }}" data-id="{{ id }}" />\n        {{/ isVideo }}\n        {{^ isVideo }}\n          <img {{# preload }}onload="DealCarousel.onImageLoaded()" {{/ preload }}class="init-no-animation" src="{{ media }}" id="gallery-image-{{ id }}" data-id="{{ id }}" alt="{{ alt }}"/>\n          {{# imageZoom }}<div class="zoom-in-image"></div>{{/ imageZoom }}\n        {{/ isVideo }}\n      {{/ featured }}\n    </div>\n\n    {{# imageZoom }}\n      <div class="image-zoom-message icon-plus" data-bhw="GoodsImageZoomMessage">{{ hoverZoomText }}</div>\n    {{/ imageZoom }}\n\n    {{# showThumbs }}\n      <ul class="gallery-thumbs">\n        {{# models }}\n          <li class="gallery-thumbnail{{# isFeatured }} selected c-bdr-prim{{/ isFeatured }}{{# isVideo }} video{{/ isVideo }}{{^ thumb }} no-thumbnail{{/ thumb }}{{# isLast }} last{{/ isLast }}" id="gallery-thumb-{{ id }}" data-id="{{ id }}" data-bhc="thumbnail_click:{{ id }}"{{# isVideo }} data-bhd="{{ videoBHD }}"{{/ isVideo }}>\n            {{# thumb }}\n              {{# lazyLoadThumbs }}<img class="sleepy-load" data-original="{{ thumb }}" alt="{{ alt }}"/> {{/ lazyLoadThumbs }}\n              {{^ lazyLoadThumbs }}<img src="{{ thumb }}" alt="{{ alt }}"/>{{/ lazyLoadThumbs }}\n            {{/ thumb }}\n          </li>\n        {{/ models }}\n      </ul>\n    {{/ showThumbs }}\n\n    <div class="gallery-controls">\n      {{# showRTL }}\n        {{# showThumbs }}\n          <div class="gallery-control-back icon-arrow-right-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>\n          <div class="gallery-control-forward icon-arrow-left-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>\n        {{/ showThumbs }}\n\n        <div class="gallery-control-left icon-arrow-right-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>\n        <div class="gallery-control-right icon-arrow-left-large" data-bhc="bumper_right:{{ uuid }}"></div>\n      {{/ showRTL }}\n\n      {{^ showRTL }}\n        {{# showThumbs }}\n          <div class="gallery-control-back icon-arrow-left-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>\n          <div class="gallery-control-forward icon-arrow-right-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>\n        {{/ showThumbs }}\n\n        <div class="gallery-control-left icon-arrow-left-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>\n        <div class="gallery-control-right icon-arrow-right-large" data-bhc="bumper_right:{{ uuid }}"></div>\n      {{/ showRTL }}\n    </div>\n  </div>\n{{/ renderFullCarousel }}\n{{^ renderFullCarousel }}\n  <div class="gallery-single">\n    <div class="gallery-featured">\n      {{# badge }}<div class="featured-badge" style="color: {{ textColor }}; background-color: {{ backgroundColor }}">{{ text }}</div>{{/ badge }}\n      {{# first }}\n        <img {{# preload }}onload="DealCarousel.onImageLoaded()" {{/ preload }}class="featured-image init-no-animation" src="{{ media }}" data-id="{{ id }}" alt="{{ alt }}"/>\n        {{# imageZoom }}<div class="zoom-in-image"></div>{{/ imageZoom }}\n      {{/ first }}\n    </div>\n\n    {{# imageZoom }}\n      <div class="image-zoom-message icon-plus" data-bhw="GoodsImageZoomMessage">{{ hoverZoomText }}</div>\n    {{/ imageZoom }}\n\n    <div class="gallery-controls">\n    </div>\n  </div>\n{{/ renderFullCarousel }}');



},{}],54:[function(require,module,exports){
var IMAGE_ASPECT_RATIO, TABLET_MQ_WIDTH, ZOOM_HOVER_DELAY;

TABLET_MQ_WIDTH = 768;

IMAGE_ASPECT_RATIO = 0.6;

ZOOM_HOVER_DELAY = 200;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.View = Backbone.View.extend({
  events: {
    'click .gallery-control-back': 'onBackClick',
    'click .gallery-control-forward': 'onForwardClick',
    'click .gallery-control-left': 'onLeftClick',
    'click .gallery-control-right': 'onRightClick',
    'click .gallery-thumbnail': 'onThumbnailClick',
    'mouseenter .zoom-controls': 'onZoomIn',
    'mouseenter .zoom-controls .gallery-control-left': 'onZoomOut',
    'mouseenter .zoom-controls .gallery-control-right': 'onZoomOut',
    'mouseleave .zoom-controls': 'onZoomOut',
    'mouseleave .zoom-controls .gallery-control-left': 'onZoomIn',
    'mouseleave .zoom-controls .gallery-control-right': 'onZoomIn',
    'mousemove .zoom-controls': 'onZoomMove'
  },
  initialize: function() {
    var base;
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.currentFeatured = this.options.featured || this.collection.first();
    this.$featuredContainer = $('.featured-image-container');
    this.collection.classes = '';
    this.collection.view = this;
    this.collection.videoBHD = JSON.stringify({
      video: true
    });
    this.collection.featured = (function(_this) {
      return function() {
        return _this.currentFeatured;
      };
    })(this);
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = this.collection.length > 1;
    this.collection.showThumbs = this.options.showThumbs;
    this.collection.imageZoom = this.options.imageZoom;
    this.collection.lazyLoadThumbs = this.options.lazyLoadThumbs && !this.options.lazyLoadFeaturedImage;
    this.collection.shouldShowImageBadge = this.options.shouldShowImageBadge;
    this.collection.lazyLoadFeaturedImage = this.options.lazyLoadFeaturedImage;
    this.collection.badge = this.options.badge;
    return (base = this.options).imageQualty != null ? base.imageQualty : base.imageQualty = '';
  },
  render: function() {
    var el, featuredIndex, renderOptions;
    this.$el = $(this.el);
    this.$body = $(document.body);
    this.rtl = this.$body.hasClass('rtl');
    renderOptions = _.extend({
      showRTL: this.rtl
    }, this.collection);
    if (this.collection.lazyLoadFeaturedImage && this.$featuredContainer.hasClass('preload')) {
      renderOptions.preload = true;
    }
    el = DealCarousel.CarouselTemplate.render(renderOptions);
    this.$el = $(el).replaceAll(this.$el);
    this.el = this.$el[0];
    this.$thumbs = this.$el.find(".gallery-thumbs");
    this.$thumbnails = this.$thumbs.children();
    this.$gallery = this.$el.find(".gallery-featured");
    this.$galleryMedia = this.$gallery.find("img");
    this.$zoomMedia = this.$gallery.find(".zoom-in-image");
    this.$clickBlocker = this.$el.find(".click-blocker");
    this.$imageZoomMessage = this.$el.find(".image-zoom-message");
    this.$controls = this.$el.find(".gallery-controls");
    this.$backButton = this.$controls.find(".gallery-control-back");
    this.$forwardButton = this.$controls.find(".gallery-control-forward");
    this.$leftButton = this.$controls.find(".gallery-control-left");
    this.$rightButton = this.$controls.find(".gallery-control-right");
    this.containerWidth = this.$el.width();
    this.insideContainerWidth = this.containerWidth - this.$backButton.width() - this.$forwardButton.width();
    this.animateViaJS = !this.$body.parent('html').hasClass('cssanimations');
    this.thumbsWidth = this.$thumbs.width();
    this.thumbWidth = this.$thumbs.children().outerWidth();
    if (this.rtl) {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-left"));
    } else {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-right"));
    }
    this.thumbsWidth = this._calculateThumbsWidth();
    this.media = {};
    this.currentPosition = 0;
    this.hasOverflow = this.thumbsWidth > this.containerWidth;
    this.setFeaturedHeight();
    this.centerThumbs();
    featuredIndex = this.collection.indexOf(this.currentFeatured);
    this.fetchInitialMedia(featuredIndex);
    this._prepareGroups();
    this._prepareImageZoom();
    if (featuredIndex !== 0) {
      this._adjustThumbs(featuredIndex);
    }
    return this.delegateEvents();
  },
  centerThumbs: function() {
    var direction;
    this.thumbsWidth = this._calculateThumbsWidth();
    this.$thumbs.width(this.thumbsWidth);
    if (!this.hasOverflow) {
      return this.visibleThumbs = this.$thumbnails.length;
    } else {
      direction = this.rtl ? 'right' : 'left';
      this.visibleThumbs = Math.floor(this.insideContainerWidth / this.thumbWidth);
      this.visibleThumbs--;
      this.$el.addClass("has-navigation");
      return this.$thumbs.css(direction, this.$backButton.width() + this.thumbMargin);
    }
  },
  fetchMedia: function(index) {
    var media;
    media = this.collection.at(index);
    if (this.media[media.id] != null) {
      return false;
    }
    if (media.type === "video") {
      return this.fetchVideo(media);
    } else {
      this.fetchImage(media);
      return this.fetchZoomImage(media);
    }
  },
  fetchImage: function(image) {
    var $newImage, newImage;
    newImage = new Image();
    newImage.src = image.media;
    $newImage = $(newImage);
    $newImage.data("id", image.id);
    $newImage.attr("id", "gallery-image-" + image.id);
    if (image.alt != null) {
      $newImage.attr("alt", image.alt);
    } else {
      $newImage.attr("alt", "");
    }
    return this.media[image.id] = $newImage;
  },
  fetchZoomImage: function(image) {
    var zoomImage;
    if (!image.zoom) {
      return;
    }
    zoomImage = new Image();
    return zoomImage.src = image.zoom;
  },
  fetchVideo: function(video) {
    var playerId;
    playerId = video.provider === "KALTURA" ? "kaltura-player-1360194818" : video.provider === "OOYALA" ? "ooyala-player" : video.provider === "YOUTUBE" ? "yt-player" : void 0;
    return this.media[video.id] = $("<div/>", {
      id: "video-container"
    }).attr("data-bhw", "PromNightVideo").html("<div id=\"" + playerId + "\" style=\"width:" + this.containerWidth + "px; height:" + this.options.mediaHeight + "px; margin: 0 auto;\"></div>");
  },
  fetchInitialMedia: function(start) {
    var collectionSize, i, j, loadCount, ref, ref1, results;
    if (start == null) {
      start = 0;
    }
    loadCount = 1;
    if (this.options.prefetchImages) {
      collectionSize = this.collection.size();
      loadCount = this.visibleThumbs;
      if (start + loadCount > collectionSize) {
        loadCount = collectionSize - start;
      }
    }
    results = [];
    for (i = j = ref = start, ref1 = start + loadCount; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      results.push(this.fetchMedia(i));
    }
    return results;
  },
  onBackClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onForwardClick(null, true);
      }
    }
    if (this.activeGroup > 0) {
      this.activeGroup--;
    } else {
      this.activeGroup = this.totalGroups - 1;
    }
    return this._updateThumbsPosition();
  },
  onForwardClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onBackClick(null, true);
      }
    }
    if (this.activeGroup < this.totalGroups - 1) {
      this.activeGroup++;
    } else {
      this.activeGroup = 0;
    }
    return this._updateThumbsPosition();
  },
  onLeftClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onRightClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb > 0) {
      newMedia = this.collection.at(currentThumb - 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(this.collection.size() - 1);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onRightClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onLeftClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb < this.collection.size() - 1) {
      newMedia = this.collection.at(currentThumb + 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(0);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onZoomIn: function(e) {
    if (this.$backButton.is(e.target) || this.$forwardButton.is(e.target)) {
      return;
    }
    if (!this.currentFeatured.zoom) {
      return;
    }
    this.$zoomMedia.css("background-image", "url('" + this.currentFeatured.zoom + "')");
    return this.$el.addClass("image-zoom");
  },
  onZoomOut: function(e) {
    if (this.$backButton.is(e.target) || this.$forwardButton.is(e.target)) {
      return;
    }
    return this.$el.removeClass("image-zoom");
  },
  onZoomMove: function(e) {
    var left, offset, top;
    if (!(this.$controls.is(e.target) && this.currentFeatured.zoom)) {
      return;
    }
    offset = this.$gallery.offset();
    left = this.zoomFactor * (offset.left - e.pageX);
    top = this.zoomFactor * (offset.top - e.pageY);
    return _.throttle(this.$zoomMedia.css("background-position", left + "px " + top + "px"), ZOOM_HOVER_DELAY);
  },
  onThumbnailClick: function(e) {
    var $thumb, newMedia;
    $thumb = this.$thumbs.find(e.currentTarget);
    newMedia = this.collection.get($thumb.data("id"));
    if (newMedia === this.currentFeatured) {
      return;
    }
    return this.updateGallery(newMedia);
  },
  playVideo: function(media) {
    if (media.provider === "KALTURA") {
      return kWidget.embed({
        "targetId": "kaltura-player-1360194818",
        "cache_st": 1360194818,
        "wid": "_1302621",
        "uiconf_id": "11486911",
        "flashvars": {
          "autoPlay": true,
          "streamerType": "hdnetwork",
          "akamaiHD": {
            "loadingPolicy": "preInitialize",
            "asyncInit": "true"
          }
        },
        "entry_id": media.media
      });
    } else if (media.provider === "OOYALA") {
      return this.videoPlayer = OO.Player.create('ooyala-player', media.media, {
        autoplay: true
      });
    } else if (media.provider === "YOUTUBE") {
      return this.videoPlayer = new YT.Player('yt-player', {
        height: this.$el.height(),
        width: this.$el.width(),
        videoId: media.media,
        playerVars: {
          'rel': 0,
          'showinfo': 0
        },
        events: {
          onReady: function(e) {
            return e.target.playVideo();
          }
        }
      });
    }
  },
  setFeaturedHeight: function() {
    var bodyWidth, mediaHeight;
    if (this.options.mediaHeight < this.$galleryMedia.height() || this.$galleryMedia.height() === 0) {
      bodyWidth = this.$body.width();
      if (bodyWidth > TABLET_MQ_WIDTH) {
        mediaHeight = this.options.mediaHeight;
      } else {
        mediaHeight = IMAGE_ASPECT_RATIO * this.containerWidth;
      }
    } else {
      mediaHeight = this.$galleryMedia.height();
    }
    this.$gallery.height(mediaHeight);
    if (!(this.$body.hasClass("goods") || this.$body.hasClass("getaways") || this.$body.hasClass("getaways-booking"))) {
      mediaHeight += 3;
    }
    return this.$controls.height(mediaHeight);
  },
  updateGallery: function(newMedia) {
    var $newGalleryMedia, isCurrentVideo, newGalleryMedia, newMediaIndex, onComplete, transitionCSS;
    newMediaIndex = this.collection.indexOf(newMedia);
    if (this.media[newMedia.id]) {
      newGalleryMedia = this.media[newMedia.id];
    } else {
      this.fetchMedia(newMediaIndex);
      newGalleryMedia = this.media[newMedia.id];
    }
    $newGalleryMedia = $(newGalleryMedia);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 0
      };
      $newGalleryMedia.css(transitionCSS);
    }
    $newGalleryMedia.appendTo(this.$gallery);
    if (newMediaIndex > 0) {
      this.$leftButton.removeClass("disabled");
    } else {
      this.$leftButton.addClass("disabled");
    }
    if (newMediaIndex < this.collection.size() - 1) {
      this.$rightButton.removeClass("disabled");
    } else {
      this.$rightButton.addClass("disabled");
    }
    this._adjustThumbs(this.collection.indexOf(newMedia));
    if (newMedia.type === "video") {
      this.playVideo(newMedia);
      this.$el.addClass("has-video");
    } else {
      this.$el.removeClass("has-video");
    }
    isCurrentVideo = this.currentFeatured.type === "video";
    onComplete = (function(_this) {
      return function() {
        var ref;
        _this.$gallery.children("[id^='gallery-']:not(#gallery-video-" + _this.currentFeatured.id + ", #gallery-image-" + _this.currentFeatured.id + ")").remove();
        if (isCurrentVideo) {
          if ((ref = _this.videoPlayer) != null) {
            ref.destroy();
          }
          return _this.$gallery.children("#video-container").remove();
        }
      };
    })(this);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 1
      };
      $newGalleryMedia.animate(transitionCSS, {
        complete: onComplete
      }, "slow");
    } else {
      setTimeout(onComplete, 600);
    }
    this.$thumbs.find("#gallery-thumb-" + newMedia.id).addClass("selected c-bdr-prim").siblings().removeClass("selected c-bdr-prim");
    this.$galleryMedia = $newGalleryMedia;
    this.currentFeatured = newMedia;
    if (this.options.imageZoom) {
      this._updateImageZoomMessage();
    }
    return this.$body.trigger("carouselUpdate", {
      image: newMedia.baseURL,
      uuid: this.options.uuid
    });
  },
  updateCollection: function(collection) {
    var currentHeight, singleImage;
    this.collection = collection;
    if (!this.collection) {
      return;
    }
    singleImage = this.collection.length === 1;
    if (singleImage) {
      currentHeight = this.$el.height();
    }
    this.undelegateEvents;
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = !singleImage;
    this.currentFeatured = this.collection.first();
    this.render();
    if (singleImage) {
      return this.$el.css("min-height", currentHeight);
    }
  },
  _calculateThumbMargins: function(marginalia) {
    if (this.visibleThumbs > 1) {
      return Math.floor(marginalia / (this.visibleThumbs - 1));
    } else {
      return Math.floor(marginalia);
    }
  },
  _calculateThumbsWidth: function() {
    return (this.thumbWidth + this.thumbMargin) * this.$thumbnails.length - this.thumbMargin;
  },
  _calculateZoomRatio: function(width, height) {
    return (width / this.$gallery.width() + height / this.$gallery.height()) / 2;
  },
  _prepareGroups: function() {
    this.thumbGroups = [];
    this.totalGroups = 0;
    this.thumbsPerGroup = 0;
    this.activeGroup = 0;
    this.pnThumbWidth = this.thumbWidth + this.thumbMargin;
    this.pnThumbWrapWidth = this.$thumbnails.length * this.pnThumbWidth;
    if (this.hasOverflow) {
      this._setThumbsPerGroup();
      this._setTotalGroups();
      this._setThumbGroups();
      this._setLastGroupThumbsShort();
      this._setActiveGroup();
      return this._updateThumbsPosition();
    }
  },
  _prepareImageZoom: function() {
    var height, ref, width;
    if (this.options.imageZoom) {
      ref = this.options.imageZoom, width = ref.width, height = ref.height;
    }
    if (!(width && height)) {
      return;
    }
    this.zoomFactor = this._calculateZoomRatio(width, height) - 1;
    this.fetchZoomImage(this.currentFeatured);
    this.$zoomMedia.width(width).height(height);
    this.$controls.addClass("zoom-controls");
    return this._updateImageZoomMessage();
  },
  _scrollThumbsPosition: function() {
    var direction, options;
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = -1 * $(this.$thumbnails[this.currentPosition]).position()[direction] + this.$backButton.width();
    if (this.animateViaJS) {
      this.$thumbs.animate(options);
    } else {
      this.$thumbs.css(options);
    }
    if (this.currentPosition === 0) {
      this.$backButton.addClass("disabled");
    } else {
      this.$backButton.removeClass("disabled");
    }
    if (this.currentPosition === this.collection.size() - this.visibleThumbs) {
      return this.$forwardButton.addClass("disabled");
    } else {
      return this.$forwardButton.removeClass("disabled");
    }
  },
  _setActiveGroup: function() {
    var currentIndex, group, i, j, lastRange, len, ref, results;
    currentIndex = this.collection.indexOf(this.currentFeatured);
    lastRange = this.thumbGroups[this.totalGroups - 1];
    ref = this.thumbGroups;
    results = [];
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (currentIndex >= group[0] && currentIndex <= group[1]) {
        if (this.activeGroup !== i) {
          this.activeGroup = i;
          results.push(this._updateThumbsPosition());
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  _setLastGroupThumbsShort: function() {
    return this.thumbsShort = this.thumbsPerGroup - (this.thumbGroups[this.totalGroups - 1][1] - this.thumbGroups[this.totalGroups - 1][0] + 1);
  },
  _setThumbGroups: function() {
    var end, i, j, ref, results, start;
    results = [];
    for (i = j = 0, ref = this.totalGroups - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      start = i * this.thumbsPerGroup;
      end = start + this.thumbsPerGroup - 1;
      if (end >= this.$thumbnails.length) {
        end = this.$thumbnails.length - 1;
      }
      results.push(this.thumbGroups[i] = [start, end]);
    }
    return results;
  },
  _setThumbsPerGroup: function() {
    return this.thumbsPerGroup = Math.floor(this.insideContainerWidth / (this.thumbWidth + this.thumbMargin));
  },
  _setTotalGroups: function() {
    return this.totalGroups = Math.ceil(this.thumbsWidth / this.insideContainerWidth);
  },
  _updateThumbsPosition: function() {
    var direction, modifier, options;
    modifier = 0;
    if (this.activeGroup === this.totalGroups - 1) {
      modifier = (this.thumbWidth + this.thumbMargin) * this.thumbsShort;
    }
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = (-1 * (((this.insideContainerWidth - this.thumbMargin) * this.activeGroup) - modifier - this.$backButton.width() - this.thumbMargin)) + "px";
    if (this.animateViaJS) {
      return this.$thumbs.animate(options);
    } else {
      return this.$thumbs.css(options);
    }
  },
  _adjustThumbs: function(index) {
    var group, i, j, k, len, ref, ref1, ref2;
    ref = this.thumbGroups;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (index >= group[0] && index <= group[1] && this.activeGroup !== i) {
        this.activeGroup = i;
        this._updateThumbsPosition();
        for (i = k = ref1 = group[0], ref2 = group[1]; ref1 <= ref2 ? k <= ref2 : k >= ref2; i = ref1 <= ref2 ? ++k : --k) {
          this.fetchMedia(i);
        }
        break;
      }
    }
  },
  _updateImageZoomMessage: function() {
    if (this.currentFeatured.zoom) {
      return this.$imageZoomMessage.css("visibility", "visible");
    } else {
      return this.$imageZoomMessage.css("visibility", "hidden");
    }
  }
});



},{}],55:[function(require,module,exports){
var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, isUrgencyPricing) {
  switch (false) {
    case !(timeLeft.days > 1):
      if (isUrgencyPricing) {
        return ".countdown_time_many_days";
      } else {
        return ".countdown_days";
      }
      break;
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.CountdownTimer == null) {
    window.CountdownTimer = {};
  }
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp
  };
}



},{}],56:[function(require,module,exports){
var base;

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

if ((base = window.CountdownTimer).current == null) {
  base.current = {};
}

CountdownTimer.init = function(arg, done) {
  var endAt, ref, timerData, timerModel, timerView;
  timerData = arg.timerData;
  if (done == null) {
    done = function() {};
  }
  endAt = timerData != null ? (ref = timerData.expiringSoon) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new CountdownTimer.Model({
    endAt: endAt
  });
  window.CountdownTimer.current.timerModel = timerModel;
  window.CountdownTimer.current.timerView = new CountdownTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: timerData != null ? timerData.el : void 0,
    translationScope: timerData != null ? timerData.translationScope : void 0
  });
  timerView = window.CountdownTimer.current.timerView;
  return $(function() {
    timerView.render();
    return done();
  });
};



},{}],57:[function(require,module,exports){
if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.Model = Backbone.Model.extend({
  timeLeft: function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.get('endAt'));
    return CountdownTimer.Helpers.timeRemaining(millisLeft);
  }
});



},{}],58:[function(require,module,exports){
var DEFAULT_EL, DEFAULT_TRANSLATION_SCOPE;

DEFAULT_EL = '.limited-time > .counter li.countdown-timer';

DEFAULT_TRANSLATION_SCOPE = 'js.modules.groupon-deal-timer';

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.View = Backbone.View.extend({
  UPDATE_FREQUENCY_MS: 1000,
  initialize: function() {
    this.i18n = this.options.i18n;
    this.el = this.options.el || DEFAULT_EL;
    return this.translationScope = this.options.translationScope || DEFAULT_TRANSLATION_SCOPE;
  },
  render: function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  },
  updateCountdown: function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("" + this.translationScope + (CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timerIcon: '<span class="icon-now"></span>',
      timestamp: CountdownTimer.Helpers.countdownTimestamp(timeLeft)
    });
    return this.$el.html(countdownTime);
  },
  t: function() {
    return this.i18n.t.apply(this.i18n, arguments);
  }
});



},{}],59:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = require('../models/option');

InlineVariations.Collections.Options = Backbone.Collection.extend({
  model: InlineVariations.Models.Option
});

module.exports = InlineVariations.Collections.Options;



},{"../models/option":62}],60:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Trait = require('../models/trait');

InlineVariations.Collections.Traits = Backbone.Collection.extend({
  model: InlineVariations.Models.Trait,
  selectedTraitValues: {},
  initialize: function() {
    return this.on('change:selectedTraitValue', this.changeSelectedTraitValue, this);
  },
  changeSelectedTraitValue: function(model, val) {
    if (val) {
      return this.selectedTraitValues[model.get('name')] = val;
    } else {
      return delete this.selectedTraitValues[model.get('name')];
    }
  },
  someTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length > 0;
  },
  allTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length === this.models.length;
  },
  closeDropdowns: function() {
    var i, len, ref, results, trait;
    ref = this.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.closeDropdown());
    }
    return results;
  }
});

module.exports = InlineVariations.Collections.Traits;



},{"../models/trait":63}],61:[function(require,module,exports){
var InlineVariations, _scrollToBuyButton, _scrollToTouchInlineVariation;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

InlineVariations.Collections.Options = require('./collections/options');

InlineVariations.Collections.Traits = require('./collections/traits');

InlineVariations.Views.Main = require('./views/main');

_scrollToBuyButton = function() {
  if (!$('#purchase-cluster .buy.fixed, .header-row-sticked, .header-row-sticky').length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $('.main').position().top - 100
  }, 500);
};

_scrollToTouchInlineVariation = function() {
  var $inlineVariationContainer;
  $inlineVariationContainer = $('#inline-variations-container');
  if (!$inlineVariationContainer.length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $inlineVariationContainer.position().top - $(window).height() / 5
  }, 500);
};

InlineVariations.init = function(arg, done) {
  var buyButton, carouselViews, dealMedia, dealOptionUuid, dealUuid, deliveryEstimates, inlineVariations, isCart, isResponsive, isTouch, mappings, offer, options, preSelectTraits, ref, ref1, stickyHeader, touchBuyButton, traits;
  buyButton = arg.buyButton, deliveryEstimates = arg.deliveryEstimates, inlineVariations = arg.inlineVariations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (!((inlineVariations != null ? (ref = inlineVariations.options) != null ? ref.length : void 0 : void 0) && ((ref1 = inlineVariations.traits) != null ? ref1.length : void 0))) {
    return done();
  }
  dealOptionUuid = inlineVariations.dealOptionUuid, dealUuid = inlineVariations.dealUuid, isResponsive = inlineVariations.isResponsive, isTouch = inlineVariations.isTouch, mappings = inlineVariations.mappings, options = inlineVariations.options, preSelectTraits = inlineVariations.preSelectTraits, traits = inlineVariations.traits;
  if (typeof DealCarousel !== "undefined" && DealCarousel !== null) {
    carouselViews = DealCarousel.carouselViews, dealMedia = DealCarousel.dealMedia;
  }
  isCart = (isTouch && (buyButton != null ? buyButton.cartIcon : void 0)) || (!isTouch && (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0));
  options = new InlineVariations.Collections.Options(options);
  traits = new InlineVariations.Collections.Traits(traits, {
    isTouch: isTouch
  });
  if (isTouch) {
    touchBuyButton = isResponsive ? ResponsiveBuyButton : TouchBuyButton;
    touchBuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (_this.main.variationsSelected()) {
          return;
        }
        _this.main.showErrorMessages();
        _scrollToTouchInlineVariation();
        return {
          stopTheBus: true
        };
      };
    })(this))(-300);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (BuyButton.view.variationsSelected) {
          return;
        }
        _this.main.showErrorMessages();
        if (stickyHeader) {
          _scrollToBuyButton();
        }
        BuyButton.view.enableBuyButton();
        return {
          stopTheBus: true
        };
      };
    })(this));
  }
  return $((function(_this) {
    return function() {
      var ref2;
      _this.main = new InlineVariations.Views.Main({
        carouselViews: carouselViews,
        dealMedia: dealMedia,
        dealOptionUuid: dealOptionUuid,
        dealUuid: dealUuid,
        deliveryEstimates: deliveryEstimates,
        isCart: isCart,
        isTouch: isTouch,
        mappings: mappings,
        offer: offer,
        options: options,
        preSelectTraits: preSelectTraits,
        traits: traits,
        _scrollToTouchInlineVariation: _scrollToTouchInlineVariation
      });
      traits.view = _this.main;
      if (options != null ? (ref2 = options[0]) != null ? ref2.hideOriginalPriceAndDiscount : void 0 : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html('');
      }
      $(document.body).on('carouselUpdate', function(e, arg1) {
        var image;
        image = arg1.image;
        return _this.main.updateInlineVariationSelections(image);
      });
      return done();
    };
  })(this));
};

module.exports = InlineVariations;



},{"./collections/options":59,"./collections/traits":60,"./views/main":64}],62:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = Backbone.Model.extend({});

module.exports = InlineVariations.Models.Option;



},{}],63:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = require('../views/trait');

InlineVariations.Views.NativeDropdownTrait = require('../views/native_dropdown_trait');

InlineVariations.Models.Trait = Backbone.Model.extend({
  initialize: function(arg, arg1) {
    var id, isTouch, layout;
    id = arg.id, layout = arg.layout;
    isTouch = arg1.isTouch;
    if (layout != null ? layout.isNativeDropdown : void 0) {
      return this.view = new InlineVariations.Views.NativeDropdownTrait({
        model: this,
        el: "#" + id
      });
    } else {
      return this.view = new InlineVariations.Views.Trait({
        model: this,
        el: "#" + id,
        isTouch: isTouch
      });
    }
  },
  setSelectedTraitValueById: function(id) {
    var selectedTraitValue;
    if (id) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        id: id
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  getTraitValueById: function(id) {
    return _.findWhere(this.get('values'), {
      id: id
    });
  },
  setSelectedTraitValueByName: function(name) {
    var selectedTraitValue;
    if (name) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        name: name
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  updateTraitValue: function(selectedTraitValue) {
    if (selectedTraitValue && !selectedTraitValue.isSoldOut && !selectedTraitValue.isPlaceholder) {
      return this.set({
        selectedTraitValueId: selectedTraitValue.id,
        selectedTraitValue: selectedTraitValue.name,
        selectedTraitValueHtml: selectedTraitValue.selectedHtml
      });
    } else {
      return this.set({
        selectedTraitValueId: false,
        selectedTraitValue: false,
        selectedTraitValueHtml: false
      });
    }
  }
});

module.exports = InlineVariations.Models.Trait;



},{"../views/native_dropdown_trait":65,"../views/trait":66}],64:[function(require,module,exports){
var Cart, DealEventPipe, InlineVariations, getBuyUrlWithShippingOptionData;

Cart = window.Cart != null ? window.Cart : window.Cart = {};

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Cart.Helpers = require('../../../cart/common/helpers');

getBuyUrlWithShippingOptionData = require('../../../goods_local_supply_v2/common/helpers').getBuyUrlWithShippingOptionData;

InlineVariations.Views.Main = Backbone.View.extend({
  el: '#inline-variations-container',
  body: 'body',
  inlineVariationsTraits: '.inline-variation-trait',
  inlineVariationsDropdowns: '.inline-variation-layout-generic-dropdown, .inline-variation-native-dropdown',
  touch: {
    main: '.t-main',
    featuredImg: '#featured-image',
    imageCarousel: '#image-wrapper ul li',
    featuredImgSize: 't300x182.jpg',
    buyButton: '#buy',
    priceBuy: '#price-buy',
    values: '#price-buy .value, #price-buy .breakout-option-value',
    prices: '#price-buy .price, #price-buy .breakout-option-price',
    filterSheetPrice: '#inline-variations-filters-header .price',
    urgencyPrice: '#price-buy .urgency-pricing-value-unit strong, #price-buy .breakout-option-price.urgency-pricing',
    urgencyOfferLabel: '#price-buy .urgency-pricing-value-unit .urgency-pricing-offer-label, #price-buy .urgency-pricing-label',
    deliveryEstimate: '.delivery-estimates-container',
    discount: '#discount-percent span, .discount-percentage',
    savings: '#discount-savings span',
    filters: '#inline-variations-filters',
    filtersHeight: '48%'
  },
  initialize: function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    _.extend(this, this.options);
    this.$inlineVariationsDropdowns = this.$el.find(this.inlineVariationsDropdowns);
    this.$inlineVariationsTraits = this.$el.find(this.inlineVariationsTraits);
    this.$body = $(this.body);
    if (this.isTouch) {
      this.$body = $(this.touch.main);
      this.$touchFeaturedImg = $(this.touch.featuredImg);
      this.$imageCarousel = $(this.touch.imageCarousel);
      this.$touchBuyButton = $(this.touch.buyButton);
      this.$touchPriceBuy = $(this.touch.priceBuy);
      this.$touchPrices = $(this.touch.prices);
      this.$touchFilterSheetPrice = $(this.touch.filterSheetPrice);
      this.$touchValues = $(this.touch.values);
      this.$touchUrgencyPrice = $(this.touch.urgencyPrice);
      this.$touchUrgencyOfferLabel = $(this.touch.urgencyOfferLabel);
      this.$touchDeliveryEstimate = $(this.touch.deliveryEstimate);
      this.$touchDiscount = $(this.touch.discount);
      this.$touchSavings = $(this.touch.savings);
      this.$touchFilters = $(this.touch.filters);
      this.touchDefaultCarouselSelection = {
        index: 0
      };
      DealEventPipe.on('touchCarouselSwiped', (function(_this) {
        return function(data) {
          return _this.updateInlineVariationSelectionsForTouch(data);
        };
      })(this));
      DealEventPipe.on('touchLocalSupplyUpdate', (function(_this) {
        return function(data) {
          var buyButtonData;
          if (data.isLocalSupplyTrigger && data.buyUrl) {
            buyButtonData = _.extend({}, data, {
              buyUrl: _this.getLocalSupplyUrl({
                buyUrl: data.buyUrl
              })
            });
            return _this.updateTouchBuyButton(buyButtonData);
          }
        };
      })(this));
      this.touchOriginalFeaturedImg = this.$touchFeaturedImg.attr('src');
    }
    this.attachBackdropEventListener();
    return this.makeSelectionsViaPreselection();
  },
  attachBackdropEventListener: function() {
    return this.$body.click((function(_this) {
      return function(e) {
        if (!_this.$body.hasClass('inline-variation-backdrop')) {
          return;
        }
        if (_this.$body.hasClass('stop-propagation')) {
          return _this.$body.removeClass('stop-propagation');
        } else {
          _this.traits.closeDropdowns();
          if (_this.isTouch) {
            return _this.$touchFilters.animate({
              height: '0'
            }, 400, 'swing', function() {
              _this.$body.removeClass('inline-variation-backdrop');
              _this.$touchFilters.height('auto');
              return _this._scrollToTouchInlineVariation();
            });
          } else {
            return _this.$body.removeClass('inline-variation-backdrop');
          }
        }
      };
    })(this));
  },
  makeSelectionsViaPreselection: function() {
    var i, len, option, ref, ref1, selections, trait, value;
    if (!((ref = this.preSelectTraits) != null ? ref.length : void 0)) {
      return;
    }
    if (!(option = this.options.findWhere({
      uuid: this.dealOptionUuid
    }))) {
      return;
    }
    selections = {};
    ref1 = this.preSelectTraits;
    for (i = 0, len = ref1.length; i < len; i++) {
      trait = ref1[i];
      if (value = option.get(trait)) {
        selections[trait] = value;
      }
    }
    this.updateSelections(selections);
    return this.render();
  },
  render: function(updateCarouselOrFeaturedImage) {
    if (updateCarouselOrFeaturedImage == null) {
      updateCarouselOrFeaturedImage = true;
    }
    this.updateSoldout();
    this.updatePriceAndBuyButton();
    if (updateCarouselOrFeaturedImage) {
      this.updateCarouselOrFeaturedImage();
    }
    return this.hideErrorMessages();
  },
  updateSoldout: function() {
    var currentValue, filteredSelection, i, len, ref, results, trait, traitValue;
    if (this.traits.models.length < 2) {
      return;
    }
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      filteredSelection = _.omit(this.traits.selectedTraitValues, trait.get('name'));
      results.push((function() {
        var j, len1, ref1, results1;
        ref1 = trait.get('values') || [];
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          traitValue = ref1[j];
          if (traitValue.isPlaceholder) {
            continue;
          }
          currentValue = {};
          currentValue[traitValue.traitName] = traitValue.name;
          results1.push(trait.view.toggleSoldOut(traitValue, (this.options.where(_.extend(filteredSelection, currentValue)).length) === 0 || traitValue.isSoldOut));
        }
        return results1;
      }).call(this));
    }
    return results;
  },
  updatePriceAndBuyButton: function() {
    var cheapestOption, oldPrice, optionInfo, qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    if (!qualifiedOptions.length) {
      return;
    }
    if (!(cheapestOption = _.min(qualifiedOptions, function(option) {
      return option.get('amount');
    }))) {
      return;
    }
    if (cheapestOption === 2e308) {
      return;
    }
    oldPrice = cheapestOption.get('oldPrice');
    optionInfo = {
      dealUuid: this.dealUuid,
      buyUrl: this.buyButtonUrl(cheapestOption),
      hideOriginalPriceAndDiscount: cheapestOption.get('hideOriginalPriceAndDiscount') || (oldPrice === '$0'),
      id: cheapestOption.get('id'),
      lengthClass: cheapestOption.get('lengthClass'),
      percent: cheapestOption.get('discount'),
      price: cheapestOption.get('newPrice'),
      savings: cheapestOption.get('savePrice'),
      uuid: cheapestOption.get('uuid'),
      value: oldPrice,
      variationsSelected: qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected()
    };
    this.overridePrice(optionInfo, cheapestOption);
    if (this.isTouch) {
      this.updateTouchDealInfo(optionInfo);
      this.updateTouchBuyButton(optionInfo);
      DealEventPipe.trigger("touchDeliveryEstimatesUpdate", optionInfo);
      return DealEventPipe.trigger("touchLocalSupplyUpdate", optionInfo);
    } else {
      DealEventPipe.trigger("priceUpdate", optionInfo);
      if (payload.goodsWarranty) {
        DealEventPipe.trigger("goodsWarrantyUpdate", optionInfo);
      }
      if (payload.buyMore) {
        return DealEventPipe.trigger("buyMoreUpdate", optionInfo, !optionInfo.variationsSelected);
      }
    }
  },
  updateTouchDealInfo: function(arg) {
    var hideOriginalPriceAndDiscount, id, percent, price, ref, sale, savings, urgencyPricing, uuid, value;
    hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount, id = arg.id, percent = arg.percent, price = arg.price, sale = arg.sale, savings = arg.savings, uuid = arg.uuid, value = arg.value;
    this.$touchValues.text(hideOriginalPriceAndDiscount ? '' : value);
    this.$touchDiscount.html(percent);
    this.$touchSavings.text(savings);
    this.$touchPriceBuy.attr('data-option-id', id);
    if (urgencyPricing = sale != null ? sale.urgencyPricing : void 0) {
      this.$touchPrices.text(urgencyPricing.regularPrice);
      this.$touchFilterSheetPrice.text(urgencyPricing.newPrice);
      this.$touchUrgencyPrice.show().text(urgencyPricing.newPrice);
      this.$touchPriceBuy.addClass('urgency-pricing-cluster');
      if ((ref = urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0) {
        return this.$touchUrgencyOfferLabel.show().text(urgencyPricing.pricingMetadata.offerLabel);
      } else {
        return this.$touchUrgencyOfferLabel.hide();
      }
    } else {
      this.$touchPrices.text(price);
      this.$touchFilterSheetPrice.text(price);
      return this.$touchPriceBuy.removeClass('urgency-pricing-cluster');
    }
  },
  updateTouchBuyButton: function(arg) {
    var buyUrl, id, variationsSelected;
    buyUrl = arg.buyUrl, id = arg.id, variationsSelected = arg.variationsSelected;
    if (variationsSelected) {
      this.$touchBuyButton.attr('href', buyUrl);
      if (this.isCart) {
        return this.$touchBuyButton.attr('data-option', id);
      }
    } else {
      this.$touchBuyButton.removeAttr('href');
      if (this.isCart) {
        return this.$touchBuyButton.removeAttr('data-option');
      }
    }
  },
  getQualifiedOptions: function() {
    if (this.traits.someTraitValuesSelected()) {
      return this.options.where(this.traits.selectedTraitValues);
    } else {
      return this.options.models;
    }
  },
  variationsSelected: function() {
    var qualifiedOptions;
    qualifiedOptions = this.getQualifiedOptions();
    return qualifiedOptions.length === 1 && this.traits.allTraitValuesSelected();
  },
  buyButtonUrl: function(option) {
    var ref;
    switch (false) {
      case !((ref = option.get('externalUrl')) != null ? ref.length : void 0):
        return option.get('externalUrl');
      case !(this.isCart && !payload.shouldDisableGoodsCart):
        return Cart.Helpers.generateCartUrl(option.get('uuid'), this.dealUuid);
      default:
        return option.get('url');
    }
  },
  overridePrice: function(optionInfo, option) {
    var offer, ref, ref1, ref2, ref3, sale;
    if (!((option.get('regularPrice') != null) || ((ref = this.offer) != null ? (ref1 = ref.offerOptions) != null ? ref1.length : void 0 : void 0))) {
      return;
    }
    sale = {};
    if (option.get('regularPrice')) {
      sale.urgencyPricing = {
        newPrice: option.get('newPrice'),
        pricingMetadata: option.get('pricingMetadata'),
        regularPrice: option.get('regularPrice')
      };
    }
    if (offer = _.findWhere((ref2 = this.offer) != null ? ref2.offerOptions : void 0, {
      id: option.get('uuid')
    })) {
      if (offer.buyUrl && !((ref3 = this.offer.offerModal) != null ? ref3.isSoldOut : void 0)) {
        optionInfo.buyUrl = offer.buyUrl;
      }
      _.extend(sale, {
        offer: offer
      });
    }
    if (sale !== {}) {
      return _.extend(optionInfo, {
        sale: sale
      });
    }
  },
  updateCarouselOrFeaturedImage: function() {
    var currentBaseUrl, image, imageUrl, valueHash;
    if (this.isTouch) {
      if (!this.$imageCarousel.length) {
        if (imageUrl = this.findFeaturedImageUrl()) {
          return this.$touchFeaturedImg.attr('src', imageUrl);
        }
      } else if (valueHash = this.findCarouselImageIndexForTouch()) {
        if (this.carouselImageIndex !== valueHash.index) {
          return this.swipeTouchCarousel(valueHash);
        }
      }
    } else if (image = this.findCarouselImage()) {
      currentBaseUrl = this.carouselViews[this.dealUuid].currentFeatured.baseURL;
      if (currentBaseUrl !== image.baseURL) {
        payload.firedByTraitSelection = true;
        return this.carouselViews[this.dealUuid].updateGallery(image);
      }
    }
  },
  swipeTouchCarousel: function(arg) {
    var index, ref;
    index = arg.index;
    DealData.firedByTraitSelection = true;
    this.carouselImageIndex = index;
    return (ref = window.TouchDeal) != null ? ref._swipe.slide(index) : void 0;
  },
  findFeaturedImageUrl: function() {
    var image, ref;
    if (!(image = (ref = this.options.findWhere(this.traits.selectedTraitValues)) != null ? ref.get('image') : void 0)) {
      return this.touchOriginalFeaturedImg;
    }
    return "" + image + this.touch.featuredImgSize;
  },
  findCarouselImage: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.dealMedia[this.dealUuid].models[0];
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        this.carouselImage = imageUrl;
        return this.dealMedia[this.dealUuid].findWhere({
          baseURL: imageUrl
        });
      }
    }
  },
  findCarouselImageIndexForTouch: function() {
    var foundMatch, imageUrl, ref, valuesHash;
    if (!this.traits.someTraitValuesSelected()) {
      return this.touchDefaultCarouselSelection;
    }
    ref = this.mappings;
    for (imageUrl in ref) {
      valuesHash = ref[imageUrl];
      foundMatch = _.every(this.traits.models, function(trait) {
        var selectedTraitValue;
        if (!(selectedTraitValue = trait.get('selectedTraitValue'))) {
          return true;
        }
        return _.contains(valuesHash[trait.get('name')], selectedTraitValue);
      });
      if (foundMatch) {
        return valuesHash;
      }
    }
  },
  updateInlineVariationSelections: function(image) {
    var key, ref, selections, value;
    if (payload.firedByTraitSelection) {
      return payload.firedByTraitSelection = false;
    }
    if (!image) {
      return;
    }
    if (image === this.carouselImage) {
      return;
    }
    this.carouselImage = image;
    selections = {};
    if (this.mappings[image]) {
      ref = this.mappings[image];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections[key] = value[0];
        }
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateInlineVariationSelectionsForTouch: function(arg) {
    var index, key, ref, selections, value;
    index = arg.index;
    if (DealData.firedByTraitSelection) {
      return DealData.firedByTraitSelection = false;
    }
    if (index === this.carouselImageIndex) {
      return;
    }
    this.carouselImageIndex = index;
    selections = {};
    ref = _.findWhere(this.mappings, {
      index: index
    });
    for (key in ref) {
      value = ref[key];
      if (value.length === 1) {
        selections[key] = value[0];
      }
    }
    this.updateSelections(selections);
    return this.render(false);
  },
  updateSelections: function(selections) {
    var i, len, ref, results, trait;
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.setSelectedTraitValueByName(selections[trait.get('name')]));
    }
    return results;
  },
  showErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.addClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.showErrorMessages());
    }
    return results;
  },
  hideErrorMessages: function() {
    var i, len, ref, results, trait;
    this.$el.removeClass('error');
    ref = this.traits.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.hideErrorMessages());
    }
    return results;
  },
  showBackdrop: function(traitView) {
    var isOpen;
    isOpen = this.$body.hasClass('inline-variation-backdrop');
    this.$body.addClass('inline-variation-backdrop stop-propagation');
    if (!this.isTouch) {
      return;
    }
    if (isOpen) {
      return traitView.slideDownAnimation(isOpen);
    } else {
      return this.$touchFilters.animate({
        height: this.touch.filtersHeight
      }, function() {
        return traitView.slideDownAnimation(isOpen);
      });
    }
  },
  getLocalSupplyUrl: function(arg) {
    var buyUrl, ref, shippingOptionData;
    buyUrl = arg.buyUrl;
    if (!(shippingOptionData = typeof GoodsLocalSupply !== "undefined" && GoodsLocalSupply !== null ? (ref = GoodsLocalSupply.View) != null ? ref.getSelectedShippingOptionData() : void 0 : void 0)) {
      return;
    }
    return getBuyUrlWithShippingOptionData(buyUrl, shippingOptionData);
  }
});

module.exports = InlineVariations.Views.Main;



},{"../../../cart/common/helpers":13,"../../../deal/frontend/event_pipe":21,"../../../goods_local_supply_v2/common/helpers":44}],65:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.NativeDropdownTrait = Backbone.View.extend({
  inlineTrait: '.inline-variation-trait',
  events: {
    'change .inline-variation-trait': 'traitValueSelection'
  },
  initialize: function() {
    this.$inlineNativeTrait = this.$el.find(this.inlineTrait);
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    return this.processTraitValues();
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  traitValueSelection: function(e) {
    this.model.setSelectedTraitValueByName($(e.currentTarget).val());
    return this.model.collection.view.render();
  },
  getSelectedTrait: function(id) {
    if (id) {
      return _.findWhere(this.model.get('values'), {
        id: id
      });
    } else {
      return _.first(this.model.get('values'));
    }
  },
  setTraitValue: function() {
    return this.getSelectedTrait(this.model.get('selectedTraitValueId')).$el.prop('selected', true);
  },
  showErrorMessages: function() {
    if (this.model.get('selectedTraitValue')) {
      return;
    }
    this.$el.addClass('error');
    return this.$inlineNativeTrait.addClass('error');
  },
  hideErrorMessages: function() {
    this.$el.removeClass('error');
    return this.$inlineNativeTrait.removeClass('error');
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    return traitValue.$el.prop('disabled', isSoldOut);
  },
  closeDropdown: function() {}
});

module.exports = InlineVariations.Views.NativeDropdownTrait;



},{}],66:[function(require,module,exports){
var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = Backbone.View.extend({
  dropdownSelection: '.inline-variation-dropdown-selection',
  traitValues: '.inline-variation-trait-value',
  inlineTitleHtml: '.inline-variation-trait-title',
  body: 'body',
  touch: {
    main: '.t-main',
    traitValuesContainer: '.inline-variation-trait-values'
  },
  events: {
    'click .inline-variation-dropdown-selection': 'toggleDropdown',
    'click .inline-variation-trait-value': 'traitValueSelection'
  },
  webSwatchEvents: {
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait',
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'
  },
  initialize: function() {
    this.layout = this.model.get('layout');
    this.title = this.model.get('title');
    this.isSwatchImageDropdown = this.layout.isImageSwatch && this.layout.isDropdown;
    this.isTouch = this.options.isTouch;
    this.$body = $(this.body);
    this.$traitValues = this.$el.find(this.traitValues);
    if (this.layout.isDropdown) {
      this.placeholderHtml = this.model.get('title');
      this.placeholderValue = this.model.get('placeholderValue');
      this.placeholderValueId = this.model.get('placeholderValueId');
      this.$titleHtml = this.$el.find(this.dropdownSelection);
    } else {
      this.$titleHtml = this.$el.find(this.inlineTitleHtml);
    }
    if (this.layout.enableFilterSheet) {
      this.$body = $(this.touch.main);
      this.$touchTraitValuesContainer = this.$el.find(this.touch.traitValuesContainer);
      this.$touchIVTraitsContainer = this.$el.parent();
    }
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    if (this.layout.isSwatch && !(this.isTouch || this.isTouchDevice())) {
      _.extend(this.events, this.webSwatchEvents);
    }
    if (this.isTouch || this.isTouchDevice()) {
      this.removeHoverClass();
    }
    return this.processTraitValues();
  },
  removeHoverClass: function() {
    return this.$traitValues.removeClass('ch-bdr-prim');
  },
  isTouchDevice: function() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  toggleDropdown: function(e) {
    var isOpen;
    isOpen = this.$el.hasClass('open');
    if (!this.layout.enableFilterSheet) {
      this.model.collection.closeDropdowns();
    }
    if (this.layout.enableFilterSheet && this.$body.hasClass('inline-variation-backdrop')) {
      this.closeDropdown();
    }
    if (isOpen) {
      return;
    }
    this.model.collection.view.showBackdrop(this);
    if (!this.layout.enableFilterSheet) {
      return this.openTrait();
    }
  },
  slideDownAnimation: function(isFilterSheetOpen) {
    var delay, showScrollAnimation;
    showScrollAnimation = this.model.get('index') && isFilterSheetOpen && this.layout.enableFilterSheet;
    delay = showScrollAnimation ? 10 : 400;
    return this.$touchTraitValuesContainer.slideDown(delay, (function(_this) {
      return function() {
        _this.openTrait();
        if (showScrollAnimation) {
          return _this.$touchIVTraitsContainer.animate({
            scrollTop: _this.$el.position().top + _this.$touchIVTraitsContainer.scrollTop() - 51
          }, 400);
        }
      };
    })(this));
  },
  openTrait: function() {
    this.$el.addClass('open');
    return this.sendDropdownTrackingEvent(false);
  },
  sendDropdownTrackingEvent: function(isOpen) {
    var status;
    status = isOpen ? 'close' : 'open';
    return OptimizeSuite.TrackingHub.add("inline-variations-dropdown-" + status);
  },
  closeDropdown: function() {
    var isOpen;
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    if (!(isOpen = this.$el.hasClass('open'))) {
      return;
    }
    if (this.layout.enableFilterSheet) {
      return this.$touchTraitValuesContainer.slideUp(400, (function(_this) {
        return function() {
          _this.$el.removeClass('open');
          return _this.sendDropdownTrackingEvent(isOpen);
        };
      })(this));
    } else {
      this.$el.removeClass('open');
      return this.sendDropdownTrackingEvent(isOpen);
    }
  },
  traitValueSelection: function(e) {
    var $target, selected;
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return e.stopPropagation();
    }
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    selected = $target.hasClass('selected');
    if (selected && this.layout.isDropdown && !(this.layout.isSwatch || this.isTouch)) {
      return;
    }
    this.$traitValues.removeClass('selected');
    if (selected) {
      this.model.setSelectedTraitValueById();
    } else {
      this.model.setSelectedTraitValueById($target.attr('id'));
    }
    return this.model.collection.view.render();
  },
  updateTitleToHoveredTrait: function(e) {
    var $target, currentTraitValue;
    if (!this.layout.isSwatch) {
      return;
    }
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return;
    }
    if (currentTraitValue = this.model.getTraitValueById($target.attr('id'))) {
      return this.$titleHtml.html(currentTraitValue.selectedHtml);
    }
  },
  updateTitleToOriginalTrait: function(e) {
    if (!this.layout.isSwatch) {
      return;
    }
    if ($(e.currentTarget).hasClass('sold-out')) {
      return;
    }
    return this.$titleHtml.html(this.model.get('selectedTraitValueHtml') || this.title);
  },
  setTraitValue: function() {
    var selectedTraitValue, selectedTraitValueId;
    if (!this.layout.enableFilterSheet) {
      this.closeDropdown();
    }
    selectedTraitValue = this.model.get('selectedTraitValueHtml');
    selectedTraitValueId = this.model.get('selectedTraitValueId');
    if (this.layout.isDropdown || this.layout.isSwatch) {
      if (!selectedTraitValue) {
        if (this.layout.isSwatch) {
          selectedTraitValue = this.title;
        } else {
          selectedTraitValue = this.placeholderHtml;
          selectedTraitValueId = this.placeholderValueId;
        }
      }
      this.$titleHtml.html(selectedTraitValue);
    }
    return this.$traitValues.each((function(_this) {
      return function(index, traitValue) {
        if (_this.layout.isSwatch || !_this.layout.isDropdown) {
          return $(traitValue).toggleClass('selected c-txt-prim c-bdr-prim', $(traitValue).attr('id') === selectedTraitValueId);
        } else {
          return $(traitValue).toggleClass('selected c-txt-prim', $(traitValue).attr('id') === selectedTraitValueId);
        }
      };
    })(this));
  },
  showErrorMessages: function() {
    var ref;
    if (!this.model.get('selectedTraitValue')) {
      this.$el.addClass('error');
    }
    return (ref = this.$traitValuesContainer) != null ? ref.addClass('error') : void 0;
  },
  hideErrorMessages: function() {
    var ref;
    this.$el.removeClass('error');
    return (ref = this.$traitValuesContainer) != null ? ref.removeClass('error') : void 0;
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    traitValue.$el.toggleClass('sold-out', isSoldOut);
    if (!(this.isTouch || this.isTouchDevice())) {
      return traitValue.$el.toggleClass('ch-bdr-prim', !isSoldOut);
    }
  }
});

module.exports = InlineVariations.Views.Trait;



},{}],67:[function(require,module,exports){
var LiveChat;

LiveChat = window.LiveChat != null ? window.LiveChat : window.LiveChat = {};

LiveChat.init = function(arg, done) {
  var liveChat, ref;
  liveChat = arg.liveChat;
  if (!(((liveChat != null ? liveChat.scriptUrl : void 0) != null) && (liveChat != null ? (ref = liveChat.configArray) != null ? ref.length : void 0 : void 0) > 0)) {
    return done();
  }
  return $(function() {
    window._bcvma = liveChat.configArray;
    if (!window.bcLoaded) {
      window.bcLoaded = true;
      $.getScript(liveChat.scriptUrl);
    }
    setInterval(function() {
      var $bcanchor, $bcfloating;
      $bcfloating = $(".bcFloat img, .bcStatic img");
      $bcanchor = $(".bcFloat a, .bcStatic a");
      if ($bcfloating != null ? $bcfloating.length : void 0) {
        $bcfloating.attr("alt", "LiveChat");
        if ($bcanchor != null ? $bcanchor.length : void 0) {
          $bcanchor.removeAttr("href").attr({
            "role": "button",
            "aria-label": "LiveChat",
            "tabindex": "0"
          }).css({
            "cursor": "pointer",
            "display": "block"
          });
          if ($bcfloating.attr('src').indexOf('clear.gif') !== -1) {
            return $bcanchor.css("display", "none");
          }
        }
      }
    }, 1000);
    return done();
  });
};

module.exports = LiveChat;



},{}],68:[function(require,module,exports){
var MemberOnly;

MemberOnly = window.MemberOnly != null ? window.MemberOnly : window.MemberOnly = {};

MemberOnly.init = function(arg, done) {
  var $tooltip, expectedSize;
  arg;
  expectedSize = $(".member-only").width();
  $tooltip = $("#member_only_tooltip");
  $tooltip.css("width", expectedSize);
  return done();
};

module.exports = MemberOnly;



},{}],69:[function(require,module,exports){
(function (global){
var averageRatingText, buildHistogram, extend, extractDisplayNames, extractHelpfulUpvote, extractPreviewReviews, extractRatingDistribution, extractReviews, extractStats, formatButtons, formatDate, formatHelpfulText, indexOf, map, normalizePercentages, object, placement, processReview, processUserReview, ratingToStars, ref, reviewIds, roundAverageRating, starToHtml,
  indexOf1 = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), extend = ref.extend, map = ref.map, indexOf = ref.indexOf, object = ref.object;

normalizePercentages = require('../../../core/utils/distribution').normalizePercentages;

averageRatingText = function(averageRating, ratingCount, i18n) {
  return {
    bhc: "deal-review-rating:" + averageRating.value,
    rating: averageRating.formatted,
    ratingCount: ratingCount.value,
    text: ratingCount.value > 1 ? i18n.t('.histogram.average_message', {
      formattedRatingCount: ratingCount.formatted
    }) : ''
  };
};

buildHistogram = function(ratingCount, ratingDistribution, displayOptions) {
  var histogramStars, i, index, j, key, keyAtStar, len, normalizedRatings, percent, ratingHistogram, ref1, ref2, star, value, valueAtStar;
  if (displayOptions.hideGoodsProductReviewsHistogram) {
    return;
  }
  if (!ratingCount.value) {
    return;
  }
  ratingHistogram = [];
  histogramStars = [];
  for (star = i = 5; i >= 1; star = --i) {
    key = "rating" + star + "Count";
    value = ((ref1 = ratingDistribution[key]) != null ? ref1.value : void 0) || 0;
    ratingHistogram.push(value);
  }
  normalizedRatings = normalizePercentages(ratingHistogram, ratingCount.value);
  for (index = j = 0, len = normalizedRatings.length; j < len; index = ++j) {
    percent = normalizedRatings[index];
    star = 5 - index;
    keyAtStar = "rating" + star + "Count";
    valueAtStar = ((ref2 = ratingDistribution[keyAtStar]) != null ? ref2.value : void 0) || 0;
    histogramStars[index] = {
      bhc: "deal-review-rating-distribution:" + keyAtStar + "_" + valueAtStar,
      ratingCountPercentage: percent + "%",
      ratingStars: ratingToStars(star)
    };
  }
  return {
    histogramStars: histogramStars
  };
};

extractRatingDistribution = function(ratingDistribution, i18n) {
  if (!ratingDistribution) {
    return {};
  }
  return object(map(ratingDistribution, function(value, key) {
    return [
      key, {
        formatted: i18n.toNumber(value),
        value: value
      }
    ];
  }));
};

extractStats = function(productReviews, i18n) {
  var averageRating, ratingCount, ref1, ref2, ref3, ref4, reviewCount;
  if (productReviews == null) {
    productReviews = {};
  }
  ratingCount = ((ref1 = productReviews.product) != null ? ref1.ratingCount : void 0) || 0;
  reviewCount = ((ref2 = productReviews.product) != null ? ref2.reviewCount : void 0) || 0;
  averageRating = ((ref3 = productReviews.product) != null ? ref3.averageRating : void 0) || 0;
  return {
    averageRating: {
      formatted: roundAverageRating(averageRating).toFixed(1),
      value: averageRating
    },
    ratingCount: {
      formatted: i18n.toNumber(ratingCount),
      value: ratingCount
    },
    ratingDistribution: extractRatingDistribution((ref4 = productReviews.product) != null ? ref4.ratingDistribution : void 0, i18n),
    reviewCount: {
      formatted: i18n.toNumber(reviewCount),
      value: reviewCount
    }
  };
};

formatButtons = function(review, userVoted, displayOptions, i18n) {
  var ref1, voteDown, voteUp;
  if (displayOptions == null) {
    displayOptions = {};
  }
  ref1 = reviewIds(review), voteUp = ref1.voteUp, voteDown = ref1.voteDown;
  if (displayOptions.isTouch) {
    if (displayOptions.votingEnabled) {
      return {
        buttons: [
          {
            voteId: voteUp,
            voteClass: userVoted ? 'vote-undo upvoted' : 'vote-up',
            text: i18n.p(review.upvoteCount, 'js.modules.product_reviews.review_card.helpful.touch_message', {
              formattedUpvoteCount: i18n.toNumber(review.upvoteCount)
            })
          }
        ]
      };
    }
  } else if (!userVoted) {
    return {
      buttons: [
        {
          voteId: voteUp,
          voteClass: 'vote-up',
          text: i18n.t('js.modules.product_reviews.review_card.helpful.yes')
        }, {
          voteId: voteDown,
          voteClass: 'vote-down',
          text: i18n.t('js.modules.product_reviews.review_card.helpful.no')
        }
      ]
    };
  }
};

formatHelpfulText = function(upvoteCount, displayOptions, i18n) {
  if (displayOptions == null) {
    displayOptions = {};
  }
  if (displayOptions.votingEnabled || !upvoteCount) {
    return '';
  }
  return i18n.p(upvoteCount, 'js.modules.product_reviews.review_card.helpful.default_message', {
    formattedUpvoteCount: i18n.toNumber(upvoteCount)
  });
};

formatDate = function(dateString, datetime, i18n) {
  var date;
  date = datetime(dateString);
  if (date != null ? date.isValid() : void 0) {
    return date.format(i18n.t('js.modules.product_reviews.review_card.datetime_format_string'));
  } else {
    return '';
  }
};

starToHtml = function(starType, position, userInput) {
  if (userInput == null) {
    userInput = false;
  }
  if (userInput) {
    return "<span class='review-star icon-star-filled review-star-" + position + " " + starType + "' data-star-rating='" + position + "' data-bhw='ProductReviewUserRatingStar" + position + "'></span>";
  } else {
    return "<span class='icon-star-filled " + starType + "'></span>";
  }
};

ratingToStars = function(rating, userInput) {
  var bhc, formattedAverageRating, i, position, starType, stars;
  stars = [];
  formattedAverageRating = roundAverageRating(rating);
  bhc = "deal-review-rating:" + formattedAverageRating;
  for (position = i = 1; i <= 5; position = ++i) {
    starType = (function() {
      switch (false) {
        case !(formattedAverageRating > 3 / 4):
          return 'full-star';
        case !(formattedAverageRating > 1 / 4):
          return 'half-star';
        default:
          return 'empty-star';
      }
    })();
    stars.push(starToHtml(starType, position, userInput));
    formattedAverageRating--;
  }
  return {
    stars: stars,
    bhc: bhc
  };
};

roundAverageRating = function(averageRating) {
  if (!averageRating) {
    return 0;
  }
  return Math.round(averageRating * 10) / 10;
};

placement = function(review) {
  if (review.isUserReview) {
    return 'user';
  } else if (review.isHelpfulReview) {
    return 'helpful';
  } else if (review.isPreviewReview) {
    return 'preview';
  } else {
    return 'list';
  }
};

reviewIds = function(review) {
  var prefix;
  prefix = review.placement === 'list' ? '' : review.placement + "-";
  return {
    card: prefix + "review-card-" + review.uuid,
    notification: prefix + "review-notification-" + review.uuid,
    rating: prefix + "review-rating-" + review.uuid,
    reviewText: prefix + "review-text-" + review.uuid,
    voteUp: prefix + "review-vote-up-" + review.uuid,
    voteDown: prefix + "review-vote-down-" + review.uuid,
    voteText: prefix + "review-vote-text-" + review.uuid,
    voteUndo: prefix + "review-vote-undo-" + review.uuid
  };
};

extractHelpfulUpvote = function(review, displayOptions, i18n) {
  var ref1, ref2, userVoted, userVotedDown, userVotedUp;
  if (displayOptions == null) {
    displayOptions = {};
  }
  if (review.byCurrentUser) {
    return;
  }
  userVotedUp = (ref1 = review.uuid, indexOf1.call(displayOptions.userUpvotedReviews || [], ref1) >= 0);
  userVotedDown = (ref2 = review.uuid, indexOf1.call(displayOptions.userDownvotedReviews || [], ref2) >= 0);
  userVoted = userVotedUp || userVotedDown;
  if (userVotedUp) {
    review.upvoteCount++;
  } else if (userVotedDown) {
    review.downvoteCount++;
  }
  return {
    buttonInfo: formatButtons(review, userVoted, displayOptions, i18n),
    text: formatHelpfulText(review.upvoteCount, displayOptions, i18n),
    undoText: !userVoted,
    userVoted: userVoted
  };
};

extractDisplayNames = function(review, i18n) {
  var displayName, username;
  displayName = review.displayName;
  if (displayName != null ? displayName.length : void 0) {
    if (review.byCurrentUser) {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.current_user', {
        displayName: displayName
      });
    } else {
      username = displayName;
    }
  } else {
    displayName = i18n.t('js.modules.product_reviews.review_card.display_name.anonymous_user');
    if (review.byCurrentUser) {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.current_user_missing_name');
    } else {
      username = i18n.t('js.modules.product_reviews.review_card.display_name.anonymous_user');
    }
  }
  return {
    username: username,
    displayName: displayName
  };
};

processReview = function(review, displayOptions, i18n, datetime) {
  var displayName, ref1, username;
  if (displayOptions == null) {
    displayOptions = {};
  }
  review.byCurrentUser = review.isUserReview || indexOf(displayOptions.userReviewIds || [], review.uuid) > -1;
  review.placement = placement(review);
  review.verifiedPurchaser = review.verifiedPurchase && displayOptions.showVerifiedPurchaser;
  ref1 = extractDisplayNames(review, i18n), username = ref1.username, displayName = ref1.displayName;
  return extend(review, {
    date: formatDate(review.submittedAt, datetime, i18n),
    helpfulUpvote: extractHelpfulUpvote(review, displayOptions, i18n),
    ratingStars: ratingToStars(review.rating),
    reviewIds: reviewIds(review),
    username: username,
    displayName: displayName
  });
};

extractReviews = function(productReviews, displayOptions, i18n, datetime) {
  var ref1;
  if (displayOptions == null) {
    displayOptions = {};
  }
  if (!(productReviews != null ? (ref1 = productReviews.reviews) != null ? ref1.length : void 0 : void 0)) {
    return;
  }
  return map(productReviews.reviews, function(review) {
    return processReview(review, displayOptions, i18n, datetime);
  });
};

extractPreviewReviews = function(reviews, displayOptions, i18n, datetime, previewSize) {
  if (displayOptions == null) {
    displayOptions = {};
  }
  if (previewSize == null) {
    previewSize = 3;
  }
  return map(reviews.slice(0, previewSize), function(review) {
    var previewReview;
    previewReview = extend({}, review, {
      isPreviewReview: true,
      placement: 'preview'
    });
    return processReview(previewReview, displayOptions, i18n, datetime);
  });
};

processUserReview = function(userReview, displayOptions, i18n, datetime) {
  var isRatingOnly, ref1, userReviewText;
  if (displayOptions == null) {
    displayOptions = {};
  }
  userReviewText = ((ref1 = userReview.text) != null ? ref1.trim() : void 0) || '';
  isRatingOnly = !userReviewText.length;
  extend(userReview, {
    isPending: userReview.status === 'PENDING',
    isRatingOnly: isRatingOnly,
    isRejected: userReview.status === 'REJECTED',
    isUserReview: true,
    text: isRatingOnly ? i18n.t('js.modules.product_reviews.review_card.rating_only_review') : userReview.text
  });
  return processReview(userReview, displayOptions, i18n, datetime);
};

module.exports = {
  averageRatingText: averageRatingText,
  buildHistogram: buildHistogram,
  extractStats: extractStats,
  formatButtons: formatButtons,
  formatHelpfulText: formatHelpfulText,
  formatDate: formatDate,
  starToHtml: starToHtml,
  ratingToStars: ratingToStars,
  roundAverageRating: roundAverageRating,
  placement: placement,
  reviewIds: reviewIds,
  extractHelpfulUpvote: extractHelpfulUpvote,
  extractDisplayNames: extractDisplayNames,
  processReview: processReview,
  extractReviews: extractReviews,
  extractPreviewReviews: extractPreviewReviews,
  processUserReview: processUserReview
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../core/utils/distribution":4}],70:[function(require,module,exports){
var MAX_PAGINATION_SLOTS_PER_PAGE, NUM_ALLOWED_SELECTED_SLOTS, NUM_SLOTS_OUTSIDE_DOTS, getDotsAndLastPage, getFirstPageAndDots, getPageHash, getPagesByRange, getSlots, paginationFooter,
  slice = [].slice;

MAX_PAGINATION_SLOTS_PER_PAGE = 11;

NUM_SLOTS_OUTSIDE_DOTS = 2;

NUM_ALLOWED_SELECTED_SLOTS = 1;

paginationFooter = function(currentPage, reviewCount, pageSize, I18n) {
  var resultsMessage, totalPages;
  resultsMessage = I18n.p(reviewCount, 'js.modules.product_reviews.pagination.results', {
    formattedReviewCount: I18n.toNumber(reviewCount),
    startingIndex: I18n.toNumber((currentPage - 1) * pageSize + 1),
    endingIndex: I18n.toNumber(Math.min(reviewCount, pageSize * currentPage))
  });
  if (!(currentPage !== 1 || reviewCount > pageSize)) {
    return {
      resultsMessage: resultsMessage
    };
  }
  totalPages = Math.ceil(reviewCount / pageSize);
  return {
    paginationSlots: getSlots(currentPage, totalPages),
    previousPage: {
      text: I18n.t('js.modules.product_reviews.pagination.previous'),
      pageNumber: (currentPage !== 1 ? currentPage - 1 : void 0)
    },
    nextPage: {
      text: I18n.t('js.modules.product_reviews.pagination.next'),
      pageNumber: (currentPage !== totalPages ? currentPage + 1 : void 0)
    },
    resultsMessage: resultsMessage
  };
};

getSlots = function(currentPage, totalPages) {
  var endDotsThreshold, endNumber, numbersRadius, startDotsThreshold, startNumber;
  endDotsThreshold = MAX_PAGINATION_SLOTS_PER_PAGE - NUM_SLOTS_OUTSIDE_DOTS;
  startDotsThreshold = totalPages - MAX_PAGINATION_SLOTS_PER_PAGE + NUM_SLOTS_OUTSIDE_DOTS + 1;
  if (totalPages <= MAX_PAGINATION_SLOTS_PER_PAGE) {
    return getPagesByRange(1, totalPages, currentPage);
  } else if (currentPage < endDotsThreshold) {
    return slice.call(getPagesByRange(1, endDotsThreshold, currentPage)).concat(slice.call(getDotsAndLastPage(currentPage, totalPages)));
  } else if (currentPage > startDotsThreshold) {
    return slice.call(getFirstPageAndDots(currentPage)).concat(slice.call(getPagesByRange(startDotsThreshold, totalPages, currentPage)));
  } else {
    numbersRadius = (MAX_PAGINATION_SLOTS_PER_PAGE - (NUM_SLOTS_OUTSIDE_DOTS * 2) - NUM_ALLOWED_SELECTED_SLOTS) / 2;
    startNumber = currentPage - Math.floor(numbersRadius);
    endNumber = currentPage + Math.ceil(numbersRadius);
    return slice.call(getFirstPageAndDots(currentPage)).concat(slice.call(getPagesByRange(startNumber, endNumber, currentPage)), slice.call(getDotsAndLastPage(currentPage, totalPages)));
  }
};

getFirstPageAndDots = function(currentPage) {
  return [
    getPageHash(1, currentPage), {
      text: '...',
      dots: true,
      pageNumber: false
    }
  ];
};

getDotsAndLastPage = function(currentPage, totalPages) {
  return [
    {
      text: '...',
      dots: true,
      pageNumber: false
    }, getPageHash(totalPages, currentPage)
  ];
};

getPagesByRange = function(from, to, currentPage) {
  var i, pageNumber, ref, ref1, results;
  results = [];
  for (pageNumber = i = ref = from, ref1 = to; ref <= ref1 ? i <= ref1 : i >= ref1; pageNumber = ref <= ref1 ? ++i : --i) {
    results.push(getPageHash(pageNumber, currentPage));
  }
  return results;
};

getPageHash = function(pageNumber, currentPage) {
  return {
    text: pageNumber,
    pageNumber: pageNumber !== currentPage ? pageNumber : void 0
  };
};

module.exports = {
  paginationFooter: paginationFooter
};



},{}],71:[function(require,module,exports){
var ProductReviews, base;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.Model = require('../models/product_review');

ProductReviews.PastPurchases.Collection = Backbone.Collection.extend({
  defaultTimeout: 5000,
  model: ProductReviews.Model,
  initialize: function(models, options1) {
    this.options = options1;
    _.extend(this, this.options);
    _.bindAll(this, 'fetchSuccess', 'fetchError');
    return this.fetch({
      success: this.fetchSuccess,
      error: this.fetchError
    });
  },
  _prepareModel: function(model, options) {
    _.extend(options, this.options);
    options = _.omit(options, ['dealUuid', 'parse', 'view']);
    return Backbone.Collection.prototype._prepareModel.call(this, model, options);
  },
  url: function() {
    return this.rootUrl + "/past_purchases";
  },
  sync: function(method, collection, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.PastPurchases.timeout || this.defaultTimeout;
    return Backbone.Collection.prototype.sync.call(this, method, collection, options);
  },
  excludeCurrentDeal: function() {
    return this.remove(this.where({
      dealUuid: this.dealUuid
    }));
  },
  fetchSuccess: function() {
    this.excludeCurrentDeal();
    if (!this.length) {
      return this.view.hidePastPurchasesLoader();
    }
    return this.view.showPastPurchases();
  },
  fetchError: function() {
    return this.view.hidePastPurchasesLoader();
  }
});

module.exports = ProductReviews.PastPurchases.Collection;



},{"../models/product_review":73}],72:[function(require,module,exports){
var ProductReviews, extractReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Views.ReviewList = require('../views/product_reviews_review_list');

ProductReviews.Model = require('../models/product_review');

if (window.moment == null) {
  window.moment = require('../../../../node_modules/moment/moment.js');
}

extractReviews = require('../../common/helpers').extractReviews;

ProductReviews.Collection = Backbone.Collection.extend({
  defaultTimeout: 3000,
  model: ProductReviews.Model,
  page: 1,
  locale: 'en_US',
  showParams: '',
  sortBy: 'most_recent',
  initialize: function(models, options1) {
    this.options = options1;
    _.extend(this, this.options);
    _.bindAll(this, 'paginationSuccess', 'paginationError');
    if (this.displayOptions.sortBy) {
      return this.sortBy = this.displayOptions.sortBy;
    }
  },
  _prepareModel: function(model, options) {
    _.extend(options, this.options);
    delete options.parse;
    return Backbone.Collection.prototype._prepareModel.call(this, model, options);
  },
  url: function() {
    return this.rootUrl + "/product_review_proxy/reviews.json?deal_uuid=" + this.dealUuid + "&locale=" + this.locale + "&sort=" + this.sortBy + "&limit=" + (this.limit()) + "&offset=" + (this.offset()) + "&show=" + this.showParams;
  },
  sync: function(method, collection, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout || this.defaultTimeout;
    return Backbone.Collection.prototype.sync.call(this, method, collection, options);
  },
  limit: function() {
    return this.pageSize;
  },
  offset: function() {
    return (this.page - 1) * this.pageSize;
  },
  parse: function(response) {
    var i, len, ref, review, user;
    if (!response.reviewable) {
      return;
    }
    if (this.displayOptions.isTouch && (user = response.user)) {
      this.displayOptions.userUpvotedReviews = user.upvotes || [];
      this.displayOptions.userDownvotedReviews = user.downvotes || [];
    }
    if (this.displayOptions.showReviewsPage && this.isPreview) {
      ref = response.reviews || [];
      for (i = 0, len = ref.length; i < len; i++) {
        review = ref[i];
        review.isPreviewReview = true;
      }
    }
    return extractReviews(response, this.displayOptions, I18n, moment);
  },
  initializePreview: function(view) {
    this.view = view;
    if (!this.displayOptions.showReviewsPage) {
      return;
    }
    this.pageSize = this.displayOptions.productReviewsPreview.pageSize;
    return this.action = 'preview';
  },
  nextPage: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page++;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'nextPage';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      remove: false,
      syncForPagination: true
    });
  },
  getPage: function(page) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page = page;
    this.action = 'getPage';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError
    });
  },
  resortReviews: function(sortOrder) {
    this.previousSortBy = this.sortBy;
    this.previousPage = this.page;
    this.page = 1;
    if (sortOrder) {
      this.sortBy = sortOrder;
    }
    this.action = 'resortReviews';
    return this.fetch({
      success: this.paginationSuccess,
      error: this.paginationError,
      reset: true
    });
  },
  paginationSuccess: function(response) {
    return this.view.render(new ProductReviews.Views.ReviewList({
      collection: this
    }));
  },
  paginationError: function(response) {
    this.page = this.previousPage;
    this.sortBy = this.previousSortBy;
    return this.view.showPaginationError(this.action);
  },
  recordUpvote: function(id) {
    return this.displayOptions.userUpvotedReviews.push(id);
  },
  recordUnvote: function(id) {
    this.displayOptions.userUpvotedReviews = _.without(this.displayOptions.userUpvotedReviews, id);
    return this.displayOptions.userDownvotedReviews = _.without(this.displayOptions.userDownvotedReviews, id);
  },
  recordDownvote: function(id) {
    return this.displayOptions.userDownvotedReviews.push(id);
  },
  fetchedReviews: function() {
    if (this.displayOptions.showReviewsPage) {
      return this.models;
    }
    return this.models.slice(this.offset());
  },
  updateReadMore: function(resetHeight) {
    return this.invoke('updateReadMore', resetHeight);
  }
});

module.exports = ProductReviews.Collection;



},{"../../../../node_modules/moment/moment.js":136,"../../common/helpers":69,"../models/product_review":73,"../views/product_reviews_review_list":81}],73:[function(require,module,exports){
var ProductReviews, formatButtons, formatHelpfulText, processUserReview, ref,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (window.moment == null) {
  window.moment = require('../../../../node_modules/moment/moment.js');
}

ProductReviews.Views.UserReview = require('../views/product_reviews_user_review');

ref = require('../../common/helpers'), formatButtons = ref.formatButtons, formatHelpfulText = ref.formatHelpfulText, processUserReview = ref.processUserReview;

ProductReviews.Model = Backbone.Model.extend({
  maximumReviewTextHeight: 109,
  defaultTimeout: 3000,
  idAttribute: 'uuid',
  defaults: {
    rating: 0,
    reviewTextHeight: 0
  },
  initialize: function(attrs, options) {
    _.extend(this, options);
    if (this.dealUuid == null) {
      this.dealUuid = attrs != null ? attrs.dealUuid : void 0;
    }
    _.bindAll(this, 'reviewSuccess', 'reviewError', 'upvoteSuccess', 'upvoteError', 'unvoteSuccess', 'unvoteError', 'downvoteSuccess', 'downvoteError', 'deleteSuccess', 'deleteError');
    return this.set({
      locale: I18n.locale,
      userVote: this.getUserVote()
    });
  },
  getUserVote: function() {
    var ref1, userDownvotedReviews, userUpvotedReviews, uuid;
    if (this.displayOptions) {
      ref1 = this.displayOptions, userUpvotedReviews = ref1.userUpvotedReviews, userDownvotedReviews = ref1.userDownvotedReviews;
    }
    if (!((userUpvotedReviews != null ? userUpvotedReviews.length : void 0) || (userDownvotedReviews != null ? userDownvotedReviews.length : void 0))) {
      return;
    }
    uuid = this.get('uuid');
    if (indexOf.call(userUpvotedReviews, uuid) >= 0) {
      return 'upvoted';
    } else if (indexOf.call(userDownvotedReviews, uuid) >= 0) {
      return 'downvoted';
    }
  },
  url: function(action) {
    if (action == null) {
      action = '';
    }
    return this.rootUrl + "/product_review_proxy/reviews" + action + "?_csrf=" + this.csrf;
  },
  sync: function(method, model, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout || this.defaultTimeout;
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  },
  toJSON: function() {
    return {
      deal_uuid: this.dealUuid,
      option_uuid: this.get('uuid'),
      locale: this.get('locale'),
      rating: this.get('rating'),
      source: this.source,
      text: $.trim(this.get('text'))
    };
  },
  review: function() {
    return this.save(this.toJSON(), {
      type: 'POST',
      wait: true,
      success: this.reviewSuccess,
      error: this.reviewError,
      url: this.url()
    });
  },
  reviewSuccess: function(model, response) {
    var ref1, ref2;
    if (response.error != null) {
      return this.reviewError(model, response);
    }
    if ((ref1 = this.displayOptions) != null) {
      ref1.userReviewIds.push(response.review.uuid);
    }
    this.set(processUserReview(response.review, this.displayOptions, I18n, moment));
    this.view.showReviewSuccess(new ProductReviews.Views.UserReview({
      model: this,
      el: this.view.userReviewEl
    }));
    if ((ref2 = this.displayOptions) != null ? ref2.readMoreEnabled : void 0) {
      return this.updateReadMore();
    }
  },
  reviewError: function(model, response) {
    return this.view.showReviewError();
  },
  upvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.upvoteSuccess,
      error: this.upvoteError,
      url: this.url("/" + this.id + "/upvote")
    });
  },
  upvoteSuccess: function(model, response) {
    var reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount') + 1;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      userVote: 'upvoted',
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, true, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      }
    });
    this.collection.recordUpvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  upvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.upvoteSuccess(model, response);
    }
    return this.view.showVoteError(this);
  },
  isDuplicateError: function(response) {
    return (response.readyState === 4) && (response.status === 409);
  },
  unvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.unvoteSuccess,
      error: this.unvoteError,
      url: this.url("/" + this.id + "/unvote")
    });
  },
  unvoteSuccess: function(model, response) {
    var downvoteCount, reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount') > 0 ? this.get('upvoteCount') - (this.get('userVote') === 'upvoted') : 0;
    downvoteCount = this.get('downvoteCount') > 0 ? this.get('downvoteCount') - (this.get('userVote') === 'downvoted') : 0;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, false, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      },
      downvoteCount: downvoteCount
    });
    this.collection.recordUnvote(this.id);
    return this.view.showUnvoteSuccess(this);
  },
  unvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.unvoteSuccess(model, response);
    }
    return this.view.showUnvoteError(this);
  },
  downvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.downvoteSuccess,
      error: this.downvoteError,
      url: this.url("/" + this.id + "/downvote")
    });
  },
  downvoteSuccess: function(model, response) {
    var downvoteCount, reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount');
    downvoteCount = this.get('downvoteCount') + 1;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      userVote: 'downvoted',
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, true, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      },
      downvoteCount: downvoteCount
    });
    this.collection.recordDownvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  downvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.downvoteSuccess(model, response);
    }
    return this.view.showVoteError(this);
  },
  "delete": function() {
    return this.destroy({
      wait: true,
      success: this.deleteSuccess,
      error: this.deleteError,
      url: this.url("/" + this.id)
    });
  },
  deleteSuccess: function(response) {
    return this.view.showDeleteSuccess(this);
  },
  deleteError: function(response) {
    return this.view.showDeleteError(this);
  },
  setReviewTextHeight: function() {
    var ref1, reviewText, reviewTextId;
    if (!(reviewTextId = (ref1 = this.get('reviewIds')) != null ? ref1.reviewText : void 0)) {
      return;
    }
    reviewText = $("#" + reviewTextId);
    reviewText.parent().removeClass('show');
    return this.set('reviewTextHeight', reviewText.height());
  },
  shouldShowReadMore: function() {
    return this.get('reviewTextHeight') > this.maximumReviewTextHeight;
  },
  updateReadMore: function(resetHeight) {
    if (resetHeight) {
      this.set('reviewTextHeight', 0, {
        silent: true
      });
    }
    if (!this.get('reviewTextHeight')) {
      return this.setReviewTextHeight();
    }
  }
});

module.exports = ProductReviews.Model;



},{"../../../../node_modules/moment/moment.js":136,"../../common/helpers":69,"../views/product_reviews_user_review":83}],74:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.Collection = require('./collections/product_reviews');

ProductReviews.Views.Main = require('./views/product_reviews');

ProductReviews.Views.PaginationFooter = require('./views/pagination_footer');

ProductReviews.Model = require('./models/product_review');

ProductReviews.init = function(arg, done) {
  var collection, csrf, dealTitle, dealUrl, dealUuid, displayOptions, helpful, helpfulCollection, model, pageSize, previewReviews, productReviews, reviewCount, reviewable, reviews, rootUrl, source, userReview;
  csrf = arg.csrf, rootUrl = arg.rootUrl, productReviews = arg.productReviews;
  if (!(productReviews != null ? productReviews.dealUuid : void 0)) {
    return done();
  }
  reviewable = productReviews.reviewable, dealUuid = productReviews.dealUuid, dealUrl = productReviews.dealUrl, dealTitle = productReviews.dealTitle, pageSize = productReviews.pageSize, reviewCount = productReviews.reviewCount, displayOptions = productReviews.displayOptions, source = productReviews.source, reviews = productReviews.reviews, helpful = productReviews.helpful, userReview = productReviews.userReview, previewReviews = productReviews.previewReviews;
  collection = new ProductReviews.Collection(reviews, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions,
    pageSize: pageSize
  });
  helpfulCollection = new ProductReviews.Collection(helpful != null ? helpful.reviews : void 0, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions
  });
  model = new ProductReviews.Model(userReview, {
    rootUrl: rootUrl,
    csrf: csrf,
    dealUuid: dealUuid,
    displayOptions: displayOptions,
    source: source
  });
  return $(function() {
    var main, options, paginationFooter, previewCollection;
    options = {
      rootUrl: rootUrl,
      csrf: csrf,
      reviewable: reviewable,
      dealUuid: dealUuid,
      dealUrl: dealUrl,
      dealTitle: dealTitle,
      collection: collection,
      helpfulCollection: helpfulCollection,
      model: model,
      reviewCount: reviewCount,
      previewCollection: previewCollection,
      displayOptions: displayOptions,
      source: source
    };
    main = new ProductReviews.Views.Main(options);
    if (displayOptions.showReviewsPage) {
      previewCollection = new ProductReviews.Collection(previewReviews, {
        rootUrl: rootUrl,
        csrf: csrf,
        dealUuid: dealUuid,
        displayOptions: displayOptions,
        isPreview: true
      });
      paginationFooter = new ProductReviews.Views.PaginationFooter(options);
      options.el = '#product-reviews-preview';
      options.previewCollection = previewCollection;
      previewCollection.initializePreview(new ProductReviews.Views.Main(options));
    }
    collection.view = main;
    helpfulCollection.view = main;
    model.view = main;
    return done();
  });
};

module.exports = ProductReviews;



},{"./collections/product_reviews":72,"./models/product_review":73,"./views/pagination_footer":75,"./views/product_reviews":79}],75:[function(require,module,exports){
var ProductReviews, paginationFooter;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

paginationFooter = require('../../common/pagination_helpers').paginationFooter;

ProductReviews.Templates['product_reviews_pagination_footer'] = require('../../pagination_footer.html.mustache');

ProductReviews.Views.PaginationFooter = Backbone.View.extend({
  el: '#product-reviews-pagination-footer',
  template: ProductReviews.Templates['product_reviews_pagination_footer'],
  initialize: function() {
    return this.listenTo(this.collection, 'request error', this.reset);
  },
  reset: function() {
    this.updateFooter();
    return this.render();
  },
  updateFooter: function() {
    var page, pageSize, ref, reviewCount;
    reviewCount = this.options.reviewCount;
    ref = this.collection, page = ref.page, pageSize = ref.pageSize;
    return this.footer = paginationFooter(page, reviewCount.value, pageSize, I18n);
  },
  render: function() {
    return this.$el.html(this.template.render({
      paginationFooter: this.footer
    }));
  }
});

module.exports = ProductReviews.Views.PaginationFooter;



},{"../../common/pagination_helpers":70,"../../pagination_footer.html.mustache":84}],76:[function(require,module,exports){
var ProductReviews, base, base1, base2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.PastPurchases.Views = (base1 = window.ProductReviews.PastPurchases).Views != null ? base1.Views : base1.Views = {};

if ((base2 = ProductReviews.PastPurchases).Templates == null) {
  base2.Templates = {};
}

ProductReviews.PastPurchases.Templates['past_purchase'] = require('../../past_purchase.html.mustache');

ProductReviews.Views.ProductReview = require('./product_review');

ProductReviews.PastPurchases.Views.PastPurchase = (function(superClass) {
  extend(PastPurchase, superClass);

  function PastPurchase() {
    return PastPurchase.__super__.constructor.apply(this, arguments);
  }

  PastPurchase.prototype.events = {
    'mouseover .allow-submission .review-star': 'hoverStar',
    'click .allow-submission .review-star': 'clickStar',
    'mouseout .user-rating': 'clearHoverStar',
    'keyup .product-reviews-form-extension textarea': 'updateLengthNotification',
    'click .product-reviews-form-extension button': 'submitReview',
    'click .product-reviews-form-extension a': 'cancelReview',
    'click .review-delete': 'deleteReview',
    'click .review-share': 'showShareTooltip'
  };

  PastPurchase.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.$userReview = this.$el;
    this.listenTo(this.model, 'change:rating', this.updateStars);
    return this.initializeMessages();
  };

  PastPurchase.prototype.render = function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    this.userReviewEl = this.$el.selector;
    this.$el.append(ProductReviews.PastPurchases.Templates['past_purchase'].render(data));
    this.$userRating = this.$el.find('.user-rating');
    this.$ratingDescription = this.$el.find('.rating-description');
    this.$userReviewNotification = this.$el.find('.user-review-notification');
    this.$reviewFormExtension = this.$el.find('.product-reviews-form-extension');
    this.$reviewFormExtensions = this.$el.find('.product-reviews-form-extension');
    this.$reviewText = this.$el.find('.product-reviews-form-extension textarea');
    this.$reviewTextCount = this.$el.find('.product-reviews-form-extension .text-count');
    this.$reviewSubmit = this.$el.find('.product-reviews-form-extension button');
    this.$reviewCancel = this.$el.find('.product-reviews-form-extension a');
    return this;
  };

  PastPurchase.prototype.clickStar = function(e) {
    this.hideTooltips();
    this.model.set('rating', $(e.currentTarget).data('star-rating'));
    return this.model.collection.each((function(_this) {
      return function(pastPurchase) {
        if (pastPurchase.id === _this.model.id) {
          return pastPurchase.view.$reviewFormExtension.slideDown('slow');
        } else {
          return pastPurchase.view.cancelReview();
        }
      };
    })(this));
  };

  PastPurchase.prototype.cancelReview = function() {
    return this.resetForm();
  };

  PastPurchase.prototype.deleteReview = function(e) {
    this.resetNotifications();
    return this.model["delete"]();
  };

  return PastPurchase;

})(ProductReviews.Views.ProductReview);

module.exports = ProductReviews.PastPurchases.Views.PastPurchase;



},{"../../past_purchase.html.mustache":85,"./product_review":78}],77:[function(require,module,exports){
var ProductReviews, base, base1, base2;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.PastPurchases.Views = (base1 = window.ProductReviews.PastPurchases).Views != null ? base1.Views : base1.Views = {};

ProductReviews.PastPurchases.Views.PastPurchase = require('./past_purchase');

if ((base2 = ProductReviews.PastPurchases).Templates == null) {
  base2.Templates = {};
}

ProductReviews.PastPurchases.Templates['past_purchase_list'] = require('../../past_purchase_list.html.mustache');

ProductReviews.PastPurchases.Views.PastPurchaseList = Backbone.View.extend({
  el: '#past-purchase-list',
  render: function() {
    var i, len, pastPurchase, pastPurchases;
    if (!this.collection.models.length) {
      return;
    }
    pastPurchases = this.collection.models;
    this.$el.append(ProductReviews.PastPurchases.Templates['past_purchase_list'].render({
      pastPurchases: _.pluck(pastPurchases, 'attributes')
    }));
    for (i = 0, len = pastPurchases.length; i < len; i++) {
      pastPurchase = pastPurchases[i];
      pastPurchase.view = (new ProductReviews.PastPurchases.Views.PastPurchase({
        model: pastPurchase,
        el: "#past-purchase-" + (pastPurchase.get('dealUuid'))
      })).render();
      (new ProductReviews.Views.ReviewRating({
        model: pastPurchase,
        el: "#past-purchase-" + (pastPurchase.get('dealUuid')) + " .user-rating"
      })).render();
    }
    return this.$el.show();
  }
});

module.exports = ProductReviews.PastPurchases.Views.PastPurchaseList;



},{"../../past_purchase_list.html.mustache":86,"./past_purchase":76}],78:[function(require,module,exports){
var ProductReviewsView;

ProductReviewsView = Backbone.View.extend({
  initializeMessages: function() {
    this.reviewAddSuccessMessage = I18n.t('js.modules.product_reviews.add_review.success');
    this.reviewAddErrorMessage = I18n.t('js.modules.product_reviews.add_review.error');
    this.reviewVoteErrorMessage = I18n.t('js.modules.product_reviews.vote_review.error');
    this.reviewUnvoteSuccessMessage = I18n.t('js.modules.product_reviews.unvote_review.success');
    this.reviewUnvoteErrorMessage = I18n.t('js.modules.product_reviews.unvote_review.error');
    this.reviewDeleteSuccessMessage = I18n.t('js.modules.product_reviews.delete_user_review.success');
    return this.reviewDeleteErrorMessage = I18n.t('js.modules.product_reviews.delete_user_review.error');
  },
  updateRatingDescriptionText: function(star) {
    return this.$ratingDescription.text(star ? "\"" + (I18n.t("js.modules.product_reviews.review_form.rating_description.rating_" + star)) + "\"" : '');
  },
  hoverStar: function(e) {
    var $star, i, rating, x;
    if (this.$userStars == null) {
      this.$userStars = this.$userRating.find('.review-star');
    }
    this.$userStars.removeClass('selected-star');
    rating = $(e.currentTarget).data('star-rating');
    for (x = i = 1; i <= 5; x = ++i) {
      $star = this.$userReview.find(".review-star-" + x);
      if (x <= rating) {
        $star.addClass('hovered-star');
      } else {
        $star.removeClass('hovered-star').addClass('empty-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  clearHoverStar: function() {
    var $star, i, rating, x;
    if (this.$userStars == null) {
      this.$userStars = this.$userRating.find('.review-star');
    }
    this.$userStars.removeClass('hovered-star');
    rating = this.model.get('rating');
    for (x = i = 1; i <= 5; x = ++i) {
      $star = this.$userReview.find(".review-star-" + x);
      if (x <= rating) {
        $star.addClass('selected-star');
      } else {
        $star.addClass('empty-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  updateStars: function() {
    var $star, i, rating, x;
    rating = this.model.get('rating');
    for (x = i = 1; i <= 5; x = ++i) {
      $star = this.$userReview.find(".review-star-" + x);
      if (x <= rating) {
        $star.removeClass('empty-star').addClass('selected-star');
      } else {
        $star.addClass('empty-star').removeClass('selected-star');
      }
    }
    return this.updateRatingDescriptionText(rating);
  },
  submitReview: function() {
    this.resetNotifications();
    this.model.set('text', this.$reviewText.val().trim());
    this.disableSubmit();
    this.$reviewCancel.hide();
    return this.model.review();
  },
  showReviewSuccess: function(userReview) {
    this.resetForm();
    userReview.render();
    this.$reviewSubmit.hide();
    this.$ratingDescription.hide();
    this.showReviewSuccessNotification();
    this.reloadBindings();
    return this.disableStarButton();
  },
  showReviewError: function() {
    this.$userReviewNotification.removeClass('success').addClass('error').text(this.reviewAddErrorMessage).show();
    this.enableSubmit();
    return this.$reviewCancel.show();
  },
  showReviewSuccessNotification: function() {
    return this.$userReviewNotification.removeClass('error').addClass('success').text(this.reviewAddSuccessMessage).show();
  },
  enableSubmit: function() {
    return this.$reviewSubmit.removeAttr('disabled').removeClass('btn-secondary');
  },
  disableSubmit: function() {
    return this.$reviewSubmit.attr('disabled', 'disabled').addClass('btn-secondary');
  },
  disableStarButton: function() {
    this.$userRating.removeClass('allow-submission').hide();
    return this.$userStars.removeClass('hovered-star');
  },
  resetNotifications: function() {
    return $('.review-notification').hide();
  },
  hideTooltips: function() {
    return GIG.Tooltip.close(this.$tooltips);
  },
  resetForm: function() {
    this.resetNotifications();
    this.hideTooltips();
    this.model.set('rating', 0);
    this.$reviewFormExtension.slideUp('slow');
    this.enableSubmit();
    return this.$reviewCancel.show();
  },
  updateLengthNotification: function() {
    var reviewLength;
    reviewLength = this.$reviewText.val().trim().length;
    return this.$reviewTextCount.text(reviewLength);
  },
  reloadBindings: function() {
    if (this.$userReview.length) {
      GIG.Tooltip.reloadBindings(this.$userReview);
    }
    if ($('#product-reviews-login-required-tooltip').length || $('#product-reviews-pending-tooltip').length || $('#product-reviews-share-tooltip').length) {
      GIG.Tooltip.reloadBindings(this.$el);
    }
    if ($('#login-modal').length) {
      return IframeLogin.reloadBindings(this.$el);
    }
  },
  showDeleteSuccess: function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    this.$userReview.find('.review-delete').hide();
    return this.$userReview.find("#" + reviewIds.notification).removeClass('error').addClass('success').text(this.reviewDeleteSuccessMessage).show();
  },
  showDeleteError: function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    this.$userReview.find('.review-delete').hide();
    return this.$userReview.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(this.reviewDeleteErrorMessage).show();
  }
});

module.exports = ProductReviewsView;



},{}],79:[function(require,module,exports){
var ProductReviews, base, base1,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.PastPurchases.Views = (base1 = window.ProductReviews.PastPurchases).Views != null ? base1.Views : base1.Views = {};

ProductReviews.PastPurchases.Collection = require('../collections/past_purchases');

ProductReviews.PastPurchases.Views.PastPurchaseList = require('./past_purchase_list');

ProductReviews.Views.ProductReview = require('./product_review');

ProductReviews.Views.Main = (function(superClass) {
  extend(Main, superClass);

  function Main() {
    return Main.__super__.constructor.apply(this, arguments);
  }

  Main.prototype.el = '#product-reviews';

  Main.prototype.userReviewEl = '#user-review';

  Main.prototype.events = {
    'mouseover #user-review .allow-submission .review-star': 'hoverStar',
    'click #user-review .allow-submission .review-star': 'clickStar',
    'mouseout #user-review .user-rating': 'clearHoverStar',
    'keyup #user-review .product-reviews-form-extension textarea': 'updateLengthNotification',
    'click #user-review .product-reviews-form-extension button': 'submitReview',
    'click #user-review .product-reviews-form-extension a': 'cancelReview',
    'click .allow-submission.vote-up': 'voteReviewUp',
    'click .allow-submission.vote-down': 'voteReviewDown',
    'click .vote-undo-link': 'voteUndo',
    'click .allow-submission.review-delete': 'deleteReview',
    'click .review-share': 'showShareTooltip',
    'click #product-reviews-pagination-button': 'showMoreReviews',
    'change #product-reviews-sort-select': 'resortReviews',
    'click #preview-page-all-reviews-button': 'showReviewsPage',
    'click .product-reviews-back-to-deal': 'backToDealPage',
    'click #product-reviews-pagination-footer li': 'renderPage'
  };

  Main.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.$userReview = $(this.userReviewEl);
    _.extend(this, this.options);
    this.listenTo(this.model, 'change:rating', this.updateStars);
    this.initializeTooltips();
    this.initializeAnchors();
    this.initializeMessages();
    this.$body = $('body');
    this.$htmlBody = $('html, body');
    this.$header = $('header');
    this.$productReviews = $('#product-reviews');
    this.$preview = $('#product-reviews-preview');
    this.$userRating = this.$userReview.find('.user-rating');
    this.$ratingDescription = this.$userReview.find('.rating-description');
    this.$userReviewNotification = this.$userReview.find('.user-review-notification');
    this.$reviewFormExtension = this.$userReview.find('.product-reviews-form-extension');
    this.$reviewText = this.$userReview.find('.product-reviews-form-extension textarea');
    this.$reviewTextCount = this.$userReview.find('.product-reviews-form-extension .text-count');
    this.$reviewSubmit = this.$userReview.find('.product-reviews-form-extension button');
    this.$reviewCancel = this.$userReview.find('.product-reviews-form-extension a');
    this.$sortNotification = this.$el.find('#product-reviews-sort-notification');
    this.$paginationNotification = this.$el.find('#product-reviews-pagination-notification');
    this.$paginationLoader = this.$el.find('#product-reviews-pagination-loader');
    this.$paginationButton = this.$el.find('#product-reviews-pagination');
    this.$reviewFilter = this.$el.find('#product-reviews-sort-select');
    this.$reviewList = this.$el.find('#product-reviews-list');
    this.$reviewsPageHeader = this.$el.find('#product-reviews-page-header');
    this.$reviewsHeader = this.$el.find('#product-reviews-header');
    return this.$reviewsQuickView = $('#product-reviews-quick-view');
  };

  Main.prototype.initializeTooltips = function() {
    this.$quickViewTooltipTrigger = $('#product-reviews-quick-view.tooltip-trigger');
    this.$formRatingTooltipTrigger = $('#product-reviews-form-rating.tooltip-trigger');
    this.$quickViewTooltip = $('#product-reviews-quick-view-tooltip');
    this.$loginRequiredTooltip = $('#product-reviews-login-required-tooltip');
    this.$shareTooltip = $('#product-reviews-share-tooltip');
    this.$tooltips = $('.tooltip');
    this.$quickViewTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-quick-view');
      };
    })(this));
    return this.$formRatingTooltipTrigger.mouseover((function(_this) {
      return function(e) {
        return _this.$quickViewTooltip.attr('data-trigger', 'product-reviews-form-rating');
      };
    })(this));
  };

  Main.prototype.initializeAnchors = function() {
    this.$anchors = $('#product-ratings, .product-reviews-anchor');
    this.$stickyHeader = $('#sticky-head');
    return this.$anchors.click((function(_this) {
      return function(e) {
        e.preventDefault();
        return _this.scrollToProductReviews();
      };
    })(this));
  };

  Main.prototype.scrollToProductReviews = function() {
    var $productReviewsEl;
    if (this.$body.hasClass('show-pr-submission' || this.$body.hasClass('product-reviews-page-active'))) {
      return;
    }
    $productReviewsEl = this.displayOptions.showReviewsPage && !this.$body.hasClass('product-reviews-page-active') ? this.$preview : this.$productReviews;
    return this.$htmlBody.animate({
      scrollTop: $productReviewsEl.offset().top - this.$stickyHeader.outerHeight()
    }, 'slow');
  };

  Main.prototype.scrollToTop = function() {
    return this.$htmlBody.animate({
      scrollTop: this.$header.outerHeight()
    }, 'slow');
  };

  Main.prototype.render = function(reviewList) {
    this.resetNotifications();
    reviewList.render();
    this.reloadBindings();
    this.updatePagination();
    this.$paginationLoader.hide();
    return this.$reviewList.show();
  };

  Main.prototype.hideMessages = function() {
    this.hideTooltips();
    return this.resetNotifications();
  };

  Main.prototype.httpsRedirect = function(element) {
    return window.location.assign("" + this.dealUrl + element);
  };

  Main.prototype.showShareTooltip = function(e) {
    var $reviewCard, emailBody, emailSubject, hrefText, text, username;
    $reviewCard = $(e.currentTarget).closest(".review-card");
    if ($reviewCard.length) {
      username = $reviewCard.find('.review-display-name').data('display-name');
      text = $reviewCard.find('.review-text').text();
      emailSubject = encodeURIComponent(I18n.t('js.modules.product_reviews.share_review.email_subject', {
        dealTitle: this.dealTitle,
        username: username
      }));
      emailBody = encodeURIComponent(this.dealTitle + "\n" + this.dealUrl + "\n\n\"" + text + "\"\n- " + username);
      hrefText = "mailto:?subject=" + emailSubject + "&body=" + emailBody + "&utm_campaign=UserReferral&utm_medium=email&utm_source=uu";
      return this.$shareTooltip.find('.icon-email').attr('href', hrefText);
    }
  };

  Main.prototype.showMoreReviews = function() {
    this.hideMessages();
    this.$paginationLoader.show();
    return this.collection.nextPage(this.$reviewFilter.val());
  };

  Main.prototype.renderPage = function(e) {
    var page;
    if ($(e.currentTarget).hasClass('disabled')) {
      return;
    }
    page = $(e.currentTarget).find('.page-number').data('page-number');
    this.$htmlBody.animate({
      scrollTop: this.$reviewsPageHeader.offset().top - this.$stickyHeader.outerHeight()
    }, 'slow');
    this.$paginationLoader.show();
    this.collection.getPage(parseInt(page));
    return this.hideMessages();
  };

  Main.prototype.showReviewsPage = function() {
    this.$body.addClass('product-reviews-page-active');
    this.$reviewsQuickView.removeAttr('data-tooltip-id');
    this.scrollToTop();
    return this.hideMessages();
  };

  Main.prototype.backToDealPage = function() {
    this.$body.removeClass('product-reviews-page-active show-pr-submission');
    this.$reviewsQuickView.attr('data-tooltip-id', 'product-reviews-quick-view-tooltip');
    return this.cancelReview();
  };

  Main.prototype.sendDropdownTrackingEvent = function() {
    return OptimizeSuite.TrackingHub.add('product-reviews-sort', {
      data: this.$reviewFilter.val()
    });
  };

  Main.prototype.resortReviews = function() {
    this.hideMessages();
    if (!this.displayOptions.showReviewsPage) {
      this.$reviewList.hide();
    }
    this.$paginationLoader.show();
    this.collection.resortReviews(this.$reviewFilter.val());
    return this.sendDropdownTrackingEvent();
  };

  Main.prototype.updatePagination = function() {
    var displayedReviewCount, reviewsLength;
    reviewsLength = this.collection.length;
    displayedReviewCount = {
      formatted: I18n.toNumber(reviewsLength),
      value: reviewsLength
    };
    this.$el.find('#product-reviews-display-count span').text(I18n.t('js.modules.product_reviews.pagination.showing_count', {
      formattedDisplayedReviewCount: displayedReviewCount.formatted,
      formattedReviewCount: this.reviewCount.formatted
    }));
    if (displayedReviewCount.value < this.reviewCount.value) {
      return this.$paginationButton.show();
    } else {
      return this.$paginationButton.hide();
    }
  };

  Main.prototype.findReview = function(placement, id) {
    switch (placement) {
      case 'helpful':
        return this.helpfulCollection.get(id);
      case 'preview':
        return this.previewCollection.get(id);
      default:
        return this.collection.get(id);
    }
  };

  Main.prototype.showPaginationError = function(action) {
    this.$paginationLoader.hide();
    this.$reviewList.show();
    this.$reviewFilter.val(this.collection.sortBy);
    switch (action) {
      case 'nextPage':
      case 'getPage':
        return this.$paginationNotification.show();
      case 'resortReviews':
        return this.$sortNotification.show();
    }
  };

  Main.prototype.clickStar = function(e) {
    if (!this.reviewable) {
      return this.httpsRedirect('#product-reviews');
    }
    this.hideTooltips();
    if (this.displayOptions.showReviewSubmissionPage && !this.$body.hasClass('show-pr-submission')) {
      this.showSubmissionPage();
    }
    this.model.set('rating', $(e.currentTarget).data('star-rating'));
    return this.$reviewFormExtension.slideDown('slow');
  };

  Main.prototype.cancelReview = function() {
    this.resetForm();
    if (!this.$body.hasClass('show-pr-submission')) {
      return;
    }
    this.$body.removeClass('show-pr-submission');
    return this.scrollToTop();
  };

  Main.prototype.deleteReview = function(e) {
    if (!this.reviewable) {
      return this.httpsRedirect(this.el);
    }
    this.resetNotifications();
    return this.model["delete"]();
  };

  Main.prototype.voteReview = function(e, fnName) {
    var $target, anchor, review;
    $target = $(e.currentTarget);
    if (!this.reviewable) {
      anchor = (function() {
        switch ($target.data('review-placement')) {
          case 'helpful':
            return '#product-reviews-helpful-reviews';
          case 'preview':
            return '#product-reviews-preview-list';
          default:
            return '#product-reviews-list';
        }
      })();
      return this.httpsRedirect(anchor);
    }
    review = this.findReview($target.data('review-placement'), $target.data('review-id'));
    $target.parent().children('button').attr('disabled', 'disabled');
    this.resetNotifications();
    review.view = this;
    return typeof review[fnName] === "function" ? review[fnName]() : void 0;
  };

  Main.prototype.voteReviewUp = function(e) {
    return this.voteReview(e, 'upvote');
  };

  Main.prototype.voteUndo = function(e) {
    return this.voteReview(e, 'unvote');
  };

  Main.prototype.voteReviewDown = function(e) {
    return this.voteReview(e, 'downvote');
  };

  Main.prototype.showVoteSuccess = function(model) {
    var button, helpfulUpvote, i, len, noButton, ref, results, reviewIds;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    noButton = $("#" + reviewIds.voteDown);
    if (noButton.length) {
      noButton.parent().hide();
    }
    this.$el.find("#" + reviewIds.voteText).text(helpfulUpvote.text);
    $("#" + reviewIds.voteUndo).show();
    if (this.displayOptions.showReviewsPage) {
      ref = $("button[data-review-id=" + model.id + "]");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        button = ref[i];
        $(button).prop('disabled', true);
        results.push($(button).parent().hide());
      }
      return results;
    }
  };

  Main.prototype.showVoteError = function(model) {
    var helpfulUpvote, noButton, reviewIds, yesButton;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    yesButton = $("#" + reviewIds.voteUp).removeAttr('disabled');
    noButton = $("#" + reviewIds.voteDown).removeAttr('disabled');
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(this.reviewVoteErrorMessage).show();
  };

  Main.prototype.showUnvoteSuccess = function(model) {
    var button, helpfulUpvote, i, len, ref, results, reviewIds;
    reviewIds = model.get('reviewIds');
    helpfulUpvote = model.get('helpfulUpvote');
    $("#" + reviewIds.voteUp).removeAttr('disabled');
    $("#" + reviewIds.voteDown).removeAttr('disabled');
    $("#" + reviewIds.card + " .review-vote").show();
    this.$el.find("#" + reviewIds.voteText).text(helpfulUpvote.text);
    this.$el.find("#" + reviewIds.notification).removeClass('error').addClass('success').text(this.reviewUnvoteSuccessMessage).show();
    if (this.displayOptions.showReviewsPage) {
      ref = $("button[data-review-id=" + model.id + "]");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        button = ref[i];
        $(button).removeProp('disabled');
        results.push($(button).parent().show());
      }
      return results;
    }
  };

  Main.prototype.showUnvoteError = function(model) {
    var reviewIds;
    reviewIds = model.get('reviewIds');
    return this.$el.find("#" + reviewIds.notification).removeClass('success').addClass('error').text(this.reviewUnvoteErrorMessage).show();
  };

  Main.prototype.showSubmissionPage = function() {
    this.$body.addClass('show-pr-submission');
    this.scrollToTop();
    return this.pastPurchases != null ? this.pastPurchases : this.pastPurchases = new ProductReviews.PastPurchases.Collection([], {
      rootUrl: this.rootUrl,
      csrf: this.csrf,
      dealUuid: this.dealUuid,
      source: this.source,
      view: this
    });
  };

  Main.prototype.showPastPurchases = function() {
    (new ProductReviews.PastPurchases.Views.PastPurchaseList({
      collection: this.pastPurchases
    })).render();
    return this.hidePastPurchasesLoader();
  };

  Main.prototype.hidePastPurchasesLoader = function() {
    return $('#product-reviews-past-purchases .loader').hide();
  };

  return Main;

})(ProductReviews.Views.ProductReview);

module.exports = ProductReviews.Views.Main;



},{"../collections/past_purchases":71,"./past_purchase_list":77,"./product_review":78}],80:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_card'] = require('../../review_card.html.mustache');

ProductReviews.Views.ReviewCard = Backbone.View.extend({
  events: {
    'click .read-more': 'toggleReadMore'
  },
  initialize: function() {
    var ref;
    if ((ref = this.model.displayOptions) != null ? ref.readMoreEnabled : void 0) {
      return this.listenTo(this.model, 'change:reviewTextHeight', this.updateReadMore);
    }
  },
  render: function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      displayOptions: this.model.displayOptions,
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    this.$el.append(ProductReviews.Templates['product_reviews_review_card'].render(data));
    this.$readMore = this.$el.find('.read-more');
    return this.$reviewText = this.$el.find('.review-text-container');
  },
  updateReadMore: function() {
    return this.$reviewText.toggleClass('show', this.model.shouldShowReadMore());
  },
  toggleReadMore: function() {
    if (this.$reviewText.hasClass('expanded')) {
      this.$reviewText.removeClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_more'));
    } else {
      this.$reviewText.addClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_less'));
    }
  }
});

module.exports = ProductReviews.Views.ReviewCard;



},{"../../review_card.html.mustache":87}],81:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_list'] = require('../../review_list.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.ReviewList = Backbone.View.extend({
  el: "#product-reviews-list",
  render: function() {
    var fetchedReviews, i, len, prefix, results, review;
    fetchedReviews = this.collection.fetchedReviews();
    if (this.collection.page === 1 || this.collection.displayOptions.showReviewsPage) {
      this.$el.html(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    } else {
      this.$el.append(ProductReviews.Templates['product_reviews_review_list'].render({
        reviews: _.pluck(fetchedReviews, 'attributes')
      }));
    }
    prefix = this.collection.isPreview ? 'preview-' : '';
    results = [];
    for (i = 0, len = fetchedReviews.length; i < len; i++) {
      review = fetchedReviews[i];
      (new ProductReviews.Views.ReviewCard({
        model: review,
        el: "#" + prefix + "review-card-" + review.id
      })).render();
      results.push((new ProductReviews.Views.ReviewRating({
        model: review,
        el: "#" + prefix + "review-rating-" + review.id
      })).render());
    }
    return results;
  }
});

module.exports = ProductReviews.Views.ReviewList;



},{"../../review_list.html.mustache":88,"./product_reviews_review_card":80,"./product_reviews_review_rating":82}],82:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_stars'] = require('../../stars.html.mustache');

ProductReviews.Views.ReviewRating = Backbone.View.extend({
  render: function() {
    return this.$el.append(ProductReviews.Templates['product_reviews_stars'].render(this.model.attributes));
  }
});

module.exports = ProductReviews.Views.ReviewRating;



},{"../../stars.html.mustache":89}],83:[function(require,module,exports){
var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_user_review'] = require('../../user_review.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.UserReview = Backbone.View.extend({
  render: function() {
    this.$el.find('.product-reviews-form-extension').after(ProductReviews.Templates['product_reviews_user_review'].render({
      userReview: this.model.attributes
    }));
    (new ProductReviews.Views.ReviewCard({
      model: this.model,
      el: this.$el.selector + " .user-review-card"
    })).render();
    return (new ProductReviews.Views.ReviewRating({
      model: this.model,
      el: this.$el.selector + " .user-review-card .review-rating"
    })).render();
  }
});

module.exports = ProductReviews.Views.UserReview;



},{"../../user_review.html.mustache":90,"./product_reviews_review_card":80,"./product_reviews_review_rating":82}],84:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("paginationFooter",c,p,1),c,p,0,23,973,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <ul>");t.b("\n" + i);if(t.s(t.f("previousPage",c,p,1),c,p,0,54,314,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li");if(!t.s(t.f("pageNumber",c,p,1),c,p,1,0,0,"")){t.b(" class=\"disabled\"");};t.b(">");t.b("\n" + i);t.b("        <span");if(t.s(t.f("pageNumber",c,p,1),c,p,0,147,183,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-page-number=\"");t.b(t.v(t.f("pageNumber",c,p,0)));t.b("\"");});c.pop();}t.b(" class=\"page-number previous icon-arrow-left-large\" data-bhc=\"control:previous\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("paginationSlots",c,p,1),c,p,0,361,623,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li");if(!t.s(t.f("pageNumber",c,p,1),c,p,1,0,0,"")){t.b(" class=\"disabled\"");};t.b(">");t.b("\n" + i);t.b("        <span");if(t.s(t.f("pageNumber",c,p,1),c,p,0,454,490,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-page-number=\"");t.b(t.v(t.f("pageNumber",c,p,0)));t.b("\"");});c.pop();}t.b(" class=\"page-number");if(!t.s(t.f("dots",c,p,1),c,p,1,0,0,"")){t.b(" number-link");};t.b("\" data-bhc=\"page:");t.b(t.v(t.f("text",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("nextPage",c,p,1),c,p,0,666,919,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li");if(!t.s(t.f("pageNumber",c,p,1),c,p,1,0,0,"")){t.b(" class=\"disabled\"");};t.b(">");t.b("\n" + i);t.b("        <span");if(t.s(t.f("pageNumber",c,p,1),c,p,0,759,795,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" data-page-number=\"");t.b(t.v(t.f("pageNumber",c,p,0)));t.b("\"");});c.pop();}t.b(" class=\"page-number next icon-arrow-right-large\" data-bhc=\"control:next\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);t.b("  <p>");t.b(t.v(t.f("resultsMessage",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# paginationFooter }}\n  <ul>\n    {{# previousPage }}\n      <li{{^ pageNumber }} class=\"disabled\"{{/ pageNumber }}>\n        <span{{# pageNumber }} data-page-number=\"{{ pageNumber }}\"{{/ pageNumber }} class=\"page-number previous icon-arrow-left-large\" data-bhc=\"control:previous\">{{ text }}</span>\n      </li>\n    {{/ previousPage }}\n\n    {{# paginationSlots }}\n      <li{{^ pageNumber }} class=\"disabled\"{{/ pageNumber }}>\n        <span{{# pageNumber }} data-page-number=\"{{ pageNumber }}\"{{/ pageNumber }} class=\"page-number{{^ dots }} number-link{{/ dots }}\" data-bhc=\"page:{{ text }}\">{{ text }}</span>\n      </li>\n    {{/ paginationSlots }}\n\n    {{# nextPage }}\n      <li{{^ pageNumber }} class=\"disabled\"{{/ pageNumber }}>\n        <span{{# pageNumber }} data-page-number=\"{{ pageNumber }}\"{{/ pageNumber }} class=\"page-number next icon-arrow-right-large\" data-bhc=\"control:next\">{{ text }}</span>\n      </li>\n    {{/ nextPage }}\n  </ul>\n  <p>{{ resultsMessage }}</p>\n{{/ paginationFooter }}\n", Hogan);
},{"hogan.js":133}],85:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"product-reviews-form\">");t.b("\n" + i);t.b("  <img src=\"");t.b(t.v(t.f("imageSrc",c,p,0)));t.b("\" />");t.b("\n" + i);t.b("  <div class=\"product-reviews-product-info\">");t.b("\n" + i);t.b("    <h3><a href=\"");t.b(t.v(t.f("dealUrl",c,p,0)));t.b("\" target=\"_blank\">");t.b(t.v(t.f("title",c,p,0)));t.b("</a></h3>");t.b("\n" + i);t.b("    <h4>");t.b(t.v(t.f("purchasedOn",c,p,0)));t.b("</h4>");t.b("\n" + i);t.b("    <div class=\"btn-secondary user-rating allow-submission\" data-bhw=\"ProductReviewsPastPurchaseUserRating\">");t.b("\n" + i);t.b(t.rp("<product_reviews_stars0",c,p,"      "));t.b("    </div>");t.b("\n" + i);t.b("    <span class=\"rating-description\"></span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"product-reviews-form-extension\" data-bhw=\"ProductReviewsPastPurchaseForm\">");t.b("\n" + i);t.b("  <label for=\"product-reviews-form-textarea-");t.b(t.v(t.f("dealUuid",c,p,0)));t.b("\" class=\"accessibility-hidden\">");if(t.s(t.f("translate",c,p,1),c,p,0,619,675,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_form.product_review_label");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("  <textarea id=\"product-reviews-form-textarea-");t.b(t.v(t.f("dealUuid",c,p,0)));t.b("\" placeholder=\"");if(t.s(t.f("translate",c,p,1),c,p,0,791,839,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_form.review_hints");});c.pop();}t.b("\" maxlength=\"");t.b(t.v(t.f("maximumReviewLength",c,p,0)));t.b("\"></textarea>");t.b("\n" + i);t.b("  <div class=\"product-reviews-review-length-notification\">");if(t.s(t.f("translate",c,p,1),c,p,0,981,1027,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_form.characters");});c.pop();}t.b(" <span class=\"text-count\">0</span></div>");t.b("\n" + i);t.b("  <button class=\"btn\" data-bhw=\"ProductReviewsPastPurchaseFormSubmit\">");if(t.s(t.f("translate",c,p,1),c,p,0,1170,1212,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_form.submit");});c.pop();}t.b("</button>");t.b("\n" + i);t.b("  <a data-bhw=\"ProductReviewsPastPurchaseFormCancel\">");if(t.s(t.f("translate",c,p,1),c,p,0,1307,1349,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_form.cancel");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"notification review-notification user-review-notification\"></div>");t.b("\n");t.b("\n");return t.fl(); },partials: {"<product_reviews_stars0":{name:"product_reviews_stars", partials: {}, subs: {  }}}, subs: {  }}, "<div class=\"product-reviews-form\">\n  <img src=\"{{ imageSrc }}\" />\n  <div class=\"product-reviews-product-info\">\n    <h3><a href=\"{{ dealUrl }}\" target=\"_blank\">{{ title }}</a></h3>\n    <h4>{{ purchasedOn }}</h4>\n    <div class=\"btn-secondary user-rating allow-submission\" data-bhw=\"ProductReviewsPastPurchaseUserRating\">\n      {{> product_reviews_stars }}\n    </div>\n    <span class=\"rating-description\"></span>\n  </div>\n</div>\n<div class=\"product-reviews-form-extension\" data-bhw=\"ProductReviewsPastPurchaseForm\">\n  <label for=\"product-reviews-form-textarea-{{ dealUuid }}\" class=\"accessibility-hidden\">{{# translate }}modules.product_reviews.review_form.product_review_label{{/ translate }}</label>\n  <textarea id=\"product-reviews-form-textarea-{{ dealUuid }}\" placeholder=\"{{# translate }}modules.product_reviews.review_form.review_hints{{/ translate }}\" maxlength=\"{{ maximumReviewLength }}\"></textarea>\n  <div class=\"product-reviews-review-length-notification\">{{# translate }}modules.product_reviews.review_form.characters{{/ translate }} <span class=\"text-count\">0</span></div>\n  <button class=\"btn\" data-bhw=\"ProductReviewsPastPurchaseFormSubmit\">{{# translate }}modules.product_reviews.review_form.submit{{/ translate }}</button>\n  <a data-bhw=\"ProductReviewsPastPurchaseFormCancel\">{{# translate }}modules.product_reviews.review_form.cancel{{/ translate }}</a>\n</div>\n<div class=\"notification review-notification user-review-notification\"></div>\n\n", Hogan);
},{"hogan.js":133}],86:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("pastPurchases",c,p,1),c,p,0,20,163,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"past-purchase\" id=\"past-purchase-");t.b(t.v(t.f("dealUuid",c,p,0)));t.b("\" data-bhc=\"");t.b(t.v(t.f("bhc",c,p,0)));t.b("\" data-bhd=\"");t.b(t.v(t.f("bhd",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# pastPurchases }}\n  <div class=\"past-purchase\" id=\"past-purchase-{{ dealUuid }}\" data-bhc=\"{{ bhc }}\" data-bhd=\"{{ bhd }}\" data-bh-viewport=\"respect\">\n  </div>\n{{/ pastPurchases }}\n", Hogan);
},{"hogan.js":133}],87:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"review-header\">");t.b("\n" + i);t.b("  <div class=\"review-header-line\">");t.b("\n" + i);t.b("    <div class=\"review-info\">");t.b("\n" + i);t.b("      <span class=\"review-rating\" id=\"");t.b(t.v(t.d("reviewIds.rating",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<product_reviews_stars0",c,p,"        "));t.b("      </span>");t.b("\n" + i);t.b("      <span class=\"review-display-name should-truncate\" data-display-name=\"");t.b(t.v(t.f("displayName",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("username",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);if(t.s(t.f("verifiedPurchaser",c,p,1),c,p,0,369,549,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <span class=\"review-verified-purchaser icon-check\">");t.b("\n" + i);t.b("          ");if(t.s(t.f("translate",c,p,1),c,p,0,456,510,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.verified_purchaser");});c.pop();}t.b("\n" + i);t.b("        </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isPending",c,p,1),c,p,0,597,914,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">");t.b("\n" + i);t.b("          ");if(t.s(t.f("translate",c,p,1),c,p,0,793,843,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.review_pending");});c.pop();}t.b("<span class=\"icon-question\"></span>");t.b("\n" + i);t.b("        </a>");t.b("\n" + i);});c.pop();}if(t.s(t.f("isRejected",c,p,1),c,p,0,954,1108,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <span class=\"review-status\">");t.b("\n" + i);t.b("          ");if(t.s(t.f("translate",c,p,1),c,p,0,1018,1069,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.review_rejected");});c.pop();}t.b("\n" + i);t.b("        </span>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("    <span class=\"review-date\">");t.b(t.v(t.f("date",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"review-text-container\">");t.b("\n" + i);t.b("  <div class=\"review-text");if(t.s(t.f("isRatingOnly",c,p,1),c,p,0,1281,1300,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" rating-only-review");});c.pop();}t.b("\" id=\"");t.b(t.v(t.d("reviewIds.reviewText",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</div>");t.b("\n" + i);if(t.s(t.d("displayOptions.readMoreEnabled",c,p,1),c,p,0,1409,1535,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"read-more\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,1460,1505,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.read_more");});c.pop();}t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n" + i);t.b("<div class=\"review-actions\">");t.b("\n" + i);if(t.s(t.f("helpfulUpvote",c,p,1),c,p,0,1631,2965,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("buttonInfo",c,p,1),c,p,0,1653,2415,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"review-vote\">");t.b("\n" + i);t.b("        <span class=\"review-vote-prompt\">");if(t.s(t.f("translate",c,p,1),c,p,0,1743,1793,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.helpful.prompt");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("buttons",c,p,1),c,p,0,1839,2383,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <button");t.b("\n" + i);t.b("            id=\"");t.b(t.v(t.f("voteId",c,p,0)));t.b("\"");t.b("\n" + i);t.b("            class=\"btn-secondary btn-small ");t.b(t.v(t.f("voteClass",c,p,0)));t.b(" ");t.b(t.v(t.d("displayOptions.loginRequired.triggerClass",c,p,0)));t.b("\"");t.b("\n" + i);t.b("            ");t.b(t.t(t.d("displayOptions.loginRequired.triggerData.vote",c,p,0)));t.b("\n" + i);t.b("            ");if(t.s(t.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,2121,2147,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("data-login-required=\"true\"");});c.pop();}t.b("\n" + i);t.b("            data-review-id=\"");t.b(t.v(t.f("uuid",c,p,0)));t.b("\"");t.b("\n" + i);t.b("            data-review-placement=\"");t.b(t.v(t.f("placement",c,p,0)));t.b("\"");t.b("\n" + i);t.b("            data-bhw=\"ProductReviewsVote\">");t.b("\n" + i);t.b("              ");t.b(t.v(t.f("text",c,p,0)));t.b("\n" + i);t.b("          </button>");t.b("\n" + i);});c.pop();}t.b("      </div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("undoText",c,p,1),c,p,0,2452,2947,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div id=\"");t.b(t.v(t.d("reviewIds.voteUndo",c,p,0)));t.b("\" class=\"review-vote-undo notification review-notification success\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,2585,2634,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.helpful.voted");});c.pop();}t.b("\n" + i);t.b("        <a");t.b("\n" + i);t.b("          class=\"vote-undo-link\"");t.b("\n" + i);t.b("          data-review-id=\"");t.b(t.v(t.f("uuid",c,p,0)));t.b("\"");t.b("\n" + i);t.b("          data-review-placement=\"");t.b(t.v(t.f("placement",c,p,0)));t.b("\"");t.b("\n" + i);t.b("          data-bhw=\"ProductReviewsVote\">");t.b("\n" + i);t.b("            (");if(t.s(t.f("translate",c,p,1),c,p,0,2852,2900,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.helpful.undo");});c.pop();}t.b(")");t.b("\n" + i);t.b("        </a>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}});c.pop();}if(t.s(t.f("isUserReview",c,p,1),c,p,0,3007,3651,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a");t.b("\n" + i);t.b("      class=\"review-delete ");t.b(t.v(t.d("displayOptions.loginRequired.triggerClass",c,p,0)));t.b("\"");t.b("\n" + i);t.b("      ");t.b(t.t(t.d("displayOptions.loginRequired.triggerData.review",c,p,0)));t.b("\n" + i);t.b("      ");if(t.s(t.d("displayOptions.loginRequired.iframeLogin",c,p,1),c,p,0,3206,3232,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("data-login-required=\"true\"");});c.pop();}t.b("\n" + i);t.b("      data-review-id=\"");t.b(t.v(t.f("uuid",c,p,0)));t.b("\"");t.b("\n" + i);t.b("      data-bhw=\"ProductReviewsDelete\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,3377,3419,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.delete");});c.pop();}t.b("\n" + i);t.b("      </a>");t.b("\n" + i);t.b("    <button");t.b("\n" + i);t.b("      class=\"review-cancel btn-secondary btn-small\"");t.b("\n" + i);t.b("      data-bhw=\"ProductReviewsCancel\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,3574,3616,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.cancel");});c.pop();}t.b("\n" + i);t.b("      </button>");t.b("\n" + i);});c.pop();}if(t.s(t.d("displayOptions.showShare",c,p,1),c,p,0,3704,4037,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">");t.b("\n" + i);t.b("      <span class=\"icon-share\"></span><span class=\"share-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,3959,4000,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("modules.product_reviews.review_card.share");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("helpfulUpvote",c,p,1),c,p,0,4091,4175,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div id=\"");t.b(t.v(t.d("reviewIds.voteText",c,p,0)));t.b("\" class=\"review-vote-text\">");t.b(t.v(t.f("text",c,p,0)));t.b("</div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n" + i);t.b("<div id=\"");t.b(t.v(t.d("reviewIds.notification",c,p,0)));t.b("\" class=\"notification review-notification\"></div>");t.b("\n");return t.fl(); },partials: {"<product_reviews_stars0":{name:"product_reviews_stars", partials: {}, subs: {  }}}, subs: {  }}, "<div class=\"review-header\">\n  <div class=\"review-header-line\">\n    <div class=\"review-info\">\n      <span class=\"review-rating\" id=\"{{ reviewIds.rating }}\">\n        {{> product_reviews_stars }}\n      </span>\n      <span class=\"review-display-name should-truncate\" data-display-name=\"{{ displayName }}\">\n        {{ username }}\n      </span>\n      {{# verifiedPurchaser }}\n        <span class=\"review-verified-purchaser icon-check\">\n          {{# translate }}modules.product_reviews.review_card.verified_purchaser{{/ translate }}\n        </span>\n      {{/ verifiedPurchaser }}\n\n      {{# isPending }}\n        <a class=\"review-status tooltip-trigger\" data-tooltip-id=\"product-reviews-pending-tooltip\" data-bhw=\"ProductReviewsPendingTooltipTrigger\" data-position=\"right\">\n          {{# translate }}modules.product_reviews.review_card.review_pending{{/ translate }}<span class=\"icon-question\"></span>\n        </a>\n      {{/ isPending }}\n      {{# isRejected }}\n        <span class=\"review-status\">\n          {{# translate }}modules.product_reviews.review_card.review_rejected{{/ translate }}\n        </span>\n      {{/ isRejected }}\n    </div>\n    <span class=\"review-date\">{{ date }}</span>\n  </div>\n</div>\n<div class=\"review-text-container\">\n  <div class=\"review-text{{# isRatingOnly }} rating-only-review{{/ isRatingOnly }}\" id=\"{{ reviewIds.reviewText }}\">{{ text }}</div>\n  {{# displayOptions.readMoreEnabled }}\n    <div class=\"read-more\">\n      {{# translate }}modules.product_reviews.review_card.read_more{{/ translate }}\n    </div>\n  {{/ displayOptions.readMoreEnabled }}\n</div>\n<div class=\"review-actions\">\n  {{# helpfulUpvote }}\n    {{# buttonInfo }}\n      <div class=\"review-vote\">\n        <span class=\"review-vote-prompt\">{{# translate }}modules.product_reviews.review_card.helpful.prompt{{/ translate }}</span>\n        {{# buttons }}\n          <button\n            id=\"{{ voteId }}\"\n            class=\"btn-secondary btn-small {{ voteClass }} {{ displayOptions.loginRequired.triggerClass }}\"\n            {{{ displayOptions.loginRequired.triggerData.vote }}}\n            {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n            data-review-id=\"{{ uuid }}\"\n            data-review-placement=\"{{ placement }}\"\n            data-bhw=\"ProductReviewsVote\">\n              {{ text }}\n          </button>\n        {{/ buttons }}\n      </div>\n    {{/ buttonInfo }}\n    {{# undoText }}\n      <div id=\"{{ reviewIds.voteUndo }}\" class=\"review-vote-undo notification review-notification success\">\n        {{# translate }}modules.product_reviews.review_card.helpful.voted{{/ translate}}\n        <a\n          class=\"vote-undo-link\"\n          data-review-id=\"{{ uuid }}\"\n          data-review-placement=\"{{ placement }}\"\n          data-bhw=\"ProductReviewsVote\">\n            ({{# translate }}modules.product_reviews.review_card.helpful.undo{{/ translate}})\n        </a>\n      </div>\n    {{/ undoText }}\n  {{/ helpfulUpvote }}\n  {{# isUserReview }}\n    <a\n      class=\"review-delete {{ displayOptions.loginRequired.triggerClass }}\"\n      {{{ displayOptions.loginRequired.triggerData.review }}}\n      {{# displayOptions.loginRequired.iframeLogin }}data-login-required=\"true\"{{/ displayOptions.loginRequired.iframeLogin }}\n      data-review-id=\"{{ uuid }}\"\n      data-bhw=\"ProductReviewsDelete\">\n        {{# translate }}modules.product_reviews.review_card.delete{{/ translate }}\n      </a>\n    <button\n      class=\"review-cancel btn-secondary btn-small\"\n      data-bhw=\"ProductReviewsCancel\">\n        {{# translate }}modules.product_reviews.review_card.cancel{{/ translate }}\n      </button>\n  {{/ isUserReview }}\n  {{# displayOptions.showShare }}\n    <div class=\"review-share tooltip-trigger\" data-tooltip-id=\"product-reviews-share-tooltip\" data-trigger-event=\"click\" data-bhw=\"ProductReviewShare\" data-position=\"bottom\">\n      <span class=\"icon-share\"></span><span class=\"share-text\">{{# translate }}modules.product_reviews.review_card.share{{/ translate }}</span>\n    </div>\n  {{/ displayOptions.showShare }}\n  {{# helpfulUpvote }}\n    <div id=\"{{ reviewIds.voteText }}\" class=\"review-vote-text\">{{ text }}</div>\n  {{/ helpfulUpvote }}\n</div>\n<div id=\"{{ reviewIds.notification }}\" class=\"notification review-notification\"></div>\n", Hogan);
},{"hogan.js":133}],88:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("reviews",c,p,1),c,p,0,14,181,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"review-card\" id=\"");t.b(t.v(t.d("reviewIds.card",c,p,0)));t.b("\" data-bhc=\"product-review:");t.b(t.v(t.f("uuid",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<product_reviews_review_card0",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<product_reviews_review_card0":{name:"product_reviews_review_card", partials: {}, subs: {  }}}, subs: {  }}, "{{# reviews }}\n  <div class=\"review-card\" id=\"{{ reviewIds.card }}\" data-bhc=\"product-review:{{ uuid }}\" data-bh-viewport=\"respect\">\n    {{> product_reviews_review_card }}\n  </div>\n{{/ reviews }}\n", Hogan);
},{"hogan.js":133}],89:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("ratingStars",c,p,1),c,p,0,18,170,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <ul class=\"product-reviews-rating\" data-bhc=\"");t.b(t.v(t.f("bhc",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("stars",c,p,1),c,p,0,94,149,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li class=\"icon-star-filled\">");t.b(t.t(t.d(".",c,p,0)));t.b("</li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# ratingStars }}\n  <ul class=\"product-reviews-rating\" data-bhc=\"{{ bhc }}\">\n    {{# stars }}\n      <li class=\"icon-star-filled\">{{{ . }}}</li>\n    {{/ stars }}\n  </ul>\n{{/ ratingStars }}\n", Hogan);
},{"hogan.js":133}],90:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("userReview",c,p,1),c,p,0,17,211,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"user-review-card review-card\" data-bhw=\"ProductReviewsUserReview\" data-bhc=\"product-review:");t.b(t.v(t.f("uuid",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<product_reviews_review_card0",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<product_reviews_review_card0":{name:"product_reviews_review_card", partials: {}, subs: {  }}}, subs: {  }}, "{{# userReview }}\n  <div class=\"user-review-card review-card\" data-bhw=\"ProductReviewsUserReview\" data-bhc=\"product-review:{{ uuid }}\" data-bh-viewport=\"respect\">\n    {{> product_reviews_review_card }}\n  </div>\n{{/ userReview }}\n", Hogan);
},{"hogan.js":133}],91:[function(require,module,exports){
if (window.FacebookPromNight == null) {
  window.FacebookPromNight = {};
}

FacebookPromNight.init = function(payload, done) {
  return $(function() {
    $(".share-links .icon-facebook").on({
      click: function(e) {
        e.preventDefault();
        return window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436');
      }
    });
    return done();
  });
};

module.exports = FacebookPromNight;



},{}],92:[function(require,module,exports){
var FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

FreeShipping.View = require('./views/free_shipping');

FreeShipping.init = function(arg, done) {
  var shippingDetails;
  shippingDetails = arg.shippingDetails;
  if (!shippingDetails) {
    return done();
  }
  return $(function() {
    var view;
    view = new FreeShipping.View({
      el: '.free-shipping-container',
      freeShippingValues: shippingDetails
    });
    return done();
  });
};

module.exports = FreeShipping;



},{"./views/free_shipping":93}],93:[function(require,module,exports){
var DealEventPipe, FreeShipping;

FreeShipping = window.FreeShipping != null ? window.FreeShipping : window.FreeShipping = {};

DealEventPipe = require('../../../deal/frontend/event_pipe');

FreeShipping.View = Backbone.View.extend({
  initialize: function() {
    this.$message = $('.free-shipping-container');
    DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateFreeShipping(priceData);
      };
    })(this));
    return DealEventPipe.on("touchDeliveryEstimatesUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateFreeShipping(priceData);
      };
    })(this));
  },
  updateFreeShipping: function(arg) {
    var uuid;
    uuid = arg.uuid;
    if (this.options.freeShippingValues[uuid]) {
      return this.$message.show();
    } else {
      return this.$message.hide();
    }
  }
});

module.exports = FreeShipping.View;



},{"../../../deal/frontend/event_pipe":21}],94:[function(require,module,exports){
var StaticPages;

StaticPages = window.StaticPages != null ? window.StaticPages : window.StaticPages = {};

StaticPages.init = function(arg, done) {
  var isResponsive, isTouchRequest, staticPageArray, staticPages;
  staticPages = arg.staticPages;
  if (!staticPages) {
    return done();
  }
  staticPageArray = staticPages.staticPageArray, isTouchRequest = staticPages.isTouchRequest, isResponsive = staticPages.isResponsive;
  if (!(staticPageArray != null ? staticPageArray.length : void 0)) {
    return done();
  }
  return $(function() {
    var $body, $main, $pitch, deferreds;
    if (isTouchRequest) {
      $body = $('body');
      $main = $('div.t-main');
      $pitch = $(isResponsive ? '.t-pod.toggle-drawer.highlights' : '#about-deal');
    } else {
      $pitch = $('article.pitch');
    }
    deferreds = $.map(staticPageArray, function(arg1) {
      var $staticPage, $staticPageOpener, formattedAjaxUrl, staticPageHref, staticPageId, staticPageType;
      staticPageType = arg1.staticPageType, staticPageId = arg1.staticPageId, staticPageHref = arg1.staticPageHref, formattedAjaxUrl = arg1.formattedAjaxUrl;
      $staticPage = $("#" + staticPageId);
      $staticPageOpener = $pitch.find("a[href='" + staticPageHref + "']");
      if (!($staticPage.length && $staticPageOpener.length)) {
        return;
      }
      return $.ajax({
        url: formattedAjaxUrl,
        dataType: 'json',
        success: function(res) {
          var $bodyHtml, bodyHtml, title;
          bodyHtml = res.bodyHtml, title = res.title;
          if (staticPageType === 'articles') {
            bodyHtml = res.content;
          }
          if (!((bodyHtml != null ? bodyHtml.length : void 0) && (title != null ? title.length : void 0))) {
            return;
          }
          if (isTouchRequest) {
            $staticPage.find('header.t-header h2').text(title);
            $bodyHtml = $staticPage.find('div.t-body-html').html(bodyHtml);
            if (!isResponsive) {
              $bodyHtml.find(':contains("Jump to..")').remove();
              $bodyHtml.find('a[href]').parent().remove();
            }
            $staticPage.find('a.t-back-link').off().click(function() {
              $staticPage.hide();
              return $main.show();
            });
            $staticPage.find('a.t-pane-back-to-top').click(function() {
              return $body.animate({
                scrollTop: 0
              }, 'median');
            });
            return $staticPageOpener.click(function() {
              $main.hide();
              $staticPage.show();
              $body.animate({
                scrollTop: 0
              }, 'slow');
              return false;
            });
          } else {
            $staticPage.find('h2.section-title').text(title);
            return $staticPage.find('div.body-html').html(bodyHtml);
          }
        },
        error: function(err) {
          if (!isTouchRequest) {
            $staticPageOpener.removeAttr('data-modal-id');
          }
          $staticPageOpener.off();
          return $staticPage.remove();
        }
      });
    });
    return $.when.apply($, deferreds).then(done);
  });
};

module.exports = StaticPages;



},{}],95:[function(require,module,exports){
var safeInit;

if (window.Tracking == null) {
  window.Tracking = {};
}

safeInit = function(obj, payload, cb) {
  var err;
  try {
    return obj.init(payload, cb);
  } catch (error) {
    err = error;
    OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Error", {
      error: err
    });
    if (window.location.hostname === 'localhost' && (console.error != null)) {
      console.error(err);
    }
    return cb();
  }
};

Tracking.Initializer = function(timeoutInMs) {
  var finished, inFlight;
  if (timeoutInMs == null) {
    timeoutInMs = 30 * 1000;
  }
  inFlight = 0;
  this._hasRun = false;
  finished = false;
  return {
    run: function(modules, payload, cb) {
      var i, len, module;
      for (i = 0, len = modules.length; i < len; i++) {
        module = modules[i];
        inFlight++;
        safeInit(module, payload, (function(_this) {
          return function() {
            inFlight--;
            if (inFlight === 0 && _this._hasRun && !finished) {
              finished = true;
              return cb();
            }
          };
        })(this));
      }
      this._hasRun = true;
      if (inFlight === 0 && !finished) {
        finished = true;
        cb();
      }
      return setTimeout((function() {
        if (!finished) {
          OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Timeout", {
            numberInFlight: inFlight
          });
          finished = true;
          if (window.location.hostname === 'localhost' && (console.error != null)) {
            console.error("Frontend Module Initialization timed out");
          }
          return cb();
        }
      }), timeoutInMs);
    }
  };
};

module.exports = Tracking.Initializer;



},{}],96:[function(require,module,exports){
var VariationsWidget, base;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if ((base = VariationsWidget.Collections).Option == null) {
  base.Option = {};
}

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = require('./option');

VariationsWidget.Collections.Option = Backbone.Collection.extend({
  model: VariationsWidget.Models.Option,
  chosen: function(value) {
    return this.find(function(trait) {
      return trait.get('traitValue') === value;
    });
  },
  selected: function() {
    return this.find(function(trait) {
      return trait.get('selected');
    });
  },
  setSelected: function(id) {
    this.selected().set('selected', false);
    return this.get(id).set('selected', true);
  }
});

VariationsWidget.Collections.Option.create = function(traits) {
  var data, i, len, option, results, trait;
  results = [];
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    data = (function() {
      var j, len1, ref, results1;
      ref = trait.data;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        option = ref[j];
        results1.push({
          traitValue: option.value,
          disabled: false,
          forceDisplay: false,
          traitIndex: option.traitIndex,
          traitName: option.name,
          id: option.optionIndex,
          isSoldOut: option.isSoldOut,
          isUnavailable: option.isUnavailable,
          optionPrice: false,
          selected: option.optionIndex === 0
        });
      }
      return results1;
    })();
    results.push(new VariationsWidget.Collections.Option(data));
  }
  return results;
};

module.exports = VariationsWidget.Collections.Option;



},{"./option":97}],97:[function(require,module,exports){
var VariationsWidget;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = Backbone.Model.extend({
  initialize: function() {}
});

module.exports = VariationsWidget.Models.Option;



},{}],98:[function(require,module,exports){
var Cart, DealEventPipe, VariationsWidget,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

Cart = window.Cart != null ? window.Cart : window.Cart = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

Cart.Helpers = require('../../cart/common/helpers');

VariationsWidget.Controller = (function() {
  function Controller() {
    this.findSelectedCollections = bind(this.findSelectedCollections, this);
    this.findDefaultCollections = bind(this.findDefaultCollections, this);
    this.isSelectionDefault = bind(this.isSelectionDefault, this);
    var ref;
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '7.0') {
      this.ie7 = true;
    }
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.updateSelectElements("", true);
    this.availableOptions = this.getAvailableOptions();
    this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
    this.lastImage = "";
    this.clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection;
    this.$selectElements = $('#variation-traits').find('.variation-trait');
    if ((ref = VariationsWidget.preSelectTraits) != null ? ref.length : void 0) {
      this.makeSelectionsViaPreselection();
    } else {
      this.updateSelectionsToDefault();
    }
  }

  Controller.prototype.render = function(latestSelection, updateCarousel) {
    if (updateCarousel == null) {
      updateCarousel = true;
    }
    if (latestSelection.selection != null) {
      this.updateSelections(latestSelection);
      this.updateSelectElements(latestSelection.trait);
      this.availableOptions = this.getAvailableOptions();
      this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
      this.updatePricing(this.cheapestOption, this.availableOptions.length);
      if (updateCarousel) {
        this.updateCarousel();
      }
      this.removeErrorMessages();
    }
  };

  Controller.prototype.updateSelectionsToDefault = function() {
    var i, len, ref, results, selectElement;
    ref = this.$selectElements || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      selectElement = ref[i];
      results.push($(selectElement).find('option:eq(0)').prop('selected', true));
    }
    return results;
  };

  Controller.prototype.updateSelections = function(latestSelection) {
    var collection, i, len, ref;
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      if (collection.models[0].get('traitName') === latestSelection.trait) {
        collection.setSelected(latestSelection.id);
        break;
      }
    }
  };

  Controller.prototype.updateSelectElements = function(latestSelection, updateAll) {
    var availableValues, collection, conditions, enabledOptions, enabledValues, i, j, k, l, lastSelection, len, len1, len2, len3, len4, m, model, option, ref, ref1, ref2, trait, traitName, unavailableOptions, unavailableValues, value;
    if (updateAll == null) {
      updateAll = false;
    }
    if (VariationsWidget.printOptionPrice) {
      updateAll = true;
    }
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      traitName = collection.models[0].get('traitName');
      if (traitName !== latestSelection || updateAll) {
        conditions = this.getConditions(collection.selected());
        lastSelection = _.keys(conditions).length === VariationsWidget.collections.length - 1;
        enabledOptions = [];
        unavailableOptions = [];
        if (!$.isEmptyObject(conditions)) {
          enabledOptions = _.where(VariationsWidget.options, conditions);
        } else {
          enabledOptions = VariationsWidget.options;
        }
        enabledValues = _.pluck(enabledOptions, traitName);
        unavailableValues = _.uniq(enabledValues);
        availableValues = [];
        for (j = 0, len1 = enabledOptions.length; j < len1; j++) {
          option = enabledOptions[j];
          for (k = 0, len2 = unavailableValues.length; k < len2; k++) {
            value = unavailableValues[k];
            if ((value === option[traitName]) && this.isOptionAvailable(option)) {
              availableValues.push(value);
            }
          }
        }
        unavailableValues = _.difference(unavailableValues, availableValues);
        enabledValues.unshift((this.i18n.t('js.modules.variations.selector')) + " " + traitName);
        ref1 = VariationsWidget.collections;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          trait = ref1[l];
          if (trait.models[0].get('traitName') === traitName) {
            ref2 = trait.models;
            for (m = 0, len4 = ref2.length; m < len4; m++) {
              model = ref2[m];
              this.setOptionState(model, enabledValues, unavailableValues);
              if (lastSelection && (conditions[traitName] == null)) {
                this.setOptionPrice(model, enabledValues, enabledOptions);
              } else if (conditions[traitName] == null) {
                this.setOptionFromPrice(model, enabledValues, enabledOptions);
              } else {
                model.set('optionPrice', false);
              }
            }
          }
        }
      }
    }
    if (this.ie7) {
      $('option').removeClass("ie7-color");
      return $('option[disabled]').addClass("ie7-color");
    }
  };

  Controller.prototype.setOptionState = function(model, enabledValues, unavailableValues) {
    var forceDisplay, printSoldOut;
    printSoldOut = VariationsWidget.printSoldOut;
    if (model.id === 0 || (_.contains(enabledValues, model.get('traitValue')))) {
      if (model.get('isSoldOut') || model.get('isUnavailable') || ((unavailableValues != null) && (_.contains(unavailableValues, model.get('traitValue'))))) {
        model.set('disabled', true);
      } else {
        model.set('disabled', false);
      }
      model.set('forceDisplay', printSoldOut === true);
    } else {
      model.set('disabled', true);
      forceDisplay = printSoldOut === true && !VariationsWidget.hideUnrelatedOption;
      model.set('forceDisplay', forceDisplay);
    }
  };

  Controller.prototype.setOptionFromPrice = function(model, enabledValues, enabledOptions) {
    var cheapestOption, modelID, name, printOptionPrice, selected, traitOptions, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    traitOptions = _.filter(enabledOptions, (function(item) {
      return item[name] === value;
    }));
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      cheapestOption = this.getCheapestAvailableOption(traitOptions);
      if (cheapestOption != null) {
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {
          minPrice: cheapestOption.newPrice
        }));
      }
    }
  };

  Controller.prototype.setOptionPrice = function(model, enabledValues, enabledOptions) {
    var i, len, modelID, name, option, printOptionPrice, selected, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      for (i = 0, len = enabledOptions.length; i < len; i++) {
        option = enabledOptions[i];
        if (value === option[name]) {
          model.set('optionPrice', option.newPrice);
        }
      }
    }
  };

  Controller.prototype.getConditions = function(selected) {
    var conditions, i, len, ref, tempCollection, tempSelected, tempSelectedTraitValue;
    conditions = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      tempCollection = ref[i];
      tempSelected = tempCollection.selected();
      tempSelectedTraitValue = tempSelected.get('traitValue');
      if (tempSelectedTraitValue !== selected.get('traitValue') && !this.isSelectionDefault(tempSelectedTraitValue)) {
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue;
      }
    }
    return conditions;
  };

  Controller.prototype.getAvailableOptions = function() {
    var collection, i, len, options, properties, ref, selectedTrait, selectedTraitValue;
    properties = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitValue = selectedTrait.get('traitValue');
      if (!this.isSelectionDefault(selectedTraitValue)) {
        properties[selectedTrait.get('traitName')] = selectedTraitValue;
      }
    }
    if ($.isEmptyObject(properties)) {
      options = VariationsWidget.options;
    } else {
      options = _.where(VariationsWidget.options, properties);
    }
    return options;
  };

  Controller.prototype.getCheapestAvailableOption = function(availableOptions) {
    var currentCheapest, i, len, option;
    currentCheapest = void 0;
    for (i = 0, len = availableOptions.length; i < len; i++) {
      option = availableOptions[i];
      if (this.isOptionAvailable(option) && (currentCheapest === void 0 || (option.amount < currentCheapest.amount))) {
        currentCheapest = option;
      }
    }
    return currentCheapest || availableOptions[0];
  };

  Controller.prototype.overridePriceDataWithSaleInfo = function(priceData, option) {
    var i, len, offer, ref, ref1, ref2, ref3, ref4, sale;
    if (!(((option != null ? option.regularPrice : void 0) != null) || (((ref = VariationsWidget.offerCollections) != null ? ref.offerOptions : void 0) != null))) {
      return;
    }
    sale = {};
    if (option.regularPrice) {
      _.extend(sale, {
        urgencyPricing: {
          regularPrice: option.regularPrice,
          newPrice: option.newPrice,
          pricingMetadata: option.pricingMetadata
        }
      });
    }
    ref2 = ((ref1 = VariationsWidget.offerCollections) != null ? ref1.offerOptions : void 0) || [];
    for (i = 0, len = ref2.length; i < len; i++) {
      offer = ref2[i];
      if (offer.uuid === option.uuid) {
        if (((offer != null ? offer.buyUrl : void 0) != null) && !((ref3 = VariationsWidget.offerCollections) != null ? (ref4 = ref3.offerModal) != null ? ref4.isSoldOut : void 0 : void 0)) {
          priceData.buyUrl = offer.buyUrl;
        }
        _.extend(sale, {
          offer: offer
        });
      }
    }
    if (sale !== {}) {
      return _.extend(priceData, {
        sale: sale
      });
    }
  };

  Controller.prototype.updatePricing = function(cheapestOption, length) {
    var priceData;
    priceData = {
      dealUuid: VariationsWidget.uuid,
      id: cheapestOption.id,
      value: cheapestOption.oldPrice,
      percent: cheapestOption.discount,
      savings: cheapestOption.savePrice,
      price: cheapestOption.newPrice,
      lengthClass: cheapestOption.lengthClass,
      buyUrl: this.buyButtonUrl(cheapestOption),
      uuid: cheapestOption.uuid,
      variationsSelected: length === 1 && !this.areAnySelectionsDefault(VariationsWidget.collections),
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount,
      soldMessage: cheapestOption.soldMessage
    };
    this.overridePriceDataWithSaleInfo(priceData, cheapestOption);
    DealEventPipe.trigger("priceUpdate", priceData);
    if (payload.goodsWarranty) {
      DealEventPipe.trigger("goodsWarrantyUpdate", priceData);
    }
    if (payload.buyMore) {
      return DealEventPipe.trigger("buyMoreUpdate", priceData, !priceData.variationsSelected);
    }
  };

  Controller.prototype.buyButtonUrl = function(cheapestOption) {
    var ref;
    if ((ref = cheapestOption.externalUrl) != null ? ref.length : void 0) {
      return cheapestOption.externalUrl;
    }
    if ((typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0) && !payload.shouldDisableGoodsCart) {
      return Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid);
    } else {
      return cheapestOption.url;
    }
  };

  Controller.prototype.updateCarousel = function() {
    var currentImage, foundMatch, imageUrl, ref, valuesHash;
    if (this.areSelectionsDefault(VariationsWidget.collections)) {
      payload.firedByTraitSelection = true;
      DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(DealCarousel.dealMedia[payload.carousel.dealId].models[0]);
    } else {
      ref = VariationsWidget.mappings;
      for (imageUrl in ref) {
        valuesHash = ref[imageUrl];
        foundMatch = _.every(VariationsWidget.collections, (function(_this) {
          return function(collection) {
            var selectedTrait, selectedTraitValue;
            selectedTrait = collection.selected();
            selectedTraitValue = selectedTrait.get('traitValue');
            if (_this.isSelectionDefault(selectedTraitValue)) {
              return true;
            } else {
              return _.contains(valuesHash[selectedTrait.get('traitName')], selectedTraitValue);
            }
          };
        })(this));
        currentImage = DealCarousel.carouselViews[payload.carousel.dealId].currentFeatured.baseURL;
        if (foundMatch && currentImage !== imageUrl) {
          payload.firedByTraitSelection = true;
          this.changeToMatchingImage(imageUrl);
          break;
        }
      }
    }
  };

  Controller.prototype.changeToMatchingImage = function(imgPath) {
    var image;
    this.lastImage = imgPath;
    image = DealCarousel.dealMedia[payload.carousel.dealId].findWhere({
      thumb: imgPath + "t100x100" + payload.carousel.imageQuality + ".jpg"
    });
    return DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(image);
  };

  Controller.prototype.findMatchingTraits = function(img) {
    var key, ref, selections, value;
    this.lastImage = img;
    selections = [];
    if (VariationsWidget.mappings[img] != null) {
      ref = VariationsWidget.mappings[img];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections.push({
            trait: key,
            selection: value[0]
          });
        }
      }
    }
    return this.makeSelectionsViaCarousel(selections);
  };

  Controller.prototype.makeSelectionsViaCarousel = function(selections) {
    if ((selections != null ? selections.length : void 0) < 1 && !this.clearTraitsOnCarouselSelection) {
      return;
    }
    this.clearSelections();
    return this.makeSelections(selections);
  };

  Controller.prototype.makeSelectionsViaPreselection = function() {
    var collection, i, j, len, len1, option, ref, ref1, selections, trait;
    option = _.findWhere(VariationsWidget.options, {
      uuid: VariationsWidget.dealOptionUuid
    });
    if (!((option != null) && this.isOptionAvailable(option))) {
      return;
    }
    selections = [];
    ref = VariationsWidget.preSelectTraits || [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get("traitName") === trait) {
          selections.push({
            trait: trait,
            selection: option[trait]
          });
          break;
        }
      }
    }
    return this.makeSelections(selections);
  };

  Controller.prototype.clearSelections = function() {
    var collection, data, i, len, ref, results, selectedTrait, selectedTraitName, selection;
    ref = VariationsWidget.collections || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitName = selectedTrait.get('traitName');
      if (!this.isSelectionDefault(selectedTrait.get('traitValue'))) {
        selection = this.i18n.t('js.modules.variations.select', {
          name: selectedTraitName
        });
        data = {
          trait: selectedTraitName,
          selection: selection,
          id: 0
        };
        $("#trait-" + (selectedTrait.get('traitIndex'))).val(selection);
        if ($("#trait-" + (selectedTrait.get('traitIndex'))).val() == null) {
          $("#trait-" + (selectedTrait.get('traitIndex'))).prop('selectedIndex', 0);
        }
        results.push(this.render(data, false));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  Controller.prototype.makeSelections = function(selections) {
    var collection, element, i, j, len, len1, ref, ref1, trait;
    ref = selections || [];
    for (i = 0, len = ref.length; i < len; i++) {
      element = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get('traitName') === element.trait) {
          trait = collection.findWhere({
            traitValue: element.selection
          });
          if (!trait.get('disabled')) {
            element['id'] = trait.get('id');
            $('#trait-' + collection.models[0].get('traitIndex')).val(element.selection);
            this.render(element, false);
            break;
          }
        }
      }
    }
  };

  Controller.prototype.showErrorMessages = function() {
    var defaultCollections, i, index, len, results;
    VariationsWidget.error.show();
    VariationsWidget.error.$el.addClass("icon-circle-alert");
    defaultCollections = this.findDefaultCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = defaultCollections.length; i < len; i++) {
      index = defaultCollections[i];
      results.push($('#trait-' + index).addClass('error'));
    }
    return results;
  };

  Controller.prototype.removeErrorMessages = function() {
    var i, index, len, results, selectedCollections;
    if (!this.areAnySelectionsDefault(VariationsWidget.collections)) {
      VariationsWidget.error.hide();
    }
    selectedCollections = this.findSelectedCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = selectedCollections.length; i < len; i++) {
      index = selectedCollections[i];
      results.push($('#trait-' + index).removeClass('error'));
    }
    return results;
  };

  Controller.prototype.areSelectionsDefault = function(collections) {
    return _.every(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.areAnySelectionsDefault = function(collections) {
    return _.some(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.isSelectionDefault = function(selection) {
    return RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(selection);
  };

  Controller.prototype.findDefaultCollections = function(collections) {
    var collection, defaultCollections, i, index, len;
    defaultCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        defaultCollections.push(index);
      }
    }
    return defaultCollections;
  };

  Controller.prototype.findSelectedCollections = function(collections) {
    var collection, i, index, len, selectedCollections;
    selectedCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (!RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        selectedCollections.push(index);
      }
    }
    return selectedCollections;
  };

  Controller.prototype.isOptionAvailable = function(option) {
    if (option == null) {
      return false;
    }
    return !(option.isSoldOut || option.isUnavailable);
  };

  return Controller;

})();

module.exports = VariationsWidget.Controller;



},{"../../cart/common/helpers":13,"../../deal/frontend/event_pipe":21}],99:[function(require,module,exports){
var DealEventPipe, VariationsWidget, _scrollToBuyButton;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Collections.Option = require('./models/option-collection');

VariationsWidget.Views.OptionCollection = require('./views/option-collection');

VariationsWidget.Views.Error = require('./views/error');

VariationsWidget.Controller = require('./variations-widget-controller');

DealEventPipe = require('../../deal/frontend/event_pipe');

_scrollToBuyButton = function() {
  var top;
  if ($('#purchase-cluster .buy.fixed').length || $('.header-row-sticked').length || $('.header-row-sticky').length) {
    top = $('.main').position().top - 100;
    return $('body,html').animate({
      scrollTop: top
    }, 500);
  }
};

VariationsWidget.init = function(arg, done) {
  var offer, stickyHeader, variations;
  variations = arg.variations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (variations == null) {
    return done();
  }
  this.options = variations.options, this.traits = variations.traits, this.mappings = variations.mappings, this.uuid = variations.uuid, this.dealOptionUuid = variations.dealOptionUuid, this.preSelectTraits = variations.preSelectTraits, this.printSoldOut = variations.printSoldOut, this.printOptionPrice = variations.printOptionPrice, this.clearTraitsOnCarouselSelection = variations.clearTraitsOnCarouselSelection, this.hideUnrelatedOption = variations.hideUnrelatedOption;
  this.collections = VariationsWidget.Collections.Option.create(this.traits);
  this.offerCollections = offer;
  BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
    return function() {
      if (BuyButton.view.variationsSelected) {
        return;
      }
      _this.controller.showErrorMessages();
      if (stickyHeader) {
        _scrollToBuyButton();
      }
      BuyButton.view.enableBuyButton();
      return {
        stopTheBus: true
      };
    };
  })(this));
  return $((function(_this) {
    return function() {
      var ref;
      _this.views = VariationsWidget.Views.OptionCollection.create(_this.collections);
      _this.error = new VariationsWidget.Views.Error({
        el: '#variation-error'
      });
      _this.controller = new VariationsWidget.Controller();
      if ((ref = _this.options) != null ? ref[0].hideOriginalPriceAndDiscount : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html("");
      }
      $(document.body).on("carouselUpdate", function(e, data) {
        if (payload.firedByTraitSelection) {
          return payload.firedByTraitSelection = false;
        }
        if (data.image !== _this.controller.lastImage) {
          return _this.controller.findMatchingTraits(data.image);
        }
      });
      return done();
    };
  })(this));
};

module.exports = VariationsWidget;



},{"../../deal/frontend/event_pipe":21,"./models/option-collection":96,"./variations-widget-controller":98,"./views/error":100,"./views/option-collection":101}],100:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Error = Backbone.View.extend({
  show: function() {
    return this.$el.show();
  },
  hide: function() {
    return this.$el.hide();
  }
});

module.exports = VariationsWidget.Views.Error;



},{}],101:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = require('./option');

VariationsWidget.Views.OptionCollection = Backbone.View.extend({
  events: {
    "change": "selectionChanged"
  },
  initialize: function() {
    var optionElementModel;
    _.bindAll(this, 'selectionChanged', 'render');
    return this.optionElementViews = (function() {
      var i, len, ref, results;
      ref = this.collection.models;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        optionElementModel = ref[i];
        results.push(new VariationsWidget.Views.Option({
          el: "#trait-" + optionElementModel.get('traitIndex') + "-" + optionElementModel.get('id'),
          model: optionElementModel
        }));
      }
      return results;
    }).call(this);
  },
  render: function() {
    var i, len, optionElementView, ref, results;
    ref = this.optionElementViews;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      optionElementView = ref[i];
      results.push(optionElementView.render());
    }
    return results;
  },
  isSelectedOptionDisabled: function(selectElement) {
    return selectElement != null ? selectElement.options[selectElement.selectedIndex].disabled : void 0;
  },
  selectionChanged: function(e) {
    var $currentElement, model, value;
    $currentElement = $(e.currentTarget)[0];
    if (VariationsWidget.controller.ie7 && this.isSelectedOptionDisabled($currentElement)) {
      $currentElement.selectedIndex = 0;
    }
    value = $(e.currentTarget).val();
    model = this.collection.chosen(value);
    return VariationsWidget.controller.render({
      trait: this.collection.models[0].get('traitName'),
      selection: value,
      id: model.get('id')
    });
  }
});

VariationsWidget.Views.OptionCollection.create = function(collections) {
  var i, index, len, results, trait;
  results = [];
  for (index = i = 0, len = collections.length; i < len; index = ++i) {
    trait = collections[index];
    results.push(new VariationsWidget.Views.OptionCollection({
      collection: trait,
      el: "#trait-" + index
    }));
  }
  return results;
};

module.exports = VariationsWidget.Views.OptionCollection;



},{"./option":102}],102:[function(require,module,exports){
if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = Backbone.View.extend({
  initialize: function() {
    _.bindAll(this, 'render');
    this.model.bind('change:disabled', this.render);
    if (VariationsWidget.printSoldOut) {
      this.model.bind('change:forceDisplay', this.render);
    }
    if (VariationsWidget.printOptionPrice) {
      this.model.bind('change:optionPrice', this.render);
      this.model.bind('change:selected', this.render);
    }
    return this.rtl = $('body').hasClass('rtl');
  },
  render: function() {
    this.$el.attr('disabled', this.model.get('disabled'));
    this.clearSoldOut();
    if (VariationsWidget.printSoldOut && this.model.get('disabled')) {
      this.renderSoldOut();
    }
    if (VariationsWidget.printOptionPrice) {
      return this.renderPrintOptionPrice();
    }
  },
  clearSoldOut: function() {
    this.$el.removeClass('force-display');
    this.$el.find('.sold-out-text').remove();
  },
  renderSoldOut: function() {
    var soldOutText, string;
    if (!this.model.get('forceDisplay')) {
      return;
    }
    soldOutText = typeof I18n !== "undefined" && I18n !== null ? I18n.t('js.modules.variations.sold_out') : void 0;
    string = "<span class=\"sold-out-text\">" + soldOutText + "</span>";
    this.$el.addClass('force-display');
    if (this.rtl) {
      this.$el.append(string);
    } else {
      this.$el.prepend(string);
    }
  },
  renderPrintOptionPrice: function() {
    var isSelected, optionPrice, string;
    optionPrice = this.model.get('optionPrice');
    isSelected = this.model.get('selected');
    string = "<span class=\"option-price\">(" + optionPrice + ")</span>";
    this.$el.find('.option-price').remove();
    if (optionPrice && !isSelected) {
      if (this.rtl) {
        return this.$el.prepend(string);
      } else {
        return this.$el.append(string);
      }
    }
  }
});

module.exports = VariationsWidget.Views.Option;



},{}],103:[function(require,module,exports){
var DealEventPipe, WishlistButton;

WishlistButton = window.WishlistButton != null ? window.WishlistButton : window.WishlistButton = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

WishlistButton = function() {
  var $wishlistButton, $wishlistButtonTextAdd, $wishlistButtonTextRemove, addItemToWishlist, csrfToken, dealId, init, listenToOptionSelection, multiOptionBreakoutClicked, onAddItemSuccess, removeItemFromWishlist, selectedOptionUUID, toggleWishlistButtonStyle, updateRemoveItemUrl, updateWishlistedNotifier, wishlistButtonClicked, wishlistPayload;
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null;
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null;
  init = function(arg, done) {
    var $multiOptionBreakout, carousel, csrf, wishlist;
    carousel = arg.carousel, csrf = arg.csrf, wishlist = arg.wishlist;
    $wishlistButton = $(".add-to-wishlist-btn");
    $wishlistButtonTextAdd = $(".add-to-wishlist-btn-text-add");
    $wishlistButtonTextRemove = $(".add-to-wishlist-btn-text-remove");
    $multiOptionBreakout = $(".multi-option-breakout input");
    wishlistPayload = wishlist;
    dealId = carousel != null ? carousel.dealId : void 0;
    if (wishlistPayload.selectedOptionUUID) {
      selectedOptionUUID = wishlistPayload.selectedOptionUUID;
    }
    csrfToken = csrf;
    listenToOptionSelection();
    return $(function() {
      $wishlistButton.on("click", function(e) {
        return wishlistButtonClicked(e);
      });
      $multiOptionBreakout.on("click", multiOptionBreakoutClicked);
      return done();
    });
  };
  multiOptionBreakoutClicked = function(e) {
    var target;
    target = $(e.target);
    selectedOptionUUID = target.data("uuid");
    updateWishlistedNotifier(selectedOptionUUID);
    return updateRemoveItemUrl(selectedOptionUUID);
  };
  updateWishlistedNotifier = function(optionUUID) {
    var optionUUIDFilter;
    $wishlistButton.removeClass("wishlisted");
    $wishlistButtonTextAdd.removeClass("hidden");
    $wishlistButtonTextRemove.addClass("hidden");
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID && _.filter(wishlistPayload.items, optionUUIDFilter).length > 0) {
      $wishlistButton.addClass("wishlisted");
      $wishlistButtonTextAdd.addClass("hidden");
      return $wishlistButtonTextRemove.removeClass("hidden");
    }
  };
  updateRemoveItemUrl = function(optionUUID) {
    var optionUUIDFilter, ref, ref1;
    optionUUIDFilter = function(item) {
      return item.optionId === optionUUID;
    };
    if (optionUUID) {
      return wishlistPayload.removeItemUrl = (ref = _.filter(wishlistPayload.items, optionUUIDFilter)) != null ? (ref1 = ref[0]) != null ? ref1.removeItemUrl : void 0 : void 0;
    }
  };
  listenToOptionSelection = function() {
    return DealEventPipe.on("priceUpdate", function(priceData) {
      var $tooltip;
      $tooltip = $('#select-option-tooltip');
      GIG.Tooltip.close($tooltip);
      selectedOptionUUID = priceData.variationsSelected && priceData.uuid;
      updateWishlistedNotifier(selectedOptionUUID);
      return updateRemoveItemUrl(selectedOptionUUID);
    });
  };
  toggleWishlistButtonStyle = function() {
    $wishlistButton.toggleClass("wishlisted");
    $wishlistButtonTextAdd.toggleClass("hidden");
    return $wishlistButtonTextRemove.toggleClass("hidden");
  };
  onAddItemSuccess = function(data) {
    var updateWishlistItems;
    updateWishlistItems = function(newItem) {
      var addedItem;
      addedItem = {
        dealId: dealId,
        itemId: newItem.itemId,
        listId: newItem.listId,
        removeItemUrl: "/deals/wishlists_proxy/remove/" + newItem.listId + "/" + newItem.itemId
      };
      if (selectedOptionUUID) {
        addedItem.optionId = selectedOptionUUID;
      }
      return wishlistPayload.items.push(addedItem);
    };
    wishlistPayload.removeItemUrl = "/deals/wishlists_proxy/remove/" + data.listId + "/" + data.itemId;
    toggleWishlistButtonStyle();
    return updateWishlistItems(data);
  };
  addItemToWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.addItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        dealId: dealId,
        optionId: selectedOptionUUID ? selectedOptionUUID : void 0,
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-add-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, status, xhr) {
        return onAddItemSuccess(data);
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  removeItemFromWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.removeItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-remove-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, textStatus, error) {
        toggleWishlistButtonStyle();
        return wishlistPayload.items = _.filter(wishlistPayload.items, function(i) {
          return i.optionId !== selectedOptionUUID;
        });
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  wishlistButtonClicked = function(e) {
    e.preventDefault();
    if ($wishlistButton.hasClass("wishlisted")) {
      return removeItemFromWishlist();
    } else {
      return addItemToWishlist();
    }
  };
  return {
    init: init,
    onAddItemSuccess: onAddItemSuccess
  };
};

window.WishlistButton = WishlistButton();

module.exports = WishlistButton;



},{"../../deal/frontend/event_pipe":21}],104:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],105:[function(require,module,exports){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

},{}],106:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

proto.allOff =
proto.removeAllListeners = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],107:[function(require,module,exports){
/**
 * Fizzy UI utils v2.0.5
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj == 'object' &&
    typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

},{"desandro-matches-selector":105}],108:[function(require,module,exports){
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var polylinearScale = _interopDefault(require('polylinear-scale'));

/**
 * Module name
 *
 * @type {String}
 */
var name = 'FlickityTransformer';

/**
 * Set default units
 *
 * @type {Object}
 */
var units = {
  perspective: 'px',
  rotate: 'deg',
  rotateX: 'deg',
  rotateY: 'deg',
  rotateZ: 'deg',
  skew: 'deg',
  skewX: 'deg',
  skewY: 'deg',
  translateX: 'px',
  translateY: 'px',
  translateZ: 'px'
};

/**
 * The Flickity instance
 *
 * @type {Object}
 */
var flickity = {};

/**
 * Transforms to apply
 *
 * @type {Array}
 */
var transforms = [];

/**
 * Array of Flickity cell elements
 *
 * @type {Array}
 */
var cellElements = [];

/**
 * Constructor
 *
 * @param {Object} flkty The Flickity instance
 * @param {Array} txs Transforms array
 */
var FlickityTransformer = function FlickityTransformer(flkty, txs) {
  flickity = flkty;
  transforms = txs;
  cellElements = flickity.getCellElements();

  init();
};

/**
 * Initialize
 *
 * @return {null}
 */
function init() {
  createScaleFunctions();

  // Apply initial transforms
  flickity.slides.forEach(applyTransforms);

  // Apply again on scroll
  flickity.on('scroll', function () {
    flickity.slides.forEach(applyTransforms);
  });

  // Require a version of Flickity supporting `scroll` event
  if (flickity._events.scroll === undefined) {
    throw new Error(name + ' requires the first parameter to be a instance of Flickity that supports the `scroll` event (version 2+)');
  }

  // Apply again on resize
  // TODO: debounce this?
  window.addEventListener('resize', function () {
    flickity.slides.forEach(applyTransforms);
  });
}

/**
 * Create scale functions for each transform
 *
 * @return {null}
 */
function createScaleFunctions() {
  transforms.forEach(function (transform) {
    var domain = [];
    var range = [];

    transform.stops.forEach(function (stop) {
      domain.push(stop[0]);
      range.push(stop[1]);
    });

    // Create unique scale function
    transform.scale = function (value) {
      return polylinearScale(domain, range, true)(value);
    };
  });
}

/**
 * Apply transforms to an element
 *
 * @param  {Object} el Flickity element
 * @param  {Integer} i  Element index
 *
 * @return {null}
 */
function applyTransforms(slide, i) {
  var el = cellElements[i];
  var txs = [];
  var xPos = void 0;

  // Get proximity to carousel home
  xPos = slide.parent.x < 0 ? slide.target - Math.abs(slide.parent.x) : slide.target + slide.parent.x;

  // Make transforms
  transforms.forEach(function (transform) {
    txs.push(makeTransform(transform, xPos));
  });

  // Apply transforms
  el.style.transform = txs.join(' ');
}

/**
 * Make an individual transform rule
 *
 * @param  {Object} transform The transform declaration
 * @param  {Number} xPos Element's proximity to carousel home
 * @return {String}
 */
function makeTransform(transform, xPos) {
  var name = transform.name;
  // const unit = units[name] || ''
  var unit = transform.unit || units[name] || '';
  var tx = transform.scale(xPos);

  return name + '(' + tx + unit + ')';
}

module.exports = FlickityTransformer;
},{"polylinear-scale":137}],109:[function(require,module,exports){
// add, remove cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'fizzy-ui-utils/utils'
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  });
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {Element, Array, NodeList} elems
 * @param {Integer} index
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );

  var selectedIndexDelta = index > this.selectedIndex ? 0 : cells.length;
  this._cellAddedRemoved( index, selectedIndexDelta );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {Element, Array, NodeList} elems
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  var selectedIndexDelta = 0;
  var len = cells.length;
  var i, cell;
  // calculate selectedIndexDelta, easier if done in seperate loop
  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    var wasBefore = this.cells.indexOf( cell ) < this.selectedIndex;
    selectedIndexDelta -= wasBefore ? 1 : 0;
  }

  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    cell.remove();
    // remove item from collection
    utils.removeFrom( this.cells, cell );
  }

  if ( cells.length ) {
    // update stuff
    this._cellAddedRemoved( 0, selectedIndexDelta );
  }
};

// updates when cells are added or removed
proto._cellAddedRemoved = function( changedCellIndex, selectedIndexDelta ) {
  // TODO this math isn't perfect with grouped slides
  selectedIndexDelta = selectedIndexDelta || 0;
  this.selectedIndex += selectedIndexDelta;
  this.selectedIndex = Math.max( 0, Math.min( this.slides.length - 1, this.selectedIndex ) );

  this.cellChange( changedCellIndex, true );
  // backwards compatibility
  this.emitEvent( 'cellAddedRemoved', [ changedCellIndex, selectedIndexDelta ] );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSlideableWidth = this.slideableWidth;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  if ( this.options.freeScroll ) {
    // shift x by change in slideableWidth
    // TODO fix position shifts when prepending w/ freeScroll
    var deltaX = prevSlideableWidth - this.slideableWidth;
    this.x += deltaX * this.cellAlign;
    this.positionSlider();
  } else {
    // do not position slider after lazy load
    if ( isPositioningSlider ) {
      this.positionSliderAtSelected();
    }
    this.select( this.selectedIndex );
  }
};

// -----  ----- //

return Flickity;

}));

},{"./flickity":113,"fizzy-ui-utils":107}],110:[function(require,module,exports){
// animate
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'fizzy-ui-utils/utils'
    ], function( utils ) {
      return factory( window, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
      window,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- requestAnimationFrame -------------------------- //

// get rAF, prefixed, if present
var requestAnimationFrame = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame;

// fallback to setTimeout
var lastTime = 0;
if ( !requestAnimationFrame )  {
  requestAnimationFrame = function( callback ) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
    var id = setTimeout( callback, timeToCall );
    lastTime = currTime + timeToCall;
    return id;
  };
}

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    });
  }
};


var transformProperty = ( function () {
  var style = document.documentElement.style;
  if ( typeof style.transform == 'string' ) {
    return 'transform';
  }
  return 'WebkitTransform';
})();

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x = x - this.slideableWidth;
    this.shiftWrapCells( x );
  }

  x = x + this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft && transformProperty ? -x : x;
  var value = this.getPositionValue( x );
  // use 3D tranforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style[ transformProperty ] = this.isAnimating ?
    'translate3d(' + value + ',0,0)' : 'translateX(' + value + ')';

  // scroll event
  var firstSlide = this.slides[0];
  if ( firstSlide ) {
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
  }
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent('settle');
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i=0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i=0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no cells
  if ( this.isPointerDown || this.isFreeScrolling || !this.cells.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

}));

},{"fizzy-ui-utils":107}],111:[function(require,module,exports){
// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'get-size/get-size'
    ], function( getSize ) {
      return factory( window, getSize );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
      window,
      window.getSize
    );
  }

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.x = 0;
  this.shift = 0;
};

proto.destroy = function() {
  // reset style
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var side = this.parent.originSide;
  this.element.style[ side ] = this.parent.getPositionValue( x );
};

/**
 * @param {Integer} factor - 0, 1, or -1
**/
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

}));

},{"get-size":120}],112:[function(require,module,exports){
// drag
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'unidragger/unidragger',
      'fizzy-ui-utils/utils'
    ], function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('unidragger'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window,
      window.Flickity,
      window.Unidragger,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: true,
  dragThreshold: 3,
});

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );

// --------------------------  -------------------------- //

var isTouch = 'createTouch' in document;
var isTouchmoveScrollCanceled = false;

proto._createDrag = function() {
  this.on( 'activate', this.bindDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'childUIPointerDown', this._childUIPointerDownDrag );
  this.on( 'deactivate', this.unbindDrag );
  // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
  // #457, RubaXa/Sortable#973
  if ( isTouch && !isTouchmoveScrollCanceled ) {
    window.addEventListener( 'touchmove', function() {});
    isTouchmoveScrollCanceled = true;
  }
};

proto.bindDrag = function() {
  if ( !this.options.draggable || this.isDragBound ) {
    return;
  }
  this.element.classList.add('is-draggable');
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.isDragBound = true;
};

proto.unbindDrag = function() {
  if ( !this.isDragBound ) {
    return;
  }
  this.element.classList.remove('is-draggable');
  this.unbindHandles();
  delete this.isDragBound;
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

proto._childUIPointerDownDrag = function( event ) {
  event.preventDefault();
  this.pointerDownFocus( event );
};

// -------------------------- pointer events -------------------------- //

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

proto.pointerDown = function( event, pointer ) {
  // dismiss inputs with text fields. #403, #404
  var isCursorInput = cursorNodes[ event.target.nodeName ] &&
    !clickTypes[ event.target.type ];
  if ( isCursorInput ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );

  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur && focused != this.element &&
    // do not blur body for IE9 & 10, #117
    focused != document.body ) {
    focused.blur();
  }
  this.pointerDownFocus( event );
  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // bind move and end events
  this._bindPostStartEvents( event );
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var touchStartEvents = {
  touchstart: true,
  MSPointerDown: true
};

var focusNodes = {
  INPUT: true,
  SELECT: true
};

proto.pointerDownFocus = function( event ) {
  // focus element, if not touch, and its not an input or select
  if ( !this.options.accessibility || touchStartEvents[ event.type ] ||
      focusNodes[ event.target.nodeName ] ) {
    return;
  }
  var prevScrollY = window.pageYOffset;
  this.element.focus();
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or <select>
  var isTouchstart = event.type == 'touchstart';
  var targetNodeName = event.target.nodeName;
  return !isTouchstart && targetNodeName != 'SELECT';
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x
 * @param {Integer} index - slide index
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}

// -----  ----- //

return Flickity;

}));

},{"./flickity":113,"fizzy-ui-utils":107,"unidragger":139}],113:[function(require,module,exports){
// Flickity main
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter',
      'get-size/get-size',
      'fizzy-ui-utils/utils',
      './cell',
      './slide',
      './animate'
    ], function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./cell'),
      require('./slide'),
      require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      _Flickity.Cell,
      _Flickity.Slide,
      _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
  utils, Cell, Slide, animatePrototype ) {

'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');

  var index;
  var initialIndex = this.options.initialIndex;
  if ( this.isInitActivated ) {
    index = this.selectedIndex;
  } else if ( initialIndex !== undefined ) {
    index = this.cells[ initialIndex ] ? initialIndex : 0;
  } else {
    index = 0;
  }
  // select instantly
  this.select( index, false, true );
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i=index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  });
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match(/^(\d+)%$/);
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5
  },
  left: {
    left: 0,
    right: 1
  },
  right: {
    right: 0,
    left: 1
  }
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }

  this.dispatchEvent('select');
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

/**
 * select slide from number or cell element
 * @param {Element or Number} elem
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell;
  if ( typeof value == 'number' ) {
    cell = this.cells[ value ];
  } else {
    // use string as selector
    if ( typeof value == 'string' ) {
      value = this.element.querySelector( value );
    }
    // get cell from element
    cell = this.getCell( value );
  }
  // select slide that has cell
  for ( var i=0; cell && i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      this.select( i, isWrap, isInstant );
      return;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem
 * @returns {Flickity.Cell} item
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i=0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {Element, Array, NodeList} elems
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

/**
 * get parent cell from an element
 * @param {Element} elem
 * @returns {Flickit.Cell} cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

proto.childUIPointerDown = function( event ) {
  this.emitEvent( 'childUIPointerDown', [ event ] );
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  if ( !this.isActive ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  if ( !this.options.accessibility ||
    ( document.activeElement && document.activeElement != this.element ) ) {
    return;
  }

  if ( event.keyCode == 37 ) {
    // go left
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  } else if ( event.keyCode == 39 ) {
    // go right
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  });
  this.unselectSelectedSlide();
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {Element} elem
 * @returns {Flickity}
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;

return Flickity;

}));

},{"./animate":110,"./cell":111,"./slide":119,"ev-emitter":106,"fizzy-ui-utils":107,"get-size":120}],114:[function(require,module,exports){
/*!
 * Flickity v2.0.6
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * http://flickity.metafizzy.co
 * Copyright 2016 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      './drag',
      './prev-next-button',
      './page-dots',
      './player',
      './add-remove-cell',
      './lazyload'
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('./flickity'),
      require('./drag'),
      require('./prev-next-button'),
      require('./page-dots'),
      require('./player'),
      require('./add-remove-cell'),
      require('./lazyload')
    );
  }

})( window, function factory( Flickity ) {
  /*jshint strict: false*/
  return Flickity;
});

},{"./add-remove-cell":109,"./drag":112,"./flickity":113,"./lazyload":115,"./page-dots":116,"./player":117,"./prev-next-button":118}],115:[function(require,module,exports){
// lazyload
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'fizzy-ui-utils/utils'
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  });
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' &&
    cellElem.getAttribute('data-flickity-lazyload') ) {
    return [ cellElem ];
  }
  // select lazy images in cell
  var imgs = cellElem.querySelectorAll('img[data-flickity-lazyload]');
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // load image
  this.img.src = this.img.getAttribute('data-flickity-lazyload');
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

}));

},{"./flickity":113,"fizzy-ui-utils":107}],116:[function(require,module,exports){
// page dots
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'tap-listener/tap-listener',
      'fizzy-ui-utils/utils'
    ], function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = new TapListener();

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.on( 'tap', this.onTap );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.bindTap( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.holder );
  TapListener.prototype.destroy.call( this );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  while ( count ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    fragment.appendChild( dot );
    newDots.push( dot );
    count--;
  }
  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
};

PageDots.prototype.onTap = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true
});

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

}));

},{"./flickity":113,"fizzy-ui-utils":107,"tap-listener":138}],117:[function(require,module,exports){
// player & autoPlay
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter',
      'fizzy-ui-utils/utils',
      './flickity'
    ], function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('ev-emitter'),
      require('fizzy-ui-utils'),
      require('./flickity')
    );
  } else {
    // browser global
    factory(
      window.EvEmitter,
      window.fizzyUIUtils,
      window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Page Visibility -------------------------- //
// https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API

var hiddenProperty, visibilityEvent;
if ( 'hidden' in document ) {
  hiddenProperty = 'hidden';
  visibilityEvent = 'visibilitychange';
} else if ( 'webkitHidden' in document ) {
  hiddenProperty = 'webkitHidden';
  visibilityEvent = 'webkitvisibilitychange';
}

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  if ( visibilityEvent ) {
    this.onVisibilityChange = function() {
      this.visibilityChange();
    }.bind( this );
    this.onVisibilityPlay = function() {
      this.visibilityPlay();
    }.bind( this );
  }
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document[ hiddenProperty ];
  if ( visibilityEvent && isPageHidden ) {
    document.addEventListener( visibilityEvent, this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  if ( visibilityEvent ) {
    document.addEventListener( visibilityEvent, this.onVisibilityChange );
  }
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  if ( visibilityEvent ) {
    document.removeEventListener( visibilityEvent, this.onVisibilityChange );
  }
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document[ hiddenProperty ];
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( visibilityEvent, this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true
});

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

}));

},{"./flickity":113,"ev-emitter":106,"fizzy-ui-utils":107}],118:[function(require,module,exports){
// prev/next buttons
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      './flickity',
      'tap-listener/tap-listener',
      'fizzy-ui-utils/utils'
    ], function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = new TapListener();

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'previous' : 'next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.on( 'tap', this.onTap );
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindTap( this.element );
  // click events from keyboard
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // do regular TapListener destroy
  TapListener.prototype.destroy.call( this );
  // click events from keyboard
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg');
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path');
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.onTap = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  // only allow clicks from keyboard
  var focused = document.activeElement;
  if ( focused && focused == this.element ) {
    this.onTap();
  }
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
});

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

}));

},{"./flickity":113,"fizzy-ui-utils":107,"tap-listener":138}],119:[function(require,module,exports){
// slide
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.changeSelectedClass('add');
};

proto.unselect = function() {
  this.changeSelectedClass('remove');
};

proto.changeSelectedClass = function( method ) {
  this.cells.forEach( function( cell ) {
    cell.element.classList[ method ]('is-selected');
  });
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

return Slide;

}));

},{}],120:[function(require,module,exports){
/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( function() {
      return factory();
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

},{}],121:[function(require,module,exports){
var TEMPLATES;

TEMPLATES = {
  modal: require('../modal.html.mustache')
};

window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        if (iframeLogin != null ? iframeLogin.lazyLoad : void 0) {
          $(window).load(function() {
            return IframeLogin.lazyLoadIframe();
          });
        }
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  getTemplate: function(args) {
    return TEMPLATES.modal.render(args);
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  lazyLoadIframe: function() {
    var ref, url;
    if (!((ref = IframeLogin.$iframe) != null ? ref.length : void 0)) {
      return;
    }
    if ((url = IframeLogin.$iframe.attr('data-src')) && !IframeLogin.$iframe.attr('src')) {
      return IframeLogin.$iframe.attr('src', url);
    }
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref, ref1, ref2;
    if (path == null) {
      path = window.location.href;
    }
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    return (ref = frames[this.iframeName]) != null ? (ref1 = ref.IframeLogin) != null ? (ref2 = ref1.iframeView) != null ? typeof ref2.resetHeight === "function" ? ref2.resetHeight() : void 0 : void 0 : void 0 : void 0;
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  module.exports = IframeLogin;
}



},{"../modal.html.mustache":122}],122:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("authenticated",c,p,1),c,p,1,0,0,"")){t.b("  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">");t.b("\n" + i);t.b("    <div class=\"modal-body\">");t.b("\n" + i);t.b("      <a class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("      <iframe name=\"modal-login\" ");if(t.s(t.f("lazyLoad",c,p,1),c,p,0,200,205,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("data-");});c.pop();}t.b("src=\"");t.b(t.v(t.f("iframeSrc",c,p,0)));t.b("\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{^ authenticated }}\n  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">\n    <div class=\"modal-body\">\n      <a class=\"close-modal icon-x\"></a>\n      <iframe name=\"modal-login\" {{# lazyLoad }}data-{{/ lazyLoad }}src=\"{{ iframeSrc }}\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>\n    </div>\n  </div>\n{{/ authenticated }}\n", Hogan);
},{"hogan.js":133}],123:[function(require,module,exports){
'use strict';
var CL_ARROW_NEXT, CL_ARROW_PREVIOUS, CL_HAS_SCROLL_EV, CollectionCarousel, SEL_ARROWS, SEL_ARROW_NEXT, SEL_ARROW_PREVIOUS, SEL_HAS_SCROLL_EV, SEL_PAN_CONTENTS, SEL_PAN_ELEMENT, SEL_PAN_HOLDER, SEL_SCROLLER, SEL_SUPPORTED_CARDS, _, _activatePanArrows, _closestElementToPan, _containedCardWidth, _cuiContentScrolled, _cuiContentScrolledDebounced, _lazyLoadContainedImages, _lowestMultipleSpanning, _nearestElementToPan, _nearestFullElement, _pageWidth, _panElement, _panLeft, _panRight, _scrollArrowsClicked, _scrollPositionNearestFullCard, _scrollToCard, _self;

_ = require('lodash');

_self = null;

CL_ARROW_NEXT = 'cui-arrow-next';

CL_ARROW_PREVIOUS = 'cui-arrow-previous';

CL_HAS_SCROLL_EV = 'has-scroll-listener';

SEL_HAS_SCROLL_EV = "." + CL_HAS_SCROLL_EV;

SEL_ARROW_NEXT = "." + CL_ARROW_NEXT;

SEL_ARROW_PREVIOUS = "." + CL_ARROW_PREVIOUS;

SEL_ARROWS = SEL_ARROW_NEXT + "," + SEL_ARROW_PREVIOUS;

SEL_SUPPORTED_CARDS = '.cui-c-collection-carousel,.cui-c-compound';

SEL_PAN_HOLDER = '.cui-content-holder';

SEL_PAN_ELEMENT = '.cui-cards-wrapper.carousel';

SEL_PAN_CONTENTS = '.cui-content';

SEL_SCROLLER = SEL_PAN_HOLDER + " > " + SEL_PAN_ELEMENT + " > " + SEL_PAN_CONTENTS;

_nearestElementToPan = function($arrow) {
  return $arrow.siblings(SEL_PAN_ELEMENT).find(SEL_PAN_CONTENTS);
};

_closestElementToPan = function($card) {
  return $card.closest(SEL_PAN_ELEMENT).find(SEL_PAN_CONTENTS);
};

_scrollArrowsClicked = function(ev) {
  var $clickedElm, $panElm;
  $clickedElm = $(this);
  $panElm = _nearestElementToPan($clickedElm);
  if ($clickedElm.hasClass(CL_ARROW_NEXT)) {
    return _panRight($panElm);
  } else if ($clickedElm.hasClass(CL_ARROW_PREVIOUS)) {
    return _panLeft($panElm);
  }
};

_scrollToCard = function($card) {
  var $panElm;
  $panElm = _closestElementToPan($card);
  if ($panElm.length && $card[0]) {
    return _panElement($panElm, $card[0].offsetLeft);
  }
};

_containedCardWidth = function($panElm) {
  return $panElm.find('.card-ui').outerWidth();
};

_lowestMultipleSpanning = function(distance, multiple) {
  var ret;
  ret = Math.floor(distance / multiple) * multiple;
  if (ret < multiple) {
    return multiple;
  }
  return ret;
};

_nearestFullElement = function(currentScroll, itemWidth) {
  var ret;
  ret = currentScroll;
  if (currentScroll && itemWidth) {
    ret = Math.round(currentScroll / itemWidth) * itemWidth;
  }
  return ret;
};

_pageWidth = function($panElm, innerCardWith) {
  var panWidth;
  panWidth = $panElm.width();
  if (innerCardWith) {
    return _lowestMultipleSpanning(panWidth, innerCardWith);
  }
  return panWidth;
};

_scrollPositionNearestFullCard = function($panElm, innerCardWith) {
  var currentScroll;
  currentScroll = $panElm[0].scrollLeft;
  currentScroll = _nearestFullElement(currentScroll, innerCardWith);
  return currentScroll;
};

_panRight = function($panElm) {
  var cardWidth, newScrollLeft;
  cardWidth = _containedCardWidth($panElm);
  newScrollLeft = _scrollPositionNearestFullCard($panElm, cardWidth) + _pageWidth($panElm, cardWidth);
  return _panElement($panElm, newScrollLeft);
};

_panLeft = function($panElm) {
  var cardWidth, newScrollLeft;
  cardWidth = _containedCardWidth($panElm);
  newScrollLeft = _scrollPositionNearestFullCard($panElm, cardWidth) - _pageWidth($panElm, cardWidth);
  return _panElement($panElm, newScrollLeft);
};

_panElement = function($panElm, amt) {
  return $panElm.stop().animate({
    scrollLeft: amt
  }, 400, 'swing', function() {
    return _lazyLoadContainedImages($panElm);
  });
};

_lazyLoadContainedImages = function($panElm) {
  return $panElm.find('.lazy-load').lazyload();
};

_activatePanArrows = function($panElm) {
  var $next, $panHolder, $prev, panElm;
  $panHolder = $panElm.closest(SEL_PAN_HOLDER);
  $next = $panHolder.find(SEL_ARROW_NEXT);
  $prev = $panHolder.find(SEL_ARROW_PREVIOUS);
  panElm = $panElm.closest(SEL_SCROLLER)[0];
  if (panElm.scrollLeft < 1) {
    $prev.hide();
  } else {
    $prev.show();
  }
  if (panElm.scrollLeft >= panElm.scrollWidth - panElm.clientWidth - 1) {
    return $next.hide();
  } else {
    return $next.show();
  }
};

_cuiContentScrolled = function(ev) {
  var $target;
  $target = $(ev.currentTarget);
  _lazyLoadContainedImages($target);
  return _activatePanArrows($target);
};

_cuiContentScrolledDebounced = _.debounce(_cuiContentScrolled, 100);

CollectionCarousel = {
  init: function() {
    _self = this;
    return $(document.body).on('click', SEL_ARROWS, _scrollArrowsClicked);
  },
  initCards: function(context) {
    var $panElms;
    if (context == null) {
      context = 'body';
    }
    $panElms = $(context).find(SEL_SUPPORTED_CARDS).find(SEL_PAN_ELEMENT).find(SEL_PAN_CONTENTS).not(SEL_HAS_SCROLL_EV).on('scroll', _cuiContentScrolledDebounced).addClass(CL_HAS_SCROLL_EV);
    if (context !== 'body') {
      $panElms = $panElms.add($(context).filter(SEL_SCROLLER));
    }
    return _.each($panElms, function(elm) {
      return _activatePanArrows($(elm));
    });
  },
  scrollToCard: _scrollToCard
};

module.exports = CollectionCarousel;

},{"lodash":129}],124:[function(require,module,exports){
'use strict';
var CL_INIT_COMPLETE, CL_INIT_PAGINATION, CollectionCardPaginator, CollectionCarousel, CollectionLoader, SEL_SUPPORTED_CARDS, _copyDataAttributesIfMissing, _paginationCardClicked, _paginationDataLoaded, _paginationProblem, _setupPaginationCards, _updateOffset, _updateRemainingQuantity;

CollectionLoader = require('../../compound/frontend');

CollectionCarousel = require('../../collection-carousel/frontend');

CL_INIT_PAGINATION = 'init-pagination';

CL_INIT_COMPLETE = 'pagination-init-complete';

SEL_SUPPORTED_CARDS = ".card-ui." + CL_INIT_PAGINATION;

_paginationCardClicked = function(ev) {
  var $paginationCard, $resultFragment;
  ev.preventDefault();
  $paginationCard = $(ev.currentTarget);
  $resultFragment = $(document.createDocumentFragment());
  $paginationCard.removeClass('retry').addClass('loading');
  return CollectionLoader.loadCard($paginationCard, $resultFragment, _paginationProblem, _paginationDataLoaded);
};

_paginationProblem = function($paginationCard) {
  return $paginationCard.removeClass('loading').addClass('retry');
};

_paginationDataLoaded = function($paginationCard, $resultFragment, data) {
  var $cardsToAdd;
  $paginationCard.removeClass('loading');
  $cardsToAdd = $(data.cardsHtml);
  $resultFragment.append($cardsToAdd);
  $resultFragment.insertBefore($paginationCard);
  _updateOffset($paginationCard, data, $cardsToAdd);
  CardUI.init($paginationCard.parent());
  return CollectionCarousel.scrollToCard($cardsToAdd);
};

_updateOffset = function($paginationCard, data, $cardsToAdd) {
  var offset, ref, total;
  offset = $paginationCard.data('offset') - 0 || 0;
  offset += $cardsToAdd.length;
  total = ((ref = data.pagination) != null ? ref.count : void 0) || 0;
  $paginationCard.data('offset', offset);
  if (offset >= total) {
    return $paginationCard.remove();
  } else {
    return _updateRemainingQuantity($paginationCard, total - offset);
  }
};

_updateRemainingQuantity = function($paginationCard, remaining) {
  var quantityField, trKey, translationData;
  quantityField = $paginationCard.data('quantity-field');
  translationData = $paginationCard.data('count-i18n');
  if (quantityField && translationData && I18n) {
    trKey = 'cardUiPagination';
    if (!I18n.translations[trKey]) {
      I18n.translations[trKey] = translationData;
    }
    return $paginationCard.find("." + quantityField).text(I18n.pluralize(remaining, trKey));
  } else {
    return $paginationCard.find("." + quantityField).text('');
  }
};

_copyDataAttributesIfMissing = function($source, $dest, attrList) {
  return _.each(attrList, function(attr) {
    return $dest.data(attr, $dest.data(attr) || $source.data(attr) || '');
  });
};

_setupPaginationCards = function($cards) {
  return _.each($cards, function(elm) {
    var $card, $parent;
    $card = $(elm);
    $parent = $card.closest('.cui-c-compound');
    if ($parent.length) {
      _copyDataAttributesIfMissing($parent, $card, ['embed-loader-path', 'embed-permalink', 'show']);
    }
    return $card.on('click', _paginationCardClicked);
  });
};

CollectionCardPaginator = {
  initCards: function(context) {
    var $paginationCards;
    if (context == null) {
      context = 'body';
    }
    $paginationCards = $(context).find(SEL_SUPPORTED_CARDS).removeClass(CL_INIT_PAGINATION).addClass(CL_INIT_COMPLETE);
    return _setupPaginationCards($paginationCards);
  }
};

module.exports = CollectionCardPaginator;

},{"../../collection-carousel/frontend":123,"../../compound/frontend":126}],125:[function(require,module,exports){
'use strict';
var Flickity, FlickityTransformer;

Flickity = require('flickity/js');

FlickityTransformer = require('flickity-transformer');

module.exports = {
  create: function(element, context) {
    var currentIndex, flkty, insideStaticClick, transformer;
    currentIndex = Math.floor($(element).find('.coverflow-cell').length / 2);
    flkty = new Flickity(element, {
      setGallerySize: false,
      pageDots: false,
      percentPosition: true,
      prevNextButtons: false,
      selectedAttraction: 0.01,
      friction: 0.15,
      initialIndex: currentIndex
    });
    transformer = new FlickityTransformer(flkty, this._getTransformerProperties());
    insideStaticClick = false;
    flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
      var currentImage, href;
      insideStaticClick = true;
      if (typeof cellIndex === 'number') {
        flkty.selectCell(cellIndex);
        if (currentIndex === cellIndex) {
          currentImage = $(element).find('.coverflow-cell')[cellIndex];
          href = $(currentImage).attr('href');
          window.location.href = href;
        } else {
          currentIndex = cellIndex;
        }
      }
      return insideStaticClick = false;
    });
    flkty.on('select', function() {
      if (insideStaticClick) {
        return;
      }
      return currentIndex = flkty.selectedIndex;
    });
    return $('.main-coverflow a').click(function(e) {
      return e.preventDefault();
    });
  },
  _getTransformerProperties: function() {
    return [
      {
        name: 'scale',
        stops: [[-300, 0.6], [0, 1], [300, 0.6]]
      }, {
        name: 'translateZ',
        stops: [[-300, 400], [0, 800], [300, 400]]
      }, {
        name: 'perspective',
        stops: [[0, 1000], [1, 1000]]
      }, {
        name: 'rotateY',
        stops: [[-300, 45], [0, 0], [300, -45]]
      }
    ];
  }
};

},{"flickity-transformer":108,"flickity/js":114}],126:[function(require,module,exports){
'use strict';
var CL_COMPOUND_CARD, CL_DEFERRED_LOAD, CL_HAS_VIEWPORT_EV, CompoundCollectionLoader, CoverFlow, SEL_CARD_CONTAINER, SEL_COMPOUND_CARD, SEL_HAS_VIEWPORT_EV, SEL_SUPPORTED_CARDS, ViewportObserver, _buildQueryString, _dataLoaded, _determineUrl, _enteredViewport, _hideCard, _loadCard, _loadPermalink, _requestParams;

ViewportObserver = require('./viewport_observer');

CoverFlow = require('./coverflow');

CL_HAS_VIEWPORT_EV = 'has-viewportenter-listener';

CL_COMPOUND_CARD = 'cui-c-compound';

CL_DEFERRED_LOAD = 'cui-deferred-load';

SEL_HAS_VIEWPORT_EV = "." + CL_HAS_VIEWPORT_EV;

SEL_COMPOUND_CARD = "." + CL_COMPOUND_CARD;

SEL_SUPPORTED_CARDS = SEL_COMPOUND_CARD + "." + CL_DEFERRED_LOAD;

SEL_CARD_CONTAINER = '.cui-content-holder > .cui-cards-wrapper > .cui-content';

_enteredViewport = function(ev) {
  var $container, $parentCard;
  $container = ev.jqTarget;
  $parentCard = $container.closest(SEL_COMPOUND_CARD);
  return _loadCard($parentCard, $container, _hideCard, _dataLoaded);
};

_hideCard = function($card) {
  return $card.css('overflow', 'hidden').stop().animate({
    height: 0
  }, 400, 'swing', function() {
    return $card.hide();
  });
};

_buildQueryString = function(queryMap) {
  var key, urlPath, urlQuery;
  urlQuery = [];
  urlPath = '';
  for (key in queryMap) {
    urlQuery.push(key + '=' + encodeURIComponent(queryMap[key]));
  }
  if (urlQuery.length) {
    urlPath = '?' + urlQuery.join('&');
  }
  return urlPath;
};

_determineUrl = function(base_url, params) {
  return base_url + _buildQueryString(params);
};

_dataLoaded = function($parentCard, $resultContainer, data) {
  $resultContainer.html(data.cardsHtml);
  return CardUI.init($resultContainer);
};

_requestParams = function($card) {
  var query;
  query = {
    card_permalink: $card.data('embed-permalink')
  };
  _.each(['show', 'offset', 'limit'], function(param) {
    var data;
    data = $card.data(param);
    if (data) {
      return query[param] = data;
    }
  });
  return query;
};

_loadCard = function($parentCard, $resultContainer, problemCallback, dataLoadedCallback) {
  var base_url, query;
  base_url = $parentCard.data('embed-loader-path');
  query = _requestParams($parentCard);
  if (base_url && query.card_permalink) {
    return _loadPermalink($parentCard, _determineUrl(base_url, query), problemCallback, function(data) {
      var ref;
      if (data && (data.cards || data.cardsHtml)) {
        if (!data.cardsHtml && data.cards.length) {
          data.cardsHtml = ((ref = window.cardUIRender) != null ? typeof ref.renderCards === "function" ? ref.renderCards(data.cards) : void 0 : void 0) || '';
        }
        if (data.cardsHtml.length) {
          return dataLoadedCallback($parentCard, $resultContainer, data);
        } else {
          return _hideCard($parentCard);
        }
      } else {
        return _hideCard($parentCard);
      }
    });
  } else {
    return _hideCard($parentCard);
  }
};

_loadPermalink = function($parentCard, url, problemCb, successCb) {
  return $.ajax({
    url: url,
    cache: false,
    dataType: 'json',
    timeout: 8000,
    success: function(json) {
      return successCb(json);
    },
    error: function() {
      return problemCb($parentCard);
    }
  });
};

CompoundCollectionLoader = {
  init: function() {
    return ViewportObserver.initialize();
  },
  initCards: function(context) {
    var $resultContainers;
    if (context == null) {
      context = 'body';
    }
    $resultContainers = $(context).find(SEL_SUPPORTED_CARDS).removeClass(CL_DEFERRED_LOAD).find(SEL_CARD_CONTAINER).not(SEL_HAS_VIEWPORT_EV).addClass(CL_HAS_VIEWPORT_EV);
    $(context).find('.main-coverflow').each(function() {
      CoverFlow.create(this);
      return $(context).find('.cui-coverflow-overlay').addClass('loaded');
    });
    return ViewportObserver.watchViewportEnter($resultContainers, _enteredViewport);
  },
  loadCard: _loadCard
};

module.exports = CompoundCollectionLoader;

},{"./coverflow":125,"./viewport_observer":127}],127:[function(require,module,exports){
'use strict';
var ViewportObserver, _, _viewScrolled, _viewScrolledThrottled, _watchViewportEnterElements;

_ = require('lodash');

_watchViewportEnterElements = [];

_viewScrolled = function() {
  var $win, ScrRight, scrBottom, scrLeft, scrTop, vpHeight, vpWidth;
  $win = $(window);
  vpWidth = $win.width();
  vpHeight = $win.height();
  scrTop = $win.scrollTop();
  scrLeft = $win.scrollLeft();
  scrBottom = scrTop + vpHeight;
  ScrRight = scrTop + vpWidth;
  return _watchViewportEnterElements = _.filter(_watchViewportEnterElements, function(elmObj) {
    var $elm, btmY, leftX, offset, rightX, topY;
    $elm = $(elmObj.element);
    offset = $elm.offset();
    topY = offset.top;
    btmY = topY + $elm.outerHeight();
    if (btmY < scrTop || topY > scrBottom) {
      return true;
    }
    leftX = offset.left;
    rightX = leftX + $elm.outerWidth();
    if (rightX < scrLeft || leftX > ScrRight) {
      return true;
    }
    elmObj.callback({
      target: elmObj.element,
      jqTarget: $elm
    });
    return !elmObj.onceOnly;
  });
};

_viewScrolledThrottled = _.throttle(_viewScrolled, 100);

ViewportObserver = {
  initialize: function() {
    $(window).on('scroll', _viewScrolledThrottled);
    return this.initialize = function() {};
  },
  watchViewportEnter: function($elements, eventCallback, onceOnly) {
    var $elementObjs;
    if (onceOnly == null) {
      onceOnly = true;
    }
    $elementObjs = _.map($elements, function(elm) {
      return {
        element: elm,
        callback: eventCallback,
        onceOnly: onceOnly
      };
    });
    _watchViewportEnterElements = _watchViewportEnterElements.concat($elementObjs);
    return _viewScrolledThrottled();
  }
};

module.exports = window.ViewportObserver = ViewportObserver;

},{"lodash":129}],128:[function(require,module,exports){
'use strict';
var CollectionCardPaginator, CollectionCarousel, CompoundCollectionLoader, _hasFirstInit;

CollectionCarousel = require('../card/collection-carousel/frontend');

CompoundCollectionLoader = require('../card/compound/frontend');

CollectionCardPaginator = require('../card/collection/frontend');

_hasFirstInit = false;

module.exports = window.CardUI = {
  init: function(context) {
    if (context == null) {
      context = 'body';
    }
    this._initCards(context);
    this._initImages(context);
    return this._oneTimeInit();
  },
  _initCards: function(context) {
    var ref;
    CollectionCarousel.initCards(context);
    CompoundCollectionLoader.initCards(context);
    CollectionCardPaginator.initCards(context);
    if (typeof GIG !== "undefined" && GIG !== null) {
      GIG.Utils.truncateElements();
    }
    return typeof GIG !== "undefined" && GIG !== null ? (ref = GIG.Tooltip) != null ? ref.reloadBindings() : void 0 : void 0;
  },
  _initImages: function(context) {
    $(window).off('load.cardui-images');
    $(window).off('resize.cardui-images');
    $(window).on('resize.cardui-images', _.debounce(((function(_this) {
      return function() {
        return _this._loadImages(context);
      };
    })(this)), 100));
    if (document.readyState === 'complete') {
      return this._loadImages(context);
    } else {
      return $(window).on('load.cardui-images', (function(_this) {
        return function() {
          return _this._loadImages(context);
        };
      })(this));
    }
  },
  _oneTimeInit: function() {
    if (_hasFirstInit) {
      return;
    }
    CollectionCarousel.init();
    CompoundCollectionLoader.init();
    return _hasFirstInit = true;
  },
  _loadImages: function(context) {
    var lazyLoadAfterPageLoaded, progressiveLoadImages, ref, ref1;
    if (context == null) {
      context = 'body';
    }
    progressiveLoadImages = $(context).find('.cui-image.progressive-load').length > 0;
    lazyLoadAfterPageLoaded = $(context).find('.cui-image.lazy-wl').length > 0;
    if ((ref = Groupon.Utils) != null) {
      ref.lazyLoadImages();
    }
    if (lazyLoadAfterPageLoaded) {
      if ((ref1 = Groupon.Utils) != null) {
        ref1.lazyLoadImages({
          threshold: 200
        }, '.lazy-wl');
      }
    }
    if (!progressiveLoadImages) {
      return this.replaceLowQualityImages();
    }
  },
  replaceLowQualityImages: function() {
    var el, els, highQualitySrc, i, len;
    els = $('img[data-original][data-high-quality]:not(.is-lazyloaded), a.lazy-load[data-original][data-high-quality]:not(.is-lazyloaded)');
    for (i = 0, len = els.length; i < len; i++) {
      el = els[i];
      if (!(window.devicePixelRatio > 1 && (highQualitySrc = el.getAttribute('data-high-quality-2x')))) {
        highQualitySrc = el.getAttribute('data-high-quality');
      }
      if (el.nodeName === 'IMG') {
        if (el.getAttribute('src') === el.getAttribute('data-original')) {
          el.setAttribute('src', highQualitySrc);
        } else {
          el.setAttribute('data-original', highQualitySrc);
        }
      } else {
        el.setAttribute('data-original', highQualitySrc);
      }
      $(el).addClass('is-lazyloaded');
    }
  }
};

},{"../card/collection-carousel/frontend":123,"../card/collection/frontend":124,"../card/compound/frontend":126}],129:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],130:[function(require,module,exports){
'use strict';

var SCREEN_READER_CSS = '.sr-only{border: 0; clip: rect(0, 0, 0, 0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; width: 1px;}';

var A11yUtility = function (options) {
  if (options === undefined) {
    options = {};
  }
  var selectorScope = options.scope;
  if (selectorScope === undefined) {
    selectorScope = 'body';
  }
  this.$elements = $(selectorScope);

  this.loggingEnabled = !!options.logging;

  this.addStylesToHead();
  return this;
};

A11yUtility.prototype.addStylesToHead = function () {
  $('head').append('<style type="text/css">' + SCREEN_READER_CSS + '</style>');
};

A11yUtility.prototype.getContextualText = function ($target) {
  if ($target.length === 0) {
    return undefined;
  }

  // try to do an educated guess of the contextual text for the element
  try {
    return $.trim($target.attr('title')) ||
           $.trim($target.data('originalTitle')) ||
           $.trim($target.closest('a').attr('title')) ||
           $.trim($target.closest('a').text()) ||
           $.trim($target.prev().children().length ?
             $($target.prev().children()[0]).text() : $target.prev().text()) ||
           $.trim($target.next().children().length ?
             $($target.next().children()[0]).text() : $target.next().text()) ||
           $.trim($target.parent().prev().children().length ?
             $($target.parent().prev().children()[0]).text() : $target.parent().prev().text()) ||
           $.trim($target.parent().next().children().length ?
             $($target.parent().next().children()[0]).text() : $target.parent().next().text()) ||
           ($.trim($target.attr('class')) ? $.trim($target.attr('class')).replace(/\s/g, ', ').replace(/[-_]/g, ' ') : undefined) ||
           ($target.attr('src') ? $target.attr('src').replace(/.*\/|\..*$/g, '') : undefined) ||
           '';
  } catch (e) {
    console.error(e.message); // eslint-disable-line
    return undefined;
  }
};

A11yUtility.prototype.fixImages = function () {
  // images without alt attribute
  var self = this;
  this.$elements.find('img:not([alt])')
    .each(function () {
      // bad idea to use contextual text of the image as the alt text
      // better to fallback to empty alt instead
      var $this = $(this);
      $this.attr('alt', '');
      if (self.loggingEnabled) {
        console.warn("FIX-A11Y: Image is missing 'alt' attr: "); // eslint-disable-line
        console.warn($this); // eslint-disable-line
      }
    });
};

A11yUtility.prototype.fixLinks = function () {
  // empty links
  var self = this;
  this.$elements.find('a:not([aria-label])')
    .filter(function () { return $.trim($(this).text()) === ''; })
    .each(function () {
      var $this = $(this);
      var text = self.getContextualText($this) || $.trim($.trim($this.attr('href')) && $this.attr('href').replace(/[-_/:]/g, ' ').replace(/^https*/g, ''));
      // found context for the link
      if (text !== undefined && text.length) {
        var span = document.createElement('span');
        span.className = 'sr-only';
        span.innerText = text;
        this.appendChild(span);
      } else {
        // can't get contextual text for the link
        // try to get the contextual alt text for any images without alt attribute
        $this.find('img:not([alt]), img[alt=""]')
          .each(function () {
            $(this).attr('alt', self.getContextualText($(this)));
          });
      }
      if (self.loggingEnabled) {
        console.warn('FIX-A11Y: Link is missing explanatory text: '); // eslint-disable-line
        console.warn($this); // eslint-disable-line
      }
    });
};

A11yUtility.prototype.fixForms = function () {
  // form fields without labels
  var self = this;
  this.$elements.find('textarea, input, select')
    .filter(function () {
      var $this = $(this);
      var accessibilityAttrs = ['title', 'aria-label', 'aria-labelledby'];
      for (var i = 0; i < accessibilityAttrs.length; i += 1) {
        var attr = $this.attr(accessibilityAttrs[i]);
        if (attr !== undefined && attr.length > 0) {
          return false;
        }
      }
      return true;
    })
    .each(function () {
      var $this = $(this);
      var text = $.trim($this.attr('placeholder') || self.getContextualText($this));
      // found context for the form element
      if (text !== undefined && text.length) {
        $this.attr('title', text);

        if (self.loggingEnabled) {
          console.warn("FIX-A11Y: Form element is missing 'title' attr: "); // eslint-disable-line
          console.warn($this); // eslint-disable-line
        }
      }
    });
};

A11yUtility.prototype.init = function () {
  this.fixImages();
  this.fixLinks();
  this.fixForms();
};

module.exports = A11yUtility;

},{}],131:[function(require,module,exports){
'use strict';

var A11yUtility = require('./grpn-fix-a11y');

module.exports = function (options) {
  var a11yTool = new A11yUtility(options);
  $(window).load(function () {
    setTimeout(function () {
      a11yTool.init();
    }, 500);
  });
  $(document).ajaxSuccess(function () {
    setTimeout(function () {
      a11yTool.init();
    }, 500);
  });
  return a11yTool;
};

},{"./grpn-fix-a11y":130}],132:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],133:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":132,"./template":134}],134:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],135:[function(require,module,exports){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var MagicEventBus;
  MagicEventBus = function () {
    function MagicEventBus() {
      this.handlers = {};
      this.statuses = {};
    }
    MagicEventBus.prototype.board = function (eventName, callback, errorHandler) {
      var position;
      if (null != this.handlers[eventName])
        this.handlers[eventName];
      else
        this.handlers[eventName] = [];
      position = this._pushHandler(eventName, callback, errorHandler);
      return function (this$) {
        return function (zIndex) {
          return this$.handlers[eventName][position].zIndex = zIndex;
        };
      }(this);
    };
    MagicEventBus.prototype.go = function (eventName, eventElement) {
      var handler, sortedHandlers;
      if (!(null != this.handlers[eventName]))
        return false;
      this.statuses[eventName] = 'going';
      sortedHandlers = this.handlers[eventName].slice().sort(function (a, b) {
        return (a.zIndex || 0) - (b.zIndex || 0);
      });
      for (var i$ = 0, length$ = sortedHandlers.length; i$ < length$; ++i$) {
        handler = sortedHandlers[i$];
        if (this.statuses[eventName] === 'stopTheBus')
          break;
        this._callback(eventName, handler, eventElement);
      }
      return this.statuses[eventName] = 'stopped';
    };
    MagicEventBus.prototype._callback = function (eventName, param$, eventElement) {
      var cache$, callback, errorHandler, results;
      {
        cache$ = param$;
        callback = cache$.callback;
        errorHandler = cache$.errorHandler;
      }
      results = function () {
        var error;
        try {
          return callback(eventElement);
        } catch (e$) {
          error = e$;
          if ('undefined' !== typeof TrackingHub && null != TrackingHub)
            TrackingHub.add('MagicEventBus ' + eventName + ' Error', { error: error });
          if ('function' === typeof errorHandler)
            return errorHandler();
        }
      }.call(this);
      if (null != results ? results.stopTheBus : void 0)
        return this.statuses[eventName] = 'stopTheBus';
    };
    MagicEventBus.prototype._pushHandler = function (eventName, callback, errorHandler) {
      this.handlers[eventName].push({
        callback: callback,
        errorHandler: errorHandler
      });
      return this.handlers[eventName].length - 1;
    };
    return MagicEventBus;
  }();
  if ('undefined' !== typeof window && null != window)
    window.MagicEventBus = MagicEventBus;
  if ('undefined' !== typeof module && null != module)
    module.exports = MagicEventBus;
}.call(this);

},{}],136:[function(require,module,exports){
//! moment.js
//! version : 2.11.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')$', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')$', 'i');
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             if (this.isValid() && other.isValid()) {
                 return other < this ? this : other;
             } else {
                 return valid__createInvalid();
             }
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this > +localInput;
        } else {
            return +localInput < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this < +localInput;
        } else {
            return +this.clone().endOf(units) < +localInput;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return +this === +localInput;
        } else {
            inputMs = +localInput;
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // JSON.stringify(new Date(NaN)) === 'null'
        return this.isValid() ? this.toISOString() : 'null';
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        // console.log("got", weekYear, week, weekday, "set", date.toISOString());
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = local__createLocal([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = getSet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = getSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto._months           = defaultLocaleMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto._monthsRegex      = defaultMonthsRegex;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.11.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],137:[function(require,module,exports){
var config = {}

/**
 * The compiled scale to return
 *
 * @param  {Number} value The number to scale
 * @return {Number}       The result
 */
function scale (value) {
  const domains = config.domain
  const ranges = config.range
  var rangeMin
  var rangeMax
  var domain
  var range
  var ratio
  var result
  var i = 0

  /* eslint-disable no-sequences */
  while (i < domains.length - 1) {
    if (value >= domains[i] && value <= domains[i + 1]) {
      domain = [domains[i], domains[i + 1]],
      range = [ranges[i], ranges[i + 1]]
      break
    }
    i++
  }

  // Value is outside given domain
  if (domain === undefined) {
    if (value < domains[0]) {
      domain = [domains[0], domains[1]]
      range = [ranges[0], ranges[1]]
    } else {
      domain = [domains[domains.length - 2], domains[domains.length - 1]]
      range = [ranges[ranges.length - 2], ranges[ranges.length - 1]]
    }
  }

  ratio = (range[1] - range[0]) / (domain[1] - domain[0])
  result = range[0] + ratio * (value - domain[0])

  if (config.clamp) {
    rangeMin = Math.min(range[0], range[1])
    rangeMax = Math.max(range[0], range[1])
    result = Math.min(rangeMax, Math.max(rangeMin, result))
  }

  return result
}

/**
 * A polylinear scale
 *
 * Supports multiple piecewise linear scales that divide a continuous domain and range.
 *
 * @param  {Array} domain     Two or more numbers
 * @param  {Array} range      Numbers equivalent to number in `domain`
 * @param  {Boolean} clamp    Enables or disables clamping
 * @return {Function}         Scale function
 */
function polylinearScale (domain, range, clamp) {
  domain = domain || [0, 1]
  range = range || [0, 1]
  clamp = clamp || false

  if (domain.length !== range.length) {
    throw new Error('polylinearScale requires domain and range to have an equivalent number of values')
  }

  config.domain = domain
  config.range = range
  config.clamp = clamp

  return scale
}

module.exports = polylinearScale

},{}],138:[function(require,module,exports){
/*!
 * Tap listener v2.0.0
 * listens to taps
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false*/ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.TapListener = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// --------------------------  TapListener -------------------------- //

function TapListener( elem ) {
  this.bindTap( elem );
}

// inherit Unipointer & EventEmitter
var proto = TapListener.prototype = Object.create( Unipointer.prototype );

/**
 * bind tap event to element
 * @param {Element} elem
 */
proto.bindTap = function( elem ) {
  if ( !elem ) {
    return;
  }
  this.unbindTap();
  this.tapElement = elem;
  this._bindStartEvent( elem, true );
};

proto.unbindTap = function() {
  if ( !this.tapElement ) {
    return;
  }
  this._bindStartEvent( this.tapElement, true );
  delete this.tapElement;
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  var pointerPoint = Unipointer.getPointerPoint( pointer );
  var boundingRect = this.tapElement.getBoundingClientRect();
  var scrollX = window.pageXOffset;
  var scrollY = window.pageYOffset;
  // calculate if pointer is inside tapElement
  var isInside = pointerPoint.x >= boundingRect.left + scrollX &&
    pointerPoint.x <= boundingRect.right + scrollX &&
    pointerPoint.y >= boundingRect.top + scrollY &&
    pointerPoint.y <= boundingRect.bottom + scrollY;
  // trigger callback if pointer is inside element
  if ( isInside ) {
    this.emitEvent( 'tap', [ event, pointer ] );
  }

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    var _this = this;
    setTimeout( function() {
      delete _this.isIgnoringMouseUp;
    }, 400 );
  }
};

proto.destroy = function() {
  this.pointerDone();
  this.unbindTap();
};

// -----  ----- //

return TapListener;

}));

},{"unipointer":140}],139:[function(require,module,exports){
/*!
 * Unidragger v2.2.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -----  ----- //

function noop() {}

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

var navigator = window.navigator;
/**
 * works as unbinder, as you can .bindHandles( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindHandles = function( isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  // disable scrolling via touch
  var touchActionValue = isBind ? 'none' : '';
  // bind each handle
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isBind );
    handle.style.touchAction = touchActionValue;
    handle[ bindMethod ]( 'click', this );
  }
};

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  // dismiss range sliders
  if ( event.target.nodeName == 'INPUT' && event.target.type == 'range' ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );
  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur ) {
    focused.blur();
  }
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// base pointer down logic
proto._dragPointerDown = function( event, pointer ) {
  // track to see when dragging starts
  this.pointerDownPoint = Unipointer.getPointerPoint( pointer );

  var canPreventDefault = this.canPreventDefaultOnPointerDown( event, pointer );
  if ( canPreventDefault ) {
    event.preventDefault();
  }
};

// overwriteable method so Flickity can prevent for scrolling
proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or <select>
  return event.target.nodeName != 'SELECT';
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var movePoint = Unipointer.getPointerPoint( pointer );
  var moveVector = {
    x: movePoint.x - this.pointerDownPoint.x,
    y: movePoint.y - this.pointerDownPoint.y
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};


// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  this.dragStartPoint = Unipointer.getPointerPoint( pointer );
  // prevent clicks
  this.isPreventingClicks = true;

  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  // allow click in <input>s and <textarea>s
  var nodeName = event.target.nodeName;
  if ( nodeName == 'INPUT' || nodeName == 'TEXTAREA' ) {
    event.target.focus();
  }
  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));

},{"unipointer":140}],140:[function(require,module,exports){
/*!
 * Unipointer v2.2.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * works as unbinder, as you can ._bindStart( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindStartEvent = function( elem, isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';

  if ( window.PointerEvent ) {
    // Pointer Events. Chrome 55, IE11, Edge 14
    elem[ bindMethod ]( 'pointerdown', this );
  } else {
    // listen for both, for devices like Chrome Pixel
    elem[ bindMethod ]( 'mousedown', this );
    elem[ bindMethod ]( 'touchstart', this );
  }
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss other pointers
  if ( this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
  // remove events
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));

},{"ev-emitter":106}]},{},[2])

